/*
*	Services JBR
*/

/* Transition End constant */
var TRANSITION_END = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";

/* Generate a random password */
function generatePassword() {
  var length = Math.round(Math.random() * 8) + 8,
  charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

/* Stronger parseFloat */
function asFloat(value) {
  if (value === '') {
    value = 0
  }
  if (value == undefined){
    value = 0;
  }
  return parseFloat(value.toString().replace(/\s/g,'').replace(',','.'));
}

/* Option de menu déroulant: nom, puis compagnie à côté, en petit et en pâle.
   Dans une boîte trop étroite, la compagnie passe en entier sous le nom. */
function optionWithCompany(state) {
  if (!state.element) {
    return state.text;
  }
  var company = $(state.element).data("company");
  if (!company) {
    return state.text;
  }
  return $("<span></span>").append(
    $("<span></span>").addClass("mr-2").text(state.text),
    $("<span></span>").addClass("d-inline-block small text-muted").text(company)
  );
}

/* Paramètres Select2 qui affichent la compagnie à côté du nom */
function select2WithCompany(options) {
  options = options || {};
  options.templateResult = optionWithCompany;
  options.templateSelection = optionWithCompany;
  return options;
}

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/*! formstone v1.4.22 [core.js] 2021-10-01 | GPL-3.0 License | formstone.it */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(w){"use strict";function e(){this.Version="1.4.22",this.Plugins={},this.DontConflict=!1,this.Conflicts={fn:{}},this.ResizeHandlers=[],this.RAFHandlers=[],this.window=i,this.$window=w(i),this.document=r,this.$document=w(r),this.$body=null,this.windowWidth=0,this.windowHeight=0,this.fallbackWidth=1024,this.fallbackHeight=768,this.userAgent=window.navigator.userAgent||window.navigator.vendor||window.opera,this.isFirefox=/Firefox/i.test(this.userAgent),this.isChrome=/Chrome/i.test(this.userAgent),this.isSafari=/Safari/i.test(this.userAgent)&&!this.isChrome,this.isMobile=/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(this.userAgent),this.isIEMobile=/IEMobile/i.test(this.userAgent),this.isFirefoxMobile=this.isFirefox&&this.isMobile,this.transform=null,this.transition=null,this.support={file:!!(window.File&&window.FileList&&window.FileReader),history:!!(window.history&&window.history.pushState&&window.history.replaceState),matchMedia:!(!window.matchMedia&&!window.msMatchMedia),pointer:!!window.PointerEvent,raf:!(!window.requestAnimationFrame||!window.cancelAnimationFrame),touch:!!("ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),transition:!1,transform:!1}}var t,n,s,i="undefined"!=typeof window?window:this,r=i.document,o={killEvent:function(e,t){try{e.preventDefault(),e.stopPropagation(),t&&e.stopImmediatePropagation()}catch(e){}},killGesture:function(e){try{e.preventDefault()}catch(e){}},lockViewport:function(e){h[e]=!0,w.isEmptyObject(h)||p||(t.length?t.attr("content",s):t=w("head").append('<meta name="viewport" content="'+s+'">'),c.$body.on(u.gestureChange,o.killGesture).on(u.gestureStart,o.killGesture).on(u.gestureEnd,o.killGesture),p=!0)},unlockViewport:function(e){void 0!==h[e]&&delete h[e],w.isEmptyObject(h)&&p&&(t.length&&(n?t.attr("content",n):t.remove()),c.$body.off(u.gestureChange).off(u.gestureStart).off(u.gestureEnd),p=!1)},startTimer:function(e,t,n,s){return o.clearTimer(e),s?setInterval(n,t):setTimeout(n,t)},clearTimer:function(e,t){e&&(t?clearInterval(e):clearTimeout(e),e=null)},sortAsc:function(e,t){return parseInt(e,10)-parseInt(t,10)},sortDesc:function(e,t){return parseInt(t,10)-parseInt(e,10)},decodeEntities:function(e){var t=c.document.createElement("textarea");return t.innerHTML=e,t.value},parseQueryString:function(e){for(var t={},n=e.slice(e.indexOf("?")+1).split("&"),s=0;s<n.length;s++){var i=n[s].split("=");t[i[0]]=i[1]}return t}},c=new e,a=w.Deferred(),l={base:"{ns}",element:"{ns}-element"},u={namespace:".{ns}",beforeUnload:"beforeunload.{ns}",blur:"blur.{ns}",change:"change.{ns}",click:"click.{ns}",dblClick:"dblclick.{ns}",drag:"drag.{ns}",dragEnd:"dragend.{ns}",dragEnter:"dragenter.{ns}",dragLeave:"dragleave.{ns}",dragOver:"dragover.{ns}",dragStart:"dragstart.{ns}",drop:"drop.{ns}",error:"error.{ns}",focus:"focus.{ns}",focusIn:"focusin.{ns}",focusOut:"focusout.{ns}",gestureChange:"gesturechange.{ns}",gestureStart:"gesturestart.{ns}",gestureEnd:"gestureend.{ns}",input:"input.{ns}",keyDown:"keydown.{ns}",keyPress:"keypress.{ns}",keyUp:"keyup.{ns}",load:"load.{ns}",mouseDown:"mousedown.{ns}",mouseEnter:"mouseenter.{ns}",mouseLeave:"mouseleave.{ns}",mouseMove:"mousemove.{ns}",mouseOut:"mouseout.{ns}",mouseOver:"mouseover.{ns}",mouseUp:"mouseup.{ns}",panStart:"panstart.{ns}",pan:"pan.{ns}",panEnd:"panend.{ns}",resize:"resize.{ns}",scaleStart:"scalestart.{ns}",scaleEnd:"scaleend.{ns}",scale:"scale.{ns}",scroll:"scroll.{ns}",select:"select.{ns}",swipe:"swipe.{ns}",touchCancel:"touchcancel.{ns}",touchEnd:"touchend.{ns}",touchLeave:"touchleave.{ns}",touchMove:"touchmove.{ns}",touchStart:"touchstart.{ns}"},d=null,f=20,h=[],p=!1;function m(e,t,n,s){var i,r={raw:{}};for(i in s=s||{})s.hasOwnProperty(i)&&("classes"===e?(r.raw[s[i]]=t+"-"+s[i],r[s[i]]="."+t+"-"+s[i]):(r.raw[i]=s[i],r[i]=s[i]+"."+t));for(i in n)n.hasOwnProperty(i)&&("classes"===e?(r.raw[i]=n[i].replace(/{ns}/g,t),r[i]=n[i].replace(/{ns}/g,"."+t)):(r.raw[i]=n[i].replace(/.{ns}/g,""),r[i]=n[i].replace(/{ns}/g,t)));return r}function g(){c.windowWidth=c.$window.width(),c.windowHeight=c.$window.height(),d=o.startTimer(d,f,y)}function y(){for(var e in c.ResizeHandlers)c.ResizeHandlers.hasOwnProperty(e)&&c.ResizeHandlers[e].callback.call(window,c.windowWidth,c.windowHeight)}function v(e,t){return parseInt(e.priority)-parseInt(t.priority)}return e.prototype.NoConflict=function(){for(var e in c.DontConflict=!0,c.Plugins)c.Plugins.hasOwnProperty(e)&&(w[e]=c.Conflicts[e],w.fn[e]=c.Conflicts.fn[e])},e.prototype.Ready=function(e){"complete"===c.document.readyState||"loading"!==c.document.readyState&&!c.document.documentElement.doScroll?e():c.document.addEventListener("DOMContentLoaded",e)},e.prototype.Plugin=function(e,t){function d(e){return e.data(p)}var f,h,n,p;return c.Plugins[e]=(h=t,n="fs-"+(f=e),p="fs"+f.replace(/(^|\s)([a-z])/g,function(e,t,n){return t+n.toUpperCase()}),h.initialized=!1,h.priority=h.priority||10,h.classes=m("classes",n,l,h.classes),h.events=m("events",f,u,h.events),h.functions=w.extend({getData:d,iterate:function(e){for(var t=Array.prototype.slice.call(arguments,1),n=0,s=this.length;n<s;n++){var i=this.eq(n),r=d(i)||{};void 0!==r.$el&&e.apply(i,[r].concat(t))}return this}},o,h.functions),h.methods=w.extend(!0,{_construct:w.noop,_postConstruct:w.noop,_destruct:w.noop,_resize:!1,destroy:function(e){h.functions.iterate.apply(this,[h.methods._destruct].concat(Array.prototype.slice.call(arguments,1))),this.removeClass(h.classes.raw.element).removeData(p)}},h.methods),h.utilities=w.extend(!0,{_initialize:!1,_delegate:!1,defaults:function(e){h.defaults=w.extend(!0,h.defaults,e||{})}},h.utilities),h.widget&&(c.Conflicts.fn[f]=w.fn[f],w.fn[p]=function(e){if(this instanceof w){var t=h.methods[e];if("object"==typeof e||!e)return function(e){var t,n,s,i="object"==typeof e,r=Array.prototype.slice.call(arguments,i?1:0),o=w();for(e=w.extend(!0,{},h.defaults||{},i?e:{}),n=0,s=this.length;n<s;n++)if(!d(t=this.eq(n))){h.guid++;var a="__"+h.guid,c=h.classes.raw.base+a,l=t.data(f+"-options"),u=w.extend(!0,{$el:t,guid:a,numGuid:h.guid,rawGuid:c,dotGuid:"."+c},e,"object"==typeof l?l:{});t.addClass(h.classes.raw.element).data(p,u),h.methods._construct.apply(t,[u].concat(r)),o=o.add(t)}for(n=0,s=o.length;n<s;n++)t=o.eq(n),h.methods._postConstruct.apply(t,[d(t)]);return this}.apply(this,arguments);if(t&&0!==e.indexOf("_")){var n=[t].concat(Array.prototype.slice.call(arguments,1));return h.functions.iterate.apply(this,n)}return this}},c.DontConflict||(w.fn[f]=w.fn[p])),c.Conflicts[f]=w[f],w[p]=h.utilities._delegate||function(e){var t=h.utilities[e]||h.utilities._initialize||!1;if(t){var n=Array.prototype.slice.call(arguments,"object"==typeof e?0:1);return t.apply(window,n)}},c.DontConflict||(w[f]=w[p]),h.namespace=f,h.namespaceClean=p,h.guid=0,h.methods._resize&&(c.ResizeHandlers.push({namespace:f,priority:h.priority,callback:h.methods._resize}),c.ResizeHandlers.sort(v)),h.methods._raf&&(c.RAFHandlers.push({namespace:f,priority:h.priority,callback:h.methods._raf}),c.RAFHandlers.sort(v)),h),c.Plugins[e]},c.$window.on("resize.fs",g),g(),function e(){if(c.support.raf)for(var t in c.window.requestAnimationFrame(e),c.RAFHandlers)c.RAFHandlers.hasOwnProperty(t)&&c.RAFHandlers[t].callback.call(window)}(),c.Ready(function(){c.$body=w("body"),w("html").addClass(c.support.touch?"touchevents":"no-touchevents"),t=w('meta[name="viewport"]'),n=!!t.length&&t.attr("content"),s="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",a.resolve()}),u.clickTouchStart=u.click+" "+u.touchStart,function(){var e,t={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"otransitionend",transition:"transitionend"},n=["transition","-webkit-transition"],s={transform:"transform",MozTransform:"-moz-transform",OTransform:"-o-transform",msTransform:"-ms-transform",webkitTransform:"-webkit-transform"},i="transitionend",r="",o="",a=document.createElement("div");for(e in t)if(t.hasOwnProperty(e)&&e in a.style){i=t[e],c.support.transition=!0;break}for(e in u.transitionEnd=i+".{ns}",n)if(n.hasOwnProperty(e)&&n[e]in a.style){r=n[e];break}for(e in c.transition=r,s)if(s.hasOwnProperty(e)&&s[e]in a.style){c.support.transform=!0,o=s[e];break}c.transform=o}(),window.Formstone=c});
/*! formstone v1.4.22 [upload.js] 2021-10-01 | GPL-3.0 License | formstone.it */
!function(e){"function"==typeof define&&define.amd?define(["jquery","./core"],e):e(jQuery,Formstone)}(function(u,r){"use strict";function s(e,t,a){t.error=!0,e.$el.trigger($.fileError,[t,a]),e.aborting||v(e)}function a(e){e.disabled&&(this.removeClass(C.disabled),e.$input.prop("disabled",!1),e.disabled=!1)}function n(e){y.killEvent(e);var t=e.data;t.disabled||t.$input.trigger($.click)}function i(e){e.data.$el.addClass(C.focus)}function l(e){e.data.$el.removeClass(C.focus)}function o(e){y.killEvent(e);var t=e.data,a=t.$input[0].files;!t.disabled&&a.length&&g(t,a)}function c(e){y.killEvent(e),e.data.$el.addClass(C.dropping).trigger($.fileDragEnter)}function d(e){y.killEvent(e),e.data.$el.addClass(C.dropping).trigger($.fileDragOver)}function f(e){y.killEvent(e),e.data.$el.removeClass(C.dropping).trigger($.fileDragLeave)}function p(e){y.killEvent(e);var t=e.data,a=e.originalEvent.dataTransfer.files;t.$el.removeClass(C.dropping),t.disabled||g(t,a)}function g(e,t){var a=[],r=t.length;if(e.maxFiles){var n=e.maxFiles-e.uploaded;0<=n&&t.length>n&&(r=n)}if(0<r){for(var i=0;i<r;i++){var l={index:e.total++,file:t[i],name:t[i].name,size:t[i].size,started:!1,complete:!1,error:!1,transfer:null};a.push(l),e.queue.push(l)}e.$el.trigger($.queued,[a]),e.autoUpload&&h(e)}e.$input.val("")}function h(e){e.uploading||(S.on($.beforeUnload,function(){return e.leave}),e.uploading=!0,e.$el.trigger($.start,[e.queue])),v(e)}function v(e){var t=0,a=[];if(e.uploading){for(var r in e.queue)!e.queue.hasOwnProperty(r)||e.queue[r].complete||e.queue[r].error||a.push(e.queue[r]);for(var n in e.queue=a,e.queue)if(e.queue.hasOwnProperty(n)){if(e.queue[n].started||m(e,e.queue[n]),++t>=e.maxConcurrent)return;r++}0===t&&(S.off($.beforeUnload),e.uploading=!1,e.$el.trigger($.complete))}}function m(n,i){if(i.size>=n.maxSize||!0===i.error)s(n,i,"size");else if(n.chunked)i.started=!0,i.chunkSize=1024*n.chunkSize,i.totalChunks=Math.ceil(i.size/i.chunkSize),i.currentChunk=0,n.$el.trigger($.fileStart,[i]),function n(l,o){var e=o.chunkSize*o.currentChunk,t=e+o.chunkSize;t>o.size&&(t=o.size);var a=o.file[q](e,t),r=new FormData;r.append(l.postKey,a,o.file.name);r.append("chunks",o.totalChunks);r.append("chunk",o.currentChunk);r=k(l,r,o);!1===r?s(l,o,"abort"):o.chunkTransfer=u.ajax({url:l.action,data:r,dataType:l.dataType,headers:l.headers,type:"POST",contentType:!1,processData:!1,cache:!1,beforeSend:function(e,t){l.$el.trigger($.chunkStart,[o,t,e])},success:function(e,t,a){o.currentChunk++,l.$el.trigger($.chunkComplete,[o]);var r=Math.ceil(o.currentChunk/o.totalChunks*100);l.$el.trigger($.fileProgress,[o,r,t,a]),o.currentChunk<o.totalChunks?n(l,o):(o.complete=!0,l.$el.trigger($.fileComplete,[o,e,t,a]),v(l))},error:function(e,t,a){var r,n,i;n=o,i=a,(r=l).$el.trigger($.chunkError,[n,i]),s(r,n,i)}})}(n,i);else{var e=new FormData;e.append(n.postKey,i.file),!1===(e=k(n,e,i))?s(n,i,"abort"):(i.started=!0,i.transfer=u.ajax({url:n.action,data:e,dataType:n.dataType,headers:n.headers,type:"POST",contentType:!1,processData:!1,cache:!1,xhr:function(){var e=u.ajaxSettings.xhr();return e.upload&&e.upload.addEventListener("progress",function(e){var t=0,a=e.loaded||e.position,r=e.total;e.lengthComputable&&(t=Math.ceil(a/r*100)),n.$el.trigger($.fileProgress,[i,t,e])},!1),e},beforeSend:function(e,t){n.$el.trigger($.fileStart,[i,t,e])},success:function(e,t,a){i.complete=!0,n.uploaded++,n.$el.trigger($.fileComplete,[i,e,t,a]),v(n)},error:function(e,t,a){s(n,i,a)}}))}}function k(e,t,a){for(var r in e.postData)e.postData.hasOwnProperty(r)&&t.append(r,e.postData[r]);return t=e.beforeSend.call(e.$el,t,a)}var e=r.Plugin("upload",{widget:!0,defaults:{accept:!1,action:"",autoUpload:!0,beforeSend:function(e){return e},chunked:!1,chunkSize:100,customClass:"",dataType:"html",headers:{},label:"Drag and drop files or click to select",leave:"You have uploads pending, are you sure you want to leave this page?",maxConcurrent:2,maxFiles:!1,maxSize:5242880,multiple:!0,postData:{},postKey:"file",theme:"fs-light"},classes:["input","target","multiple","dropping","disabled","focus"],methods:{_construct:function(e){if(r.support.file){var t="";q||(e.chunked=!1),e.maxQueue&&(e.maxConcurrent=e.maxQueue),!1!==e.label&&(t+='<div class="'+C.target+'">',t+=e.label,t+="</div>"),t+='<input class="'+C.input+'" type="file"',e.multiple&&(t+=" multiple"),e.accept&&(t+=' accept="'+e.accept+'"'),t+=">",e.baseClasses=[C.base,e.theme,e.customClass].join(" "),this.addClass(e.baseClasses).append(t),e.$input=this.find(b.input),e.queue=[],e.total=0,e.uploaded=0,e.uploading=!1,e.disabled=!0,e.aborting=!1,this.on($.click,b.target,e,n).on($.dragEnter,e,c).on($.dragOver,e,d).on($.dragLeave,e,f).on($.drop,e,p),e.$input.on($.focus,e,i).on($.blur,e,l).on($.change,e,o),a.call(this,e)}},_destruct:function(e){r.support.file&&(e.$input.off($.namespace),this.off($.namespace).removeClass(e.baseClasses).html(""))},disable:function(e){e.disabled||(this.addClass(C.disabled),e.$input.prop("disabled",!0),e.disabled=!0)},enable:a,abort:function(e,t){var a;for(var r in e.aborting=!0,e.queue)e.queue.hasOwnProperty(r)&&(a=e.queue[r],(void 0===t||0<=t&&a.index===t)&&(a.started&&!a.complete?e.chunked?a.chunkTransfer.abort():a.transfer.abort():s(e,a,"abort")));e.aborting=!1,v(e)},start:h}}),b=e.classes,C=b.raw,$=e.events,y=e.functions,S=(r.window,r.$window),q=!1;r.Ready(function(){var e=["mozSlice","webkitSlice","slice"];if(r.support.file){var t=!1;try{t=new File([""],"f")}catch(e){}if(!t)try{t=new Blob([""],{})}catch(e){}if(t)for(var a in e)if(e.hasOwnProperty(a)&&e[a]in t){q=e[a];break}}}),$.chunkComplete="chunkcomplete",$.chunkError="chunkerror",$.chunkStart="chunkstart",$.complete="complete",$.fileComplete="filecomplete",$.fileDragEnter="filedragenter",$.fileDragLeave="filedragleave",$.fileDragOver="filedragover",$.fileError="fileerror",$.fileProgress="fileprogress",$.fileStart="filestart",$.start="start",$.queued="queued"});

var DB_Transaction = function(request, callback)
{
	var _transaction = this;
	_transaction.request = request;
	_transaction.callback = callback;
	_transaction.interface = {
		stack_item: $('<div></div>').StackItem(request)
	};

	_transaction.run = function()
	{
		if (_transaction.request != undefined){
			$.ajax({
				type: 'POST',
				url: "/api/post",
				data: _transaction.request,
				processData: false,
				contentType: false,
				success: _transaction.response,
				dataType: 'json'
			});
		}
	};

	_transaction.cancel = function()
	{
		_transaction.request = undefined;
		_transaction.interface.stack_item.delete();
	};

	_transaction.response = function(x)
	{
		if (x.success){
			_transaction.success(x);
		} else {
			_transaction.error(x);
		}
	};

	_transaction.success = function(x)
	{
		$.slr.react(_transaction, x);
		if (_transaction.callback != undefined){
			_transaction.callback(x);
		}
	};

	_transaction.error = function(x)
	{
		$.slr.react(_transaction, x);
	};

	return function()
	{
		$.slr.interface.stack.add(_transaction.interface.stack_item);
		return _transaction;
	}();
}

var DB = function()
{
	var _db = this;
	_db.queue = [];
	_db.status = {
		is_running: false,
		has_error: false
	}

	_db.next = function()
	{
		if (_db.queue.length > 0){
			var transaction = _db.queue.shift();
			transaction.run();
		} else {
			_db.ended();
		}
	};

	_db.add = function(request, callback)
	{
		if (_db.status.has_error){
			$.slr.warning(); return;
		}
		var transaction = new DB_Transaction(request, callback);
		_db.queue.push(transaction);
		$.slr.interface.stack.status.active = true;
		if (!_db.status.is_running){
			_db.next();
			_db.status.is_running = true;
		}
	};

	_db.empty_queue = function()
	{
		_db.queue.forEach(function(transaction, index){
			transaction.cancel();
		});
		_db.queue = [];
	};

	_db.ended = function()
	{
		_db.empty_queue();
		_db.status.is_running = false;
		$.slr.interface.stack.status.active = false;
	};

	return function(){
		return _db;
	}();
};

$.fn.EmailComposer = function(object_data)
{
	var _mail = this;
	_mail.object_data = object_data;

	/* Submit form */
	_mail.send = function()
	{
		// close window
		_mail.modal('hide');

		// gather data
		var values = _mail.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		request.append("model", "mailer");
		$.map(values, function(n, i){
			if (n['name'] == "mailer_action"){
				request.append("action", n['value']);
			} else if (n['name'] == 'mailer_email' || n['name'] == 'mailer_attachments'){
				if (data[n['name']] == undefined){
					data[n['name']] = [];
				}
				data[n['name']].push(n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	return function()
	{
		// populate invoice data
		if (_mail.data("model") == "invoice"){
			_mail.find("input.email-placeholder").val(_mail.object_data.contact_email);
			_mail.find("input.filename-placeholder").val(_mail.object_data.str_id + ".pdf");
			_mail.find("input[name=mailer_subject]").val('La facture ' + _mail.object_data.str_id + ' est disponible');
			_mail.find("input[name=mailer_invoice_id]").val(_mail.object_data.id);
			_mail.find('.btn-action-email-send').prop("disabled", false)
		} else if (_mail.data("model") == "contact"){
			_mail.find("input[name=mailer_contact_id]").val(_mail.object_data.id);
			if (_mail.find("input[name=mailer_action]").val() == "send-contact"){
				_mail.find("input[name=mailer_subject]").val(_mail.object_data.contact_subject);
				var select = _mail.find('select[name=mailer_attachments]'),
					attachments = JSON.parse(_mail.object_data.contact_attachments);
				select.append($('<option>').attr("value", "pdf").text(_mail.object_data.contact_attachment).prop("selected", true));
				attachments.forEach(function(attachment, index){
					select.append($('<option>').attr("value", attachment.id).text(attachment.file_name).prop("selected", false));
				});
			} else if (_mail.find("input[name=mailer_action]").val() == "send-coords"){
				_mail.find("input[name=mailer_subject]").val(_mail.object_data.coords_subject);
				_mail.find("input.filename-placeholder").val(_mail.object_data.coords_attachment);
			}
		}

		// tag emails
		_mail.find('select.tags').select2({
			tags: true,
			tokenSeparators: [',', ' '],
			selectOnClose: true,
			dropdownCss: {display: 'none'},
		}).on("change", function(){
			_mail.find('.btn-action-email-send').prop("disabled", $(this).val().length ? false : true);
		});
		setTimeout(function(){
			_mail.find('select.tags').parent().find("input.select2-search__field").attr("placeholder", "Ajouter une adresse courriel");
		}, 100);

		// attachments
		_mail.find('select.attachments').select2({
			tags: true,
			tokenSeparators: [',', ' '],
			selectOnClose: true,
		});

		// click action, disabled until an email address is tagged
		_mail.find('.btn-action-email-send').on("click", _mail.send).prop("disabled", _mail.find('select.tags').length > 0);
		return _mail;
	}();
};


$.fn.EmailComposerMultiple = function(_list)
{
	var _mail_multiple = this;
	_mail_multiple.ids = [];
	_mail_multiple.str_ids = [];
	_mail_multiple.email_addresses = [];

	/* On changed: ids changed */
	_mail_multiple.ids_changed = function(e)
	{
		var $target = $(e.target);
		if ($target.attr("name") == "send_multiple"){
			var id = parseInt($target.val(), 10),
			str_id = $target.data("string-id"),
			email_address = $target.data("email");
			if ($target.is(":checked")){
				_mail_multiple.ids.push(id);
				_mail_multiple.str_ids.push(str_id);
				_mail_multiple.email_addresses.push(email_address);
			} else {
				_mail_multiple.ids.splice(_mail_multiple.ids.indexOf(id), 1);
				_mail_multiple.email_addresses.splice(_mail_multiple.str_ids.indexOf(str_id), 1);
				_mail_multiple.str_ids.splice(_mail_multiple.str_ids.indexOf(str_id), 1);
			}
		}
	};

	/* Open */
	_mail_multiple.open = function()
	{
		// must select items first
		if (!_mail_multiple.ids.length){
			$.slr.notify({
				icon: 'fa fa-warning',
				title: 'Aucune facture sélectionnée',
				message: "Vous devez d'abord sélectionner une ou plusieurs factures dans la liste."
			}, { type: 'danger' });
			return false;
		}

		// must have exactly one email address
		if (_mail_multiple.email_addresses.length > 1){
			var first_address = _mail_multiple.email_addresses[0];
			for (var i = 1; i < _mail_multiple.email_addresses.length; i++) {
				var address = _mail_multiple.email_addresses[i];
				if (address != first_address){
					$.slr.notify({
						icon: 'fa fa-warning',
						title: 'Plusieurs adresses sélectionnées',
						message: "Les factures sélectionnées doivent obligatoiremenet être associées à la même adresse courriel."
					}, { type: 'danger' });
					return false;
				}
			}
		}

		// set form info
		_mail_multiple.find("input[name=mailer_email]").val(_mail_multiple.email_addresses[0]);
		_mail_multiple.find("input[name=mailer_invoices_ids]").val(_mail_multiple.ids.join(','));
		_mail_multiple.find("input[name=mailer_str_ids]").val(_mail_multiple.str_ids.join(', '));

		// open the modal window
		_mail_multiple.modal('show');
	};

	/* Submit form */
	_mail_multiple.send = function()
	{
		// close window
		_mail_multiple.modal('hide');

		// gather data
		var values = _mail_multiple.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		request.append("model", "mailer");
		$.map(values, function(n, i){
			if (n['name'] == "mailer_action"){
				request.append("action", n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	return function()
	{
		$("table.dataTable").on("change", _mail_multiple.ids_changed);
		$('.btn-action-email-multiple').on("click", _mail_multiple.open);
		_mail_multiple.find('.btn-action-email-send').on("click", _mail_multiple.send);
		return _mail_multiple;
	}();
};


$.fn.InvoiceSelector = function(_list)
{
	var _invoice_multiple = this;
	_invoice_multiple.ids = [];
	_invoice_multiple.str_ids = [];

	/* On changed: ids changed */
	_invoice_multiple.ids_changed = function(e)
	{
		var $target = $(e.target);
		if ($target.attr("name") == "send_multiple"){
			var id = parseInt($target.val(), 10),
			str_id = $target.data("string-id")
			if ($target.is(":checked")){
				_invoice_multiple.ids.push(id);
				_invoice_multiple.str_ids.push(str_id);
			} else {
				_invoice_multiple.ids.splice(_invoice_multiple.ids.indexOf(id), 1);
				_invoice_multiple.str_ids.splice(_invoice_multiple.str_ids.indexOf(str_id), 1);
			}
		}
		if (_invoice_multiple.ids.length) {
			$('button.rapport-a-payer, button.code-paiement').prop('disabled', false)
		} else {
			$('button.rapport-a-payer, button.code-paiement').prop('disabled', true)
		}
	};

	_invoice_multiple.send = function() {
		_invoice_multiple.attr('action', _invoice_multiple.attr('action').replace('code', 'a-payer'))
		_invoice_multiple.find("input[name=selection]").val(_invoice_multiple.ids.join(','));
		_invoice_multiple.submit();
	}

	_invoice_multiple.code = function() {
		_invoice_multiple.attr('action', _invoice_multiple.attr('action').replace('a-payer', 'code'))
		_invoice_multiple.find("input[name=selection]").val(_invoice_multiple.ids.join(','));
		_invoice_multiple.submit();
		setTimeout(function () {
			location.reload()
		}, 1000)
	}

	return function()
	{
		$("table.dataTable").on("change", _invoice_multiple.ids_changed);
		$('button.rapport-a-payer').on("click", _invoice_multiple.send);
		$('button.code-paiement').on("click", _invoice_multiple.code);
		return _invoice_multiple;
	}();
};

$.fn.SLR_ContactDocumentEditor = function(contact_data)
{
	var _editor = this;
	_editor.action = "telecharger";
	_editor.contact_data = contact_data;
	_editor.print_iframe = undefined;
	_editor.document_mailer = undefined;

	// set action for next
	_editor.setAction = function(action)
	{
		_editor.action = action;
		switch (_editor.action) {
			case "download":
				_editor.attr("target", "_self");
				_editor.attr("action", "/contact/telecharger/fiche/" + _editor.contact_data.id);
				_editor.find("span.action-label").text("Télécharger la fiche complète");
				_editor.find(".btn .material-symbols-outlined").text("download");
				break;
			case "print":
				if (_editor.print_iframe != undefined){
					_editor.print_iframe.remove();
				}
				_editor.print_iframe = $('<iframe></iframe>').attr("name", "print_iframe").css({
					width : '1px',
					height : '1px',
					position : 'fixed',
					top : '-1px',
					left : '-1px'
				});
				$("body").append(_editor.print_iframe);
				_editor.find("span.action-label").text("Imprimer la fiche complète");
				_editor.find(".btn .material-symbols-outlined").text("print");
				break;
			case "email":
				_editor.attr("target", "_self");
				_editor.attr("action", "/contact/enregistrer/fiche/" + _editor.contact_data.id);
				_editor.find("span.action-label").text("Préparer pour l'envoi");
				_editor.find(".btn .material-symbols-outlined").text("send");
				break;
		}
	};

	// post data
	_editor.post_data = function()
	{
		switch (_editor.action) {
			case "download":
				_editor.submit();
				_editor.modal('hide');
				break;
			case "print":
				var print_icon = _editor.find("i");
				print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
				var src = "/assets/libraries/pdfjs/web/viewer.html?file=",
					file = "/contact/previsualiser/fiche/" + _editor.contact_data.id;
				file += "?editor_title=" + _editor.find("input[name=editor_title]").val();
				file += "&editor_production=" + _editor.find("input[name=editor_production]").val();
				file += "&editor_role=" + _editor.find("input[name=editor_role]").val();
				file += "&editor_dates=" + _editor.find("input[name=editor_dates]").val();
				var note = _editor.find("textarea[name=editor_note]").val();
				note = note.replace(/(?:\r\n|\r|\n)/g, '||BR||');
				file += "&editor_note=" + note;
				src += encodeURIComponent(file);
				_editor.print_iframe.attr("src", src);
				window.endPrintProcess = function(){
					var print_icon = _editor.find("i");
					print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
					_editor.modal('hide');
				};
				break;
			case "email":
				var email_icon = _editor.find("i");
				email_icon.removeClass("fa-envelope-o").addClass("fa-circle-o-notch fa-spin");
				_editor.ajaxSubmit({
					success: function(){
						var print_icon = _editor.find("i");
						print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-envelope-o");
						_editor.modal('hide');
						_editor.document_mailer.modal('show');
					}
				});
				break;
		}
		return false;
	};

	return function()
	{
		_editor.find(".btn-action-generate").on("click", _editor.post_data);
		_editor.document_mailer = $("#email-contact-modal").clone().EmailComposer(_editor.contact_data);
		_editor.find("h5.modal-title").text(_editor.contact_data.full_name);
		_editor.find("input[name=editor_contact_id]").val(_editor.contact_data.id);
		return _editor;
	}();
};

$.fn.SLR_ContactActions = function()
{
	var self = this;
	if (self.data("init") == true) return;
	self.data("init", true);
	self.contact_data = self.data("contact");
	self.document_editor = undefined;
	self.document_mailer = undefined;

	// Submit action to API
	self.submit_action = function(action, permission_key, permission_value)
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contact");
		request.append("id", self.contact_data.id);
		request.append("action", action);
		if (permission_key != undefined && permission_value != undefined){
			data[permission_key] = permission_value;
		}
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	// Delete contact
	self.delete_contact = function()
	{
		swal({
			title: "Suppression d'une fiche technique",
			text: "Êtes-vous sûr de vouloir supprimer cette fiche technique et le compte utilisateur associé? Cette action est protégée par mot de passe.",
			type: "input",
			customClass: "delete-contact-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Supprimer',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'CONTACT_DELETE',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					swal({
						title: "Suppression en cours...",
						text: "La fiche technique est en cours de suppression.",
						type: "success",
						showConfirmButton: false,
						timer: 2000
					});
					self.submit_action("delete", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".delete-contact-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
		return false;
	};

	// Download contact
	self.download_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("download");
		self.document_editor.modal('show');
		return false;
	};

	// Print contact
	self.print_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("print");
		self.document_editor.modal('show');
		return false;
	};

	// Email contact
	self.email_contact = function()
	{
		if (self.document_editor == undefined){
			self.document_editor = $("#contact-document-editor-modal").clone().SLR_ContactDocumentEditor(self.contact_data);
		}
		self.document_editor.setAction("email");
		self.document_editor.modal('show');
		return false;
	};

	// Print coordinates
	self.print_document = function()
	{
		$('.print-frame').remove();
		var print_icon = $(this).find("i");
		print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
		var print_iframe = $('<iframe></iframe>').attr("src", "/assets/libraries/pdfjs/web/viewer.html?file=" + encodeURIComponent($(this).attr("href"))).css({
			width : '1px',
			height : '1px',
			position : 'fixed',
			top : '-1px',
			left : '-1px'
		}).addClass("print-frame");
		$("body").append(print_iframe);
		window.endPrintProcess = function(){
			print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
		};
		return false;
	};

	// Email coordinates
	self.email_coords = function()
	{
		self.coordinates_mailer = $('#email-coords-modal').clone().EmailComposer(self.contact_data);
		$(self.coordinates_mailer).modal('show');
		return false;
	};

	return function()
	{
		// initialize actions
		self.find(".btn-action-delete-contact").on("click", self.delete_contact);
		self.find(".btn-action-download-contact").on("click", self.download_contact);
		self.find(".btn-action-print-contact").on("click", self.print_contact);
		self.find(".btn-action-email-contact").on("click", self.email_contact);
		self.find(".btn-action-print-coords").on("click", self.print_document);
		self.find(".btn-action-email-coords").on("click", self.email_coords);
		self.find(".btn-action-print-labels").on("click", self.print_document);
		return self;
	}();
};

/* Form object */
$.fn.Form = function()
{
	var _form = this;
	_form.adding = false;
	_form.element = _form.is("form.main-form") ? $(_form) : _form.find("form.main-form");
	_form.interface = {
		clear_button: _form.find(".btn-action-clear"),
		dropify_elements: []
	};

	/* Submit form */
	_form.submit_form = function()
	{
		// gather data
		var values = _form.element.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		var currentAction = '';
		var currentModel = $(_form.element[0]).data("model");
		request.append("model", currentModel);
		$.map(values, function(n, i){
			if (n['name'] == "action"){
				currentAction = n['value'];
				request.append("action", n['value']);
			} else if (n['name'] == "id"){
				request.append("id", n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});

		// repeater field
		$('.repeater-field.main-form-field').each(function(){
			var repeaterField = $(this).data('repeater_field');
			data[repeaterField.data('name')] = repeaterField.val();
			repeaterField.names.forEach(function(name, index){
				delete data[name];
			});
		});

		// do not double-submit new
		if (_form.adding) {
			return false;
		} else if (currentAction == "add") {
			_form.adding = true;
			$('.btn-action-submit').prop('disabled', true);
			_form.element.find('button[type="submit"]').prop('disabled', true);
		}

		// force booleans
		if (currentModel == 'invoice') {
			if ($('input[name="exempt_tps"]').length && !$('input[name="exempt_tps"]').prop('checked')) {
				data.exempt_tps = 0;
			}
			if ($('input[name="exempt_tps"]').length && !$('input[name="exempt_tvq"]').prop('checked')) {
				data.exempt_tvq = 0;
			}
			if (!$('input[name="sartec"]').prop('checked')) {
				data.sartec = 0;
			}
			if (!$('input[name="sartec_tv"]').prop('checked')) {
				data.sartec_tv = 0;
			}
			if (!$('input[name="paid"]').prop('checked')) {
				data.paid = 0;
			}
		}

		// append data
		request.append("data", JSON.stringify(data));

		// add data
		$('input[type=file]').each(function(){
			if ($('input[type=file]').val()){
				request.append($(this).attr("name"), $(this)[0].files[0]);
			}
		});

		// add request to queue
		$.slr.db.add(request, _form.saved);
		return false;
	};

	/* Delete action */
	_form.delete = function()
	{
		// arrange form
		$("input[name=action]").val("delete");
		_form.submit_form();
	};

	/* Set field value */
	_form.set_attachment_value = function(field_name, field_value)
	{
		_form.find(":input[name=" + field_name + "_id]").val(field_value);
		_form.find(":input[name=" + field_name + "]").val("");
	};

	/* Lock form */
	_form.lock = function()
	{
		// _form.element.addClass("disabled");
	};

	/* Unlock form */
	_form.unlock = function()
	{
		_form.adding = false;
		$('.btn-action-submit').prop('disabled', false);
		_form.element.find('button[type="submit"]').prop('disabled', false);
	};

	/* Clear form */
	_form.clear = function()
	{
		_form.element.removeError();
		_form.find(".card-block").slideUp(350, function(){
			_form.element.each(function(){
				$(this).get(0).reset();
			});
			_form.unlock();
			_form.find("textarea").val("");
			_form.interface.dropify_elements.forEach(function(element){
				var dropify_element = element.data('dropify');
				dropify_element.resetPreview();
				dropify_element.clearElement();
			});
			_form.find("input[type=checkbox]").prop("checked", false).change();
			_form.find("select").val("").change();
			setTimeout(function(){
				_form.find(".card-block").slideDown(350);
			}, 100);
		});

		return false;
	}

	/* Form saved: overridden in specific forms */
	_form.saved = function()
	{
		// nothing on normal form
	}

	/* Init form */
	return function()
	{
		/* Initialize form submission */
		_form.element.on('submit', function(e){
			e.preventDefault();
			_form.submit_form();
		});

		/* Clear button action and notification */
		_form.interface.clear_button.on("click", function(){
			$.slr.notify({
				icon: 'fa fa-eraser',
				title: 'Formulaire réinitialisé',
				message: "Vous avez réinitialisé le contenu du formulaire."
			}, { type: 'warning' });
			_form.clear();
		});

		/* Masked fields */
		_form.find('input.masked').each(function(){
			$(this).mask($(this).data("mask"), {placeholder: $(this).attr("placeholder")});
		});

		/* Resizeable text area */
		autosize(_form.find('textarea'));

		/* Select */
		_form.find("select").
		not("#slr-element-template select, .template select").	// not an element template
		each(function(){
			if ($(this).hasClass("select2") || $(this).hasClass("select-search")){
				$(this).select2(select2WithCompany());
			} else if ($(this).hasClass("select-plus-new")){
				// managed inside Contract.js
			} else if ($(this).hasClass("select")){
				$(this).selectpicker({
					size: 5
				});
			}
		});

		/* Date time picker */
		_form.find('.date-picker').datetimepicker({
			widgetPositioning: {
				horizontal: 'right'
			},
			icons: {
				time: "fa fa-clock-o",
				date: "fa fa-calendar",
				up: "fa fa-arrow-up",
				down: "fa fa-arrow-down",
				previous: 'fa fa-arrow-left',
				next: 'fa fa-arrow-right'
			},
			format: 'DD/MM/YYYY',
			locale: 'fr-ca'
		});

		/* Bootstrap toggle */
		_form.find('input[type=checkbox]').not(".custom-control-input").bootstrapToggle();

		/* Repeater fields */
		_form.find('.repeater-field').each(function(){
			$(this).RepeaterField();
		});

		/* Form controls */
		$(".btn-action-submit").on("click", function(){
			if ($.slr.interface.form != undefined){
				$.slr.interface.form.find("button[type=submit]").click();
			}
		});
		$(".btn-action-clear").on("click", function(){
			if ($.slr.interface.form != undefined){
				$.slr.interface.form.clear();
			}
		});
		if ($('#ftp-module.panel').length) {
			$('.btn-open-ftp-panel').on('click', function() {
				if (!$('#ftp-module.panel').hasClass('panel--open')) {
					$('#ftp-module.panel').addClass('panel--open')
				} else {
					$('#ftp-module.panel').removeClass('panel--open')
				}
			})
		}

		/* Lock element on form cards */
		var lock_element = $('<div class="form-lock"></div>');
		lock_element.append($(".slr-loader:first").clone());
		_form.find(".card-block").each(function(){
			$(this).append(lock_element.clone());
		});

		// Specific forms
		if (_form.element.data("model") == "invoice"){
			_form.InvoiceForm();
		} else if (_form.element.data("model") == "contact"){
			_form.ContactForm();
		}

		// Init done
		return _form;
	}();
};


$.fn.InvoiceForm = function()	// extends Form
{
	_form = this;
	_form.element_list = undefined;
	_form.calculator = undefined;

	_form.getInvoiceID = function()
	{
		return parseInt(_form.element.find("input[name=id]").val(), 10);
	};

	_form.get_contact_id = function()
	{
		return parseInt(_form.element.find("select[name=contact_id]").val(), 10);
	};

	_form.get_invoice_type = function()
	{
		return parseInt(_form.element.find("input[name=type]").val(), 10);
	};

	_form.get_redevance = function()
	{
		return parseFloat(_form.element.find("input[name=redevance]").val(), 10);
	};

	_form.updateTotals = function()
	{
		if (_form.element_list != undefined) {
			if (_form.get_invoice_type() == 3) {	// prod
				var total_amount = 0;
				_form.element_list.model.each(function(element){
					total_amount += element.getTotal();
				});
				total_amount = total_amount.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				_form.find(".cell-total-amount").html(total_amount);
			} else {
				var total_received = 0,
				total_due = 0;
				_form.element_list.model.each(function(element){
					total_received += element.getTotal();
					total_due += element.getTotalDue();
				});
				total_received = total_received.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				total_due = total_due.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				_form.find(".cell-total-received").html(total_received);
				_form.find(".cell-total-due").html(total_due);
				_form.calculator.setFee(total_received);
			}
		}
	};

	/* Form saved: overridden from form */
	_form.saved = function(x)
	{
		_form.adding = false;
		_form.element_list.model.each(function(element){
			element.interface.tabs.details.details_list.model.details.forEach(function(details_item){
				details_item.update();
			});
		});

		/* Update str_id */
		if ('extra' in x && 'str_id' in x.extra) {
			$('input[name="str_id"]').val(x.extra.str_id)
			$('.invoice-strid').text(x.extra.str_id)
		}
	};

	_form.updateItems = function() {
		_form.element_list.model.elements.forEach(function(_e) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(_item) {
				_item.updateItemFees();
				_item.save();
			});
		});
	};

	_form.autoSave = function() {
		var currentAction = $('input[name=action]').val();
		if (currentAction == 'edit') {
			$('.btn-action-submit').click();
		}
	};

	_form.strid_clicked = function() {
		var new_strid = prompt('Veuillez entrer le nouveau numéro de facture.', $(this).attr('data-hole-strid'));
		if (new_strid) {
			$('input[name="str_id"]').val(new_strid).trigger('change')
			$(this).text(new_strid).off('click').removeClass('text-red')
		}
	}

	_form.sartec_changed = function() {
		let self = $(this),
		other = $(this).attr('name') == 'sartec' ? $('input[name="sartec_tv"]') : $('input[name="sartec"]');
		if (self.is(':checked')) {
			other.prop('checked', false)
		}
	}

	return function()
	{
		/* Date time picker */
		var dateTimePicker = _form.find('.invoice-date-picker').datetimepicker({
			widgetPositioning: {
				horizontal: 'left'
			},
			icons: {
				time: "fa fa-clock-o",
				date: "fa fa-calendar",
				up: "fa fa-arrow-up",
				down: "fa fa-arrow-down",
				previous: 'fa fa-arrow-left',
				next: 'fa fa-arrow-right'
			},
			format: 'DD/MM/YYYY',
			locale: 'fr-ca'
		});
		dateTimePicker.on("dp.change", function(){
			_form.autoSave();
		});

		// Update invoice string_id
		$('.invoice-strid').on('click', _form.strid_clicked);

		// Calculatrice
		_form.calculator = _form.find(".slr-calc").Calculator();

		// Elements list
		_form.element_list = _form.find("#slr-element-list").ElementList(_form);

		// Change redevance, calc again
		_form.element.find("input[name=redevance]").on("change", _form.updateItems);

		// Sartec only one selected
		_form.element.find("input[name=sartec],input[name=sartec_tv]").on("change", _form.sartec_changed);

		// Auto-save for invoice form
		_form.find('input[name=date]').on("change", _form.autoSave);
		_form.element.on("change", _form.autoSave);

		// Contact & reference
		_form.find("#form-invoice-contact-reference").ContactReferenceModule();

		// Update totals
		_form.updateTotals();

		// Return
		return _form;
	}();
}

$.fn.ContactReferenceModule = function()
{
	var self = this;
	self.fields = {
		contact : self.find('select[name=contact_id]'),
		invoiced : self.find('textarea[name=invoiced]'),
		reference : self.find('input[name=reference]')
	};

	self.current_contact_id = function()
	{
		return self.fields.contact.select2('val');
	};

	return function()
	{
		// auto complete on reference field
		$.typeahead({
			input: 'input[name=reference]',
			order: 'asc',
			minLength: 0,
			accent: true,
			dynamic: true,
			searchOnFocus: true,
			source: {
				ajax: {
					url: "/facture/references/",
					data: {
						contact_id: self.current_contact_id
					}
				}
			},
			cancelButton: false
		});

		// focus sur le champ suivant: Facturé à sur une facture externe, sinon la référence
		self.fields.contact.on("change", function(){
			setTimeout(function(){
				if (self.fields.invoiced.length){
					self.fields.invoiced.focus();
				} else {
					self.fields.reference.focus().select();
				}
			}, 1);
		});

		// nouvelle facture: focus sur la référence, ou sur Payable à pour une facture externe sans destinataire
		var currentAction = $('input[name=action]').val();
		if (currentAction == 'add') {
			if (self.fields.invoiced.length && !self.fields.contact.val()){
				self.fields.contact.next('.select2').find('.select2-selection').focus();
			} else if (self.fields.invoiced.length){
				self.fields.invoiced.focus();
			} else {
				self.fields.reference.focus().select();
			}
		}
		return self;
	}();
};

$.fn.SLR_InvoiceActions = function()
{
	var _actions = this;
	if (_actions.data("init") == true) return;
	_actions.data("init", true);
	_actions.invoice_data = _actions.data("invoice");
	_actions.email_composer = undefined;

	_actions.submit_action = function(action, permission_key, permission_value)
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "invoice");
		request.append("id", _actions.invoice_data.id);
		request.append("action", action);
		if (permission_key != undefined && permission_value != undefined){
			data[permission_key] = permission_value;
		}
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request, _actions.saved);
		return false;
	};

	_actions.print = function()
	{
		var print_icon = $(this).find("i");
		$('.print-frame').remove();
		print_icon.removeClass("fa-print").addClass("fa-circle-o-notch fa-spin");
		var iframe = $('<iframe></iframe>').attr("src", "/assets/libraries/pdfjs/web/viewer.html?file=" + $(this).attr("href")).css({
			width : '1px',
			height : '1px',
			position : 'fixed',
			top : '-1px',
			left : '-1px'
		}).addClass("print-frame");
		$("body").append(iframe);
		window.endPrintProcess = function(){
			print_icon.removeClass("fa-circle-o-notch fa-spin").addClass("fa-print");
		};
		return false;
	};

	_actions.email = function()
	{
		_actions.email_composer = $('#email-modal').clone().EmailComposer(_actions.invoice_data);
		$(_actions.email_composer).modal('show');
		return false;
	};

	_actions.delete = function()
	{
		$(".delete-invoice-swal").remove();
		swal({
			title: "Suppression d'une facture",
			text: "Êtes-vous sûr de vouloir supprimer cette facture? Cette action est protégée par mot de passe.",
			type: "input",
			customClass: "delete-invoice-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Supprimer',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'INVOICE_DELETE',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					_actions.submit_action("delete", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".delete-invoice-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_actions.publish = function()
	{
		swal({
			title: "Publication d'une facture",
			text: "Êtes-vous sûr de vouloir publier\net verrouiller cette facture?",
			type: "warning",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-primary",
			confirmButtonText: 'Publier et verrouiller',
			closeOnConfirm: true
		}, function(){
			_actions.submit_action("publish");
		});
		return false;
	};

	_actions.discard = function()
	{
		swal({
			title: "Annuler les changements",
			text: "Êtes-vous sûr de vouloir annuler vos changements?\nLa facture originale sera rétablie.",
			type: "warning",
			showCancelButton: true,
			cancelButtonText: 'Conserver',
			confirmButtonClass: "btn-primary",
			confirmButtonText: 'Rejeter les changements',
			closeOnConfirm: true
		}, function(){
			_actions.submit_action("discard");
		});
		return false;
	};

	_actions.unlock = function()
	{
		$(".unlock-invoice-swal").remove();
		swal({
			title: "Déverrouiller une facture",
			text: "La facture sera aussi dépubliée.\nCette action est protégée par mot de passe.",
			type: "input",
			customClass: "unlock-invoice-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Déverrouiller',
			closeOnConfirm: false,
			inputPlaceholder: "Mot de passe"
		}, function (inputValue){
			$.post("/login/permission", {
				privilege: 'INVOICE_UNLOCK',
				password: inputValue
			}, function(x){
				if (x.success){
					// got permission, delete using key
					_actions.submit_action("unlock", x.action, x.key);
				} else {
					// didn't get permission
					swal({
						title: "Erreur",
						text: "Mot de passe incorrect.",
						type: "error",
						confirmButtonClass: "btn-danger"
					});
				}
			}, 'json');
		});
		$(".unlock-invoice-swal").find(".form-control").attr("type", "password").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_actions.saved = function()
	{
		//
	};

	return function()
	{
		// Print button
		_actions.find(".btn-action-print").on("click", _actions.print);

		// Send via email
		_actions.find(".btn-action-email").on("click", _actions.email);

		// Delete invoice
		_actions.find(".btn-action-delete").on("click", _actions.delete);

		// Publish invoice
		_actions.find(".btn-action-publish").on("click", _actions.publish);

		// Discard changes
		_actions.find(".btn-action-discard").on("click", _actions.discard);

		// Unlock invoice
		_actions.find(".btn-action-unlock").on("click", _actions.unlock);

		return _actions;
	}();
};

$.fn.WeightCalc = function()
{
	var self = this;
	self.field = self.find("input[name=weight]");
	self.weight_unit = self.find("input[name=weight_unit]").val();
	self.weight_value = asFloat(self.find("input[name=weight]").val());

	self.toLbs = function()
	{
		if (self.weight_unit == "kg")
		{
			// update interface
			self.weight_unit = "lbs";
			self.find("#weight-unit-button").html(self.weight_unit);
			self.find("input[name=weight_unit]").val(self.weight_unit);

			// update value
			if (!isNaN(self.weight_value)){
				self.weight_value *= 2.20462262;
				self.find("input[name=weight]").val(Math.round(self.weight_value));
			}
		}
	};

	self.toKg = function()
	{
		if (self.weight_unit == "lbs")
		{
			// update interface
			self.weight_unit = "kg";
			self.find("#weight-unit-button").html(self.weight_unit);
			self.find("input[name=weight_unit]").val(self.weight_unit);

			// update value
			if (!isNaN(self.weight_value)){
				self.weight_value /= 2.20462262;
				self.find("input[name=weight]").val(Math.round(self.weight_value));
			}
		}
	};

	return function()
	{
		self.field.mask('999');
		self.find(".action-convert-weight-field-to-lbs").on("click", self.toLbs);
		self.find(".action-convert-weight-field-to-kg").on("click", self.toKg);
		self.find("input[name=weight]").on("change", function(){
			self.weight_value = asFloat(self.field.val());
			if (isNaN(self.weight_value)){
				self.weight_value = 0;
			}
		});
		return self;
	}();
};

$.fn.HeightCalc = function()
{
	var self = this;
	self.field = self.find("input[name=height]");
	self.height_unit = self.find("input[name=height_unit]").val();
	self.height_value = self.find("input[name=height_value]").val();

	self.prepareField = function()
	{
		if (self.height_unit == "pi"){
			self.field.mask('0\'09').attr("placeholder", "_'__");
		} else {
			self.field.mask('9.99').attr("placeholder", "_.__");
		}
	};

	self.toPi = function()
	{
		if (self.height_unit == "m")
		{
			// update interface
			self.height_unit = "pi";
			self.find("#height-unit-button").html(self.height_unit);
			self.find("input[name=height_unit]").val(self.height_unit);

			// get value
			var currentValue = asFloat(self.field.val());
			if (!isNaN(currentValue)){
				var inches = Math.round(Math.round(currentValue * 100) * 0.3937),
				feet = Math.floor(inches/12);
				self.weight_value = feet+"'"+(inches%12);
				self.find("input[name=height]").val(self.weight_value);
			}

			// prepare field
			self.prepareField();
		}
	};

	self.toM = function()
	{
		if (self.height_unit == "pi")
		{
			// update interface
			self.height_unit = "m";
			self.find("#height-unit-button").html(self.height_unit);
			self.find("input[name=height_unit]").val(self.height_unit);

			// get value
			var currentValue = parseFloat(self.field.val().replace("'", "."));
			if (!isNaN(currentValue)){
				var inches = Math.floor(currentValue) * 12 + ((currentValue - Math.floor(currentValue)) * 10),
				meters = Math.round(inches / 0.3937) / 100;
				self.weight_value = meters;
				self.find("input[name=height]").val(self.weight_value);
			}

			// prepare field
			self.prepareField();
		}
	};

	return function()
	{
		self.prepareField();
		self.field.on("blur", self.blurField);
		self.find(".action-convert-height-field-to-pi").on("click", self.toPi);
		self.find(".action-convert-height-field-to-m").on("click", self.toM);
		return self;
	}();
};

$.fn.ContactForm = function()	// extends Form
{
	_form = this;
	_form.uploader = {
		files: undefined,
		notes: undefined,
	};

	_form.get_contact_id = function()
	{
		return parseInt(_form.find("input[name=id]").val(), 10);
	};

	_form.init_permissions = function() {
		let initiallyDisabled = []
		$('input[name*="[write]"]').each(function() {
			if ($(this).prop('disabled')) {
				initiallyDisabled.push(this.name)
			}
		})
		$('input[name*="[read]"]').on('change', function() {
			const isChecked = $(this).is(':checked'),
			baseName = $(this).attr('name').replace('[read]', '')
			writeCheckbox = $('input[name="' + baseName + '[write]"]')
			if (!isChecked) {
				writeCheckbox.prop('checked', false).prop('disabled', true)
			} else {
				const writeName = writeCheckbox.attr('name')
				if (initiallyDisabled.indexOf(writeName) === -1) {
					writeCheckbox.prop('disabled', false)
				}
			}
		}).trigger('change')

		// Logique pour dépôts: nécessite tous les types de factures
		function checkDepositAccess() {
			const invoicePubChecked = $('input[name="permissions[invoice_pub][read]"]').is(':checked')
			const invoiceTvChecked = $('input[name="permissions[invoice_tv][read]"]').is(':checked')
			const invoiceProdChecked = $('input[name="permissions[invoice_prod][read]"]').is(':checked')
			const allInvoicesChecked = invoicePubChecked && invoiceTvChecked && invoiceProdChecked

			const depositRead = $('input[name="permissions[deposit][read]"]')
			const depositWrite = $('input[name="permissions[deposit][write]"]')

			if (!allInvoicesChecked) {
				depositRead.prop('checked', false).prop('disabled', true)
				depositWrite.prop('checked', false).prop('disabled', true)
				depositRead.closest('tr').css('opacity', '0.5')
			} else {
				depositRead.prop('disabled', false)
				depositWrite.prop('disabled', false)
				depositRead.closest('tr').css('opacity', '1')
			}
		}

		// Vérifier au chargement et sur changement des factures
		$('.invoice-type-checkbox').on('change', checkDepositAccess)
		checkDepositAccess()
	}

	_form.set_permissions = function() {
		var role = _form.find('#field-user-auth_level option:selected').text().toLowerCase();
		if (role == 'employé') {
			role = 'employee'
		}
		if (role == 'artiste') {
			_form.find('input[name="permissions[contact][read]"]').prop('checked', true).prop('disabled', true)
		} else {
			_form.find('input[name="permissions[contact][read]"]').prop('disabled', false)
		}
		var table = _form.find('table.table');
		var tableRoles = (table.data('roles')||'').split(',');
		if (tableRoles.indexOf(role) > -1) table.show();
		else table.hide();
		table.find('tbody tr').each(function() {
			var row = $(this);
			var roles = (row.data('roles')||'').split(',');
			if (roles.indexOf(role) > -1) row.show();
			else row.hide();
		});
	}

	return function()
	{
		/* Password generation */
		$("button#generate-password").on("click", function(){
			var field = $("#" + $(this).data("controls"));
			field.password('hide').password('val', generatePassword());
		});

		/* Password visibility */
		_form.find('input[type=password][data-toggle="password-custom"]').password({
			eyeClass: '',
			eyeOpenClass: 'icmn-eye',
			eyeCloseClass: 'icmn-eye-blocked'
		});

		/* Dropify elements for file inputs */
		_form.find('input[type=file].dropify').each(function(){
			var dropify_element = $('input[type=file]').dropify({
				messages: {
					default: 'Glissez un fichier ici ou cliquez pour sélectionner',
					replace: 'Glissez un fichier ou cliquez pour remplacer',
					remove:  'Supprimer',
					error:   'Désolé, le fichier est trop volumineux'
				}
			});
			dropify_element.on('dropify.afterClear', function(event, element){
				var field_name = dropify_element.data("edit-field-name");
				$("input[name=" + field_name + "]").val("");
			});
			$(this).on("change", function(){
				var field_name = dropify_element.data("edit-field-name");
				$("input[name=" + field_name + "]").val("");
			});
			_form.interface.dropify_elements.push(dropify_element);
		});

		/* Weight field */
		_form.find("#weight-calc").WeightCalc();

		/* Height field */
		_form.find("#height-calc").HeightCalc();

		/* Year / month picker */
		_form.find('input[name=passport_expire_date]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Birth date picker */
		_form.find('input[name=birthdate]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Service start date picker */
		_form.find('input[name=service_start_date]').each(function(){
			var field = $(this);
			field.datetimepicker({
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				viewMode: 'years',
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});

		/* Uploaders */
		_form.uploader.files = _form.find(".contact-files-upload").Uploader({
			parent: _form,
			model : 'contact',
			type: 'file',
			id : _form.get_contact_id(),
			multiple: true,
		});
		_form.uploader.notes = _form.find(".contact-notes-upload").Uploader({
			parent: _form,
			model : 'contact',
			type: 'note',
			id : _form.get_contact_id(),
			multiple: true,
		});

		_form.find('#field-user-auth_level').on('changed.bs.select change', _form.set_permissions);
		_form.set_permissions();
		_form.init_permissions();

		// Return
		return _form;
	}();
}

var StackItemUtils = {

	getInfo: function(request)
	{
		var request_model = request.get("model"),
			request_action = request.get("action"),
			request_data = JSON.parse(request.get("data"));
		switch (request_model){
			case "contact":
				switch (request_action){
					case "add":
						return {
							title: "Ajout d'une fiche",
							description: request_data.firstname + " " + request_data.lastname
						};
					case "edit":
						return {
							title: "Édition d'une fiche",
							description: request_data.firstname + " " + request_data.lastname
						};
				}
			case "invoice":
				switch (request_action){
					case "add":
						return {
							title: "Nouvelle facture",
							description: "Création de la facture"
						};
					case "edit":
						return {
							title: "Édition d'une facture",
							description: "Facture " + request_data.str_id
						};
					case "delete":
						return {
							title: "Suppression d'une facture",
							description: "Facture " + request_data.str_id
						};
					case "publish":
						return {
							title: "Publication d'une facture",
							description: "Facture " + request_data.str_id + " publiée"
						};
					case "unlock":
						return {
							title: "Déverrouillage d'une facture",
							description: "Facture en cours dépubliée"
						};
				}
			case "element":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouvel élément",
								description: "Création de l'élément"
							};
						} else {
							return {
								title: "Élément de facture",
								description: "Sauvegarde de l'élément"
							};
						}
					case "duplicate":
						return {
							title: "Élément de facture",
							description: "Duplication de l'élément"
						};
					case "order":
						return {
							title: "Ordre des éléments",
							description: "Enregistré avec succès"
						};
					case "delete_file":
						return {
							title: "Élément #" + (request_data.index + 1),
							description: "Fichier supprimé"
						};
				}
				break;
			case "contract":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouveau contrat",
								description: "Création du contrat " + request_data.str_id
							};
						} else {
							return {
								title: "Contrat #" + request_data.id,
								description: "Sauvegarde du contrat"
							};
						}
					case "get":
						return {
							title: "Contrat #" + request_data.id,
							description: "Chargement du contrat"
						};
					case "delete_file":
						return {
							title: "Contrat " + request_data.str_id,
							description: "Fichier supprimé"
						};
				}
			case "detailsitem":
				switch (request_action){
					case "auto":
						if (request_data.id == undefined){
							return {
								title: "Nouveaux détails",
								description: "Création de l'item"
							};
						} else {
							return {
								title: "Modification des détails",
								description: "Sauvegarde de l'item"
							};
						}
					case "duplicate":
						return {
							title: "Détails de la facture",
							description: "Duplication de l'item"
						};
					case "order":
						return {
							title: "Ordre des items de l'élément",
							description: "Enregistré avec succès"
						};
				}
			case "mailer":
				switch (request_action) {
					case "send-invoice":
						return {
							title: "Facture envoyée",
							description: "Envoi par courriel effectué avec succès"
						};
				}
		}
		return {
			title: "Opération inconnue",
			description: "--"
		}
	}

};

$.fn.StackItem = function(request)
{
	var _item = this;
	_item.request = request
	_item.expire = undefined;
	_item.interface = {
		icon: undefined,
		icon_class: 'icmn-star-full'
	};

	_item.delete = function()
	{
		clearTimeout(_item.expire);
		_item.slideUp("fast", function(){
			_item.remove();
			$.slr.interface.stack.interface.update();
		});
	};

	_item.success = function()
	{
		_item.find("span.pull-right").text("Complété");
		_item.interface.icon.removeClass(_item.interface.icon_class);
		_item.interface.icon_class = 'fa fa-check';
		_item.interface.icon.addClass(_item.interface.icon_class);
		_item.expire = setTimeout(_item.delete, 10000);
	};

	_item.error = function(permanent)
	{
		_item.find(".pull-right").text("Erreur");
		_item.interface.icon.removeClass(_item.interface.icon_class);
		_item.interface.icon_class = 'fa fa-exclamation-triangle';
		_item.interface.icon.addClass(_item.interface.icon_class);
		if (permanent == undefined){
			permanent = true;
		}
		if (!permanent){
			_item.expire = setTimeout(_item.delete, 10000);
		}
	};

	return function()
	{
		var request_info = StackItemUtils.getInfo(request);
		_item.addClass("cat__top-bar__activity__item");
	 	_item.interface.icon = $('<i></i>').addClass('cat__top-bar__activity__icon').addClass(_item.interface.icon_class);
		var text = $('<div></div>').addClass('cat__top-bar__activity__inner'),
			title = $('<div></div>').addClass('cat__top-bar__activity__title'),
			description = $('<div></div>').addClass('cat__top-bar__activity__descr');
		title.append('<span class="pull-right"></span>');
		title.append('<a href="#">' + request_info.title + '</a>');
		description.text(request_info.description);
		text.append(title).append(description);
		_item.append(_item.interface.icon).append(text);
		return _item;
	}();
};

$.fn.Stack = function()
{
	var _sm = this;
	_sm.status = {
		_active : false,
		_empty : true,
		set active(is_active){
			this._active = is_active;
			_sm.interface.setActive(this._active);
		},
		set empty(is_empty){
			this._empty = is_empty;
			_sm.interface.setEmpty(this._empty);
		},
		get active(){ return this._active; },
		get empty(){ return this._empty; },
	};

	_sm.interface =
	{
		icon: _sm.find('#stack-icon'),
		queue: _sm.find('#stack-queue'),
		empty: _sm.find("#stack-empty"),

		setActive: function(active){
			if (active){
				_sm.interface.icon.addClass('fa-circle-o-notch fa-spin').removeClass('fa-server');
			} else {
				_sm.interface.icon.removeClass('fa-circle-o-notch fa-spin').addClass('fa-server');
			}
		},

		setEmpty: function(empty){
			if (empty){
				_sm.interface.empty.slideDown("fast");
			} else {
				_sm.interface.empty.slideUp("fast");
			}
		},

		update: function(){
			if (_sm.find('.cat__top-bar__activity__item:not(#stack-empty)').length === 0){
				_sm.status.empty = true;
			} else {
				_sm.status.empty = false;
			}
		}
	};

	_sm.add = function(queue_item)
	{
		queue_item.hide();
		_sm.interface.queue.append(queue_item.slideDown("fast"));
		_sm.interface.update();
	};

	return function()
	{
		return _sm;
	}();
};

function SLR_Element(_element)
{
	// parent element
	var self = this;
	self.element = _element;
	self.item = {
		id: undefined,
		invoice_id: undefined,
		contract_id: undefined,
		list_order: undefined,
		config: undefined,
		options_list: undefined,
		fee: undefined,
		broadcast: undefined,
		upgrade: undefined,
		deleted: false,
		element_type: undefined,
		date1: undefined,
		date2: undefined,
		cycle: undefined,
		cycle_date1: undefined,
		cycle_date2: undefined
	};

	self.save = function()
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "element");
		request.append("action", "auto");
		request.append("type", self.element.el.form.get_invoice_type());
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.delete = function()
	{
		self.item.deleted = 1;
		self.save();
	};

	self.callback = function(x)
	{
		self.item.id = x.element_id;
		if (x.action == "create" && self.element.interface.tabs.guarantees.length && self.element.getContractID()) {
			self.element.interface.tabs.guarantees.load('/facture/guarantees/' + x.element_id + '/' + self.element.getContractID(), function(){
				self.element.interface.tabs.guarantees.Guarantees(self.element);
			});
		}
		self.element.update();
	}

	self.init = function()
	{
		if (self.element.find("input[name=element_id]").val()){
			self.item.id = parseInt(self.element.find("input[name=element_id]").val(), 10);
		}
	}();
}

$.fn.Element = function(elementList)
{
	var _e = this;
	_e.el = elementList;
	_e.model = new SLR_Element(_e);
	_e.interface = {
		close_button : _e.find(".close-button"),
		trash_button : _e.find(".trash-button"),
		duplicate_button : _e.find(".duplicate-button"),
		header : _e.find('.slr-el-header'),
		tabs : {
			contract : _e.find(".slr-contract-tab"),
			fee : _e.find(".slr-fee-tab"),
			guarantees : _e.find(".slr-guarantees-tab"),
			details : _e.find(".slr-details-tab"),
		},
		cells : {
			header_title : _e.find(".cell-header-title"),
			header_dates : _e.find(".cell-header-date"),
			base_fee : _e.find(".fee-indicator .value"),
			upgrade_fee : _e.find(".upgrade-indicator .value"),
			broadcast_fee : _e.find(".broadcast-indicator .value")
		}
	};
	_e.status = {
		_opened : _e.hasClass("selected"),
		set opened (is_opened){
			this._opened = is_opened;
			if (_e.status._opened){
				_e.addClass('selected');
			} else {
				_e.removeClass('selected');
			}
		},
		get opened(){
			return this._opened;
		}
	};

	_e.close = function()
	{
		_e.find("input").blur();
		_e.status.opened = false;
		return false;
	}

	_e.open = function()
	{
		if (!_e.status.opened){
			_e.status.opened = true;
			return false;
		}
	};

	_e.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer cet élément?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer l'élément",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_e.model.delete(); // from db
				_e.slideUp("fast", function(){ // from view
					_e.el.remove_element(_e); // from list
					_e.remove(); // from dom
				});
			}
		});
		return false;
	};

	_e.duplicate = function()
	{
		_e.el.duplicate_element(_e); // in list
		return false;
	};

	_e.update = function()
	{
		_e.find("input[name=element_id]").val(_e.model.item.id);
		if (_e.interface.tabs.details.length) {
			_e.interface.tabs.details.details_list.setElementID(_e.model.item.id);
		}
		if (_e.interface.tabs.contract.length) {
			_e.interface.tabs.contract.load_element_files();
		}
	};

	_e.updateDetailsSummary = function()
	{
		if (_e.details_summary != undefined && _e.interface.tabs.details.length) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			_e.details_summary.setDetails(details_items);
			_e.el.form.updateTotals();
		}
	};

	_e.updateInterface = function()
	{
		// update interface
		if ("getHeaderTitle" in _e.interface.tabs.details){
			_e.interface.cells.header_title.text(_e.interface.tabs.details.getHeaderTitle());
			_e.interface.cells.header_dates.text(_e.interface.tabs.details.getHeaderDates());
		}
		if (_e.interface.tabs.fee.length){
			_e.interface.cells.base_fee.text(_e.interface.tabs.fee.getFee().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			_e.interface.cells.upgrade_fee.text(_e.interface.tabs.fee.getUpgrade().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			_e.interface.cells.broadcast_fee.text(_e.interface.tabs.fee.getBroadcast().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		} else if (_e.interface.tabs.guarantees.length){
			_e.interface.cells.base_fee.text(_e.interface.tabs.guarantees.getFee().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		}
	};

	_e.setInitialOptionsList = function()
	{
		_e.model.item.config = _e.getConventionName();
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
		}
	};

	_e.updateOptionsList = function()
	{
		// update options list online
		_e.model.item.config = _e.getConventionName();
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
			_e.save();
		}

		// base fee changed, update list items
		_e.interface.tabs.details.details_list.updatedBaseFee();
	};

	_e.getBaseFee = function()
	{
		if (_e.interface.tabs.fee){
			return _e.interface.tabs.fee.getFee();
		} else {
			return 0;
		}
	};

	_e.getUpgradeFee = function()
	{
		if (_e.interface.tabs.fee){
			return _e.interface.tabs.fee.getUpgrade();
		} else {
			return 0;
		}
	};

	_e.getBaseOrUpgradeFee = function()
	{
		if (_e.interface.tabs.fee && _e.interface.tabs.details){
			if (_e.interface.tabs.details.get_value('element_type') == "UPGRADE"){	// default
				return _e.getUpgradeFee();
			} else {
				return _e.getBaseFee();
			}
		} else {
			return 0;
		}
	}

	_e.getTotal = function()
	{
		var total = 0;
		if (_e.details_summary != undefined && _e.interface.tabs.details.length) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(detail_item){
				total += detail_item.model.getBase();
			});
		}
		return total;
	};

	_e.getTotalDue = function()
	{
		var total = 0;
		if (_e.details_summary != undefined){
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(detail_item){
				total += detail_item.model.getDue();
			});
		}
		return total;
	};

	_e.save = function()
	{
		_e.model.save();
	};

	_e.set = function(key, value)
	{
		// update model
		_e.model.item[key] = value;
		_e.save();

		// update interface
		_e.updateInterface();
	}

	_e.getElementID = function()
	{
		return _e.model.item.id;
	};

	_e.get_element_index = function()
	{
		return _e.el.model.getIndexOf(_e.getElementID());
	};

	/* Convention info */
	_e.getConventionName = function()
	{
		if (_e.find("select[name=config]").length) {
			return _e.find("select[name=config]").val();
		}
		return 'prod_2020';
	};
	_e.getConventionType = function()
	{
		return _e.getConventionName().split("_")[0];
	};
	_e.getConventionData = function()
	{
		return $.slr.conventions[_e.model.item.config].fees;
	};
	_e.getConventionItems = function()
	{
		return $.slr.conventions[_e.model.item.config].items.items;
	};
	_e.getConventionTypes = function()
	{
		return $.slr.conventions[_e.model.item.config].items.types;
	};

	_e.getContractID = function()
	{
		if (_e.interface.tabs.contract.length){
			return _e.interface.tabs.contract.get_id();
		}
		return undefined;
	};

	_e.reachTab = function(tab_index)
	{
		// go to tab
		_e.find(".card-collapse:eq(0)").collapse('hide');
		if (tab_index != 1){ _e.find(".card-collapse:eq(1)").collapse('hide'); }
		if (tab_index != 2){ _e.find(".card-collapse:eq(2)").collapse('hide'); }
		var tab = _e.find(".card-collapse:eq(" + tab_index + ")");
		if (tab.hasClass("show")){
			TabOrder.focusTab(tab);
		} else {
			tab.one('shown.bs.collapse', function(){
				TabOrder.focusTab(tab);
			});
		}
		tab.collapse('show');

		// scroll to tab
		$('body, html').animate({
			scrollTop: (_e.find(".card-collapse:eq(" + (tab_index-1) + ")").offset().top - ($(".cat__core__top-sidebar").outerHeight(true) + 6))
		}, 150);
	};

	/*
	*	Contract follow up between tabs
	*/

	_e.contractCreated = function()
	{
		/* Update guarantees tab */
		if (_e.interface.tabs.guarantees.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
					});
				}
			});
		}
	};

	_e.contractUpdated = function()
	{
		/* Update guarantees tab */
		/* An unsaved element has no convention yet: its creation callback reloads the tab */
		if (_e.interface.tabs.guarantees.length && _e.getElementID())
		{
			/* Reload for current element */
			var element_id = _e.getElementID(),
			contract_id = _e.getContractID();
			if (contract_id == undefined){
				contract_id = "";
			}
			_e.interface.tabs.guarantees.load('/facture/guarantees/' + element_id + "/" + contract_id, function(){
				_e.interface.tabs.guarantees.Guarantees(_e);
			});
		}
	};

	_e.contractChanged = function()
	{
		/* Update guarantees tab */
		if (_e.interface.tabs.guarantees.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID(),
				contract_id = x.getContractID();
				if (x != _e && contract_id && contract_id == _e.getContractID() && x.interface.tabs.guarantees.length){
					x.interface.tabs.guarantees.load('/facture/guarantees/' + element_id + '/' + contract_id, function(){
						x.interface.tabs.guarantees.Guarantees(x);
					});
				}
			});
		}
	};

	_e.contractRenamed = function()
	{
		/* Update contract tab */
		if (_e.interface.tabs.contract.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
					});
				}
			});
		}
	};

	_e.contractDeleted = function()
	{
		/* Update contract tab */
		if (_e.interface.tabs.contract.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
						x.contractUpdated();
					});
				}
			});
		}
	};

	return function()
	{
		// immediately get properties
		_e.model.item.config = _e.getConventionName();

		// set interface
		_e.interface.close_button.on("click", _e.close);
		_e.interface.header.on("click", function(){
			if (!_e.status.opened){
				_e.open();
			} else {
				_e.close();
			}
			return false;
		});
		_e.interface.trash_button.on("click", _e.trash);
		_e.interface.duplicate_button.on("click", _e.duplicate);
		_e.on("click", _e.open);

		// initialize accordion
		_e.find(".accordion>.card").each(function(){
			var id = "tab" + Math.random().toString(36).substring(7);
			$(this).find(".card-header").attr("data-target", "#"+id).attr("data-toggle", "collapse");
			$(this).find(".card-collapse").attr("id", id);
			$(this).find(".card-collapse.collapse").collapse('hide');
		});

		// no accordion behavior on config select
		_e.find(".card-header select").on("click", function(e){
			return false;
		});

		// date pickers
		_e.find('.element-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			})
		});

		// tabs
		switch (_e.el.form.get_invoice_type()) {
			case 1:	// InvoiceType::PUB
				_e.interface.tabs.fee.FeeCalculator(_e);
				_e.interface.tabs.contract.Contract(_e);
				_e.interface.tabs.details.Details(_e);
				break;
			case 2:	// InvoiceType::TV
				_e.interface.tabs.guarantees.Guarantees(_e);
				_e.interface.tabs.contract.Contract(_e);
				_e.interface.tabs.details.Details(_e);
				break;
			case 3:	// InvoiceType::PROD
				_e.interface.tabs.details.Details(_e);
				break;
		}

		// initialize loaded item
		_e.model.item.invoice_id = _e.el.form.getInvoiceID();
		if (_e.el.form.get_invoice_type() != 3) {	// not prod
			_e.model.item.config = _e.getConventionName();
			_e.model.item.contract_id = _e.getContractID();
		} else {
			_e.model.item.config = 'prod_2020';
		}

		// pub invoices only
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
			_e.model.item.cycle = _e.interface.tabs.fee.get_value('cycle');
			_e.model.item.cycle_date1 = _e.interface.tabs.fee.get_value('cycle_date1');
			_e.model.item.cycle_date2 = _e.interface.tabs.fee.get_value('cycle_date2');
			_e.model.item.date1 = _e.interface.tabs.details.get_value('date1');
			_e.model.item.date2 = _e.interface.tabs.details.get_value('date2');
			_e.model.item.element_type = _e.interface.tabs.details.get_value('element_type');
		}

		// details summary
		_e.details_summary = _e.find(".slr-el-rows").DetailsSummary(_e);
		_e.updateDetailsSummary();

		// select with search
		_e.find(".element-select-search[name=element_type]").each(function(){
			$(this).select2({
				language: "fr"
			});
		});
		return _e;
	}();
};

/*
*	Element list model
*/
function SLR_ElementList(_element)
{
	/* Properties */
	var self = this;
	self.element = _element;
	self.elements = [];

	/* Methods */
	self.addElement = function(element)
	{
		self.elements.push(element);
	};

	self.removeElement = function(element)
	{
		var index = self.elements.indexOf(element);
		if (index >= 0){
			self.elements.splice(index, 1);
		}
	};

	self.duplicateElement = function(element)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "element");
		request.append("action", "duplicate");
		request.append("type", self.element.form.get_invoice_type());
		request.append("data", JSON.stringify(element.model.item));

		// add request to queue
		$.slr.db.add(request, function(x)
		{
			self.element.load_element(x.item.id);
		});
		return false;
	};

	self.setListOrder = function(list_order)
	{
		// reorder array of elements
		var elements_array = [];
		list_order.forEach(function(id){
			elements_array.push(self.getByID(id));
		});
		self.elements = elements_array;

		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "element");
		request.append("action", "order");
		request.append("data", JSON.stringify(list_order));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	self.getByID = function(element_id)
	{
		var element = undefined;
		self.elements.forEach(function(e){
			if (e.getElementID() == element_id){
				element = e;
			}
		});
		return element;
	};

	self.getIndexOf = function(element_id)
	{
		var index_of = -1000;
		self.elements.forEach(function(e, index){
			if (e.getElementID() == element_id){
				index_of = index;
			}
		});
		return index_of;
	};

	self.getCount = function()
	{
		return self.elements.length;
	};

	self.each = function(callback)
	{
		self.elements.forEach(function(x){
			callback(x);
		});
	};
}

/*
*	Element list interface behavior
*/
$.fn.ElementList = function(_form)
{
	var _el = this;
	_el.model = new SLR_ElementList(_el);
	_el.template = undefined;
	_el.form = _form;
	_el.interface = {
		empty_element : _el.find("#slr-element-list-empty"),
		add_button : _el.find(".btn-action-add-element"),
		container : _el.find("#slr-elements-container")
	};

	_el.refresh = function()
	{
		// empty or not
		if (_el.model.getCount()){
			_el.interface.empty_element.fadeOut("fast");
		} else {
			_el.interface.empty_element.fadeIn("fast");
		}

		// show elements
		_el.model.each(function(x){
			_el.interface.container.append(x);
		});

		// update totals
		_el.form.updateTotals();
	};

	_el.add_element = function()
	{
		if (_el.form.get_invoice_type() != 3) {	// not prod
			// select previous element contract if available
			var lastContract = undefined;
			_el.model.elements.forEach(function(x){
				if (x.getContractID() != undefined && x.getContractID()){
					lastContract = x.getContractID();
				}
			});
		}

		// create new element
		var newElement = _el.template.find(".slr-el").clone();
		if (lastContract != undefined){
			newElement.find("select[name=contract_id]").val(lastContract).trigger("change");
		}
		newElement.Element(_el);
		
		// save new element
		newElement.save();
		newElement.open(); // open new element by default
		newElement.updateInterface();
		_el.model.addElement(newElement);
		_el.refresh();
		return false;
	};

	_el.remove_element = function(element)
	{
		_el.model.removeElement(element);
		_el.refresh();
	};

	_el.duplicate_element = function(element){
		_el.model.duplicateElement(element);
	}

	_el.load_element = function(element_id)
	{
		$.get("/facture/element/" + element_id, {}, function(x){
			var newElement = $($(x)[0]);
			newElement.Element(_el);
			_el.model.addElement(newElement);
			_el.refresh();
		}, 'html');
	};

	_el.elements_sorted = function()
	{
		var order = [], elements = [];
		_el.interface.container.find(".slr-el").each(function(index, el){
			order.push(parseInt($(el).find("input[name=element_id]").val(), 10));
		});
		_el.model.setListOrder(order);
	};

	_el.reloadContractFiles = function(contract)
	{
		_el.model.each(function(element){
			element.interface.tabs.contract.reloadOthers(contract);
		});
	};
	
	_el.reloadContractNotes = function(contract)
	{
		_el.model.each(function(element){
			element.interface.tabs.contract.reloadOthers(contract);
		});
	};

	return function()
	{
		_el.template = $("#slr-element-template").clone().removeAttr("id");
		_el.existing_contracts = _el.template.find(".select-plus-new").data("existing-contracts");
		$("#slr-element-template").remove();
		$("#slr-elements-container").sortable({
			helper : 'clone',
			stop : _el.elements_sorted,
			handle : '.drag-element-button',
			start: function(e, ui ){
			     ui.placeholder.height(ui.helper.outerHeight());
			},
		});
		_el.interface.add_button.on("click", _el.add_element);
		if (_el.interface.container.find(".slr-el").length) {
			_el.interface.container.find(".slr-el").each(function(){
				var loadedElement = $(this).Element(_el);
				_el.model.addElement(loadedElement);
			});
		} else {
			_el.interface.add_button.click();
		}
		return _el;
	}();
};

function SLR_Contract(_ctr)
{
	// parent element
	var self = this;
	self.ctr = _ctr;
	self.item = {};
	self.action = undefined;
	self.action_callback = undefined;

	self.reset = function() {
		self.item = {
			id: undefined,
			contact_id: undefined,
			str_id: undefined,
			fonction: undefined,
			jours_tournage: 0,
			emissions_episodes: 0,
			banque: 0,
			banque_details: '',
			note: '',
			cachet: 0,
			cachet_total: 0,
			droits_percent: 0,
			droits_total: 0,
			garanties: [],
			deleted: false
		};
	};

	self.save = function()
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contract");
		request.append("action", "auto");
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.create = function(new_str_id)
	{
		// gather data
		self.reset();
		self.action = "create";
		self.item.contact_id = self.ctr.e.el.form.get_contact_id();
		self.item.str_id = new_str_id;
		self.save();
		return false;
	};

	self.rename = function(new_str_id, action_callback)
	{
		self.action = "rename";
		self.action_callback = action_callback;
		self.item.str_id = new_str_id;
		self.save();
		return false;
	}

	self.get = function(contract_id)
	{
		// gather data
		self.reset();
		self.item.id = contract_id;
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contract");
		request.append("action", "get");
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.loaded);
		return false;
	};

	self.loaded = function(x)
	{
		// load contract file
		self.item = x.item;
		self.ctr.load_files();

		// elements list and contract button actions
		var elements_list = self.parse_elements_list(x.elements);
		_ctr.interface.rename_btn.prop("disabled", false);
		_ctr.interface.clipboard_btn.prop("disabled", false);
		_ctr.interface.delete_btn.prop("disabled", elements_list.length);

		// display importable rows
		_ctr.contract_table.load(elements_list);
	};

	self.delete = function(action_callback)
	{
		self.action = "delete";
		self.action_callback = action_callback;
		self.item.deleted = 1;
		self.save();
		return false;
	};

	self.callback = function(x)
	{
		// get the current callback action
		var action = self.action;
		self.action = undefined;

		// created contract
		if (action == "create"){
			if (x == undefined){	// did not work
				self.ctr.interface.select2.val(0).trigger("change");
			} else {
				self.item = x.item;
				self.ctr.created(self.item);
				self.ctr.load_files();
				_ctr.interface.rename_btn.prop("disabled", false);
				_ctr.interface.clipboard_btn.prop("disabled", false);
				_ctr.interface.delete_btn.prop("disabled", false);
			}

			// renamed contract
		} else if (action == "rename"){
			self.action_callback(x);
			self.ctr.e.contractRenamed();

			// deleted contract
		} else if (action == "delete"){
			self.action_callback(x);
			self.ctr.e.contractDeleted();

		} else {
			self.ctr.e.contractChanged();
		}
	};

	self.parse_elements_list = function(elements_list)
	{
		var parsed_elements_list = [];
		elements_list.forEach(function(element, index){
			// all return 1
			if (element.invoice_id != self.ctr.e.el.form.getInvoiceID() && element.type == self.ctr.e.el.form.get_invoice_type()){
				parsed_elements_list.push(element);
			}
		});
		return parsed_elements_list;
	};

	self.init = function()
	{
		self.reset();
		if (self.ctr.find("select[name=contract_id]").val()){
			self.item.id = parseInt(self.ctr.find("select[name=contract_id]").val(), 10);
		}
	}();
}

$.fn.Contract = function(_e)
{
	var _ctr = this;
	_ctr.e = _e;
	_ctr.model = new SLR_Contract(_ctr);
	_ctr.form = _ctr.find("form.contract");
	_ctr.interface = {
		select : _ctr.find("select[name=contract_id]"),
		select2 : undefined,
		contract_files : _ctr.find(".contract-files-cell"),
		contract_notes : _ctr.find(".contract-notes-cell"),
		contract_comment : _ctr.find(".contract-comment-cell"),
		element_files : _ctr.find(".element-files-cell"),
		element_timesheets : _ctr.find(".element-timesheet-cell"),
		action_buttons : _ctr.find(".contract-actions"),
		rename_btn : _ctr.find("button[data-action='rename-contract']"),
		delete_btn : _ctr.find("button[data-action='delete-contract']"),
		clipboard_btn : _ctr.find("button[data-action='copy-contract']"),
		next_tab_btn : _ctr.find("button[data-action='next-tab']")
	};
	_ctr.uploader = {
		contract : undefined,
		element : undefined
	};
	_ctr.contract_table = undefined;
	_ctr.element_files_loaded = false;

	_ctr.changed = function()
	{
		// reset files for now
		_ctr.uploader.contract.reset();
		_ctr.uploader.notes.reset();
		_ctr.find('textarea[name="note"]').prop('disabled', true).val('');

		// disable buttons for now
		_ctr.interface.rename_btn.prop("disabled", true);
		_ctr.interface.delete_btn.prop("disabled", true);
		_ctr.interface.clipboard_btn.prop("disabled", true);

		// action
		if ($(this).val() !== "0" && _ctr.e.el.existing_contracts.indexOf($(this).val()) === -1){
			swal({
				title: "Nouveau contrat?",
				text: "Voulez-vous créer un nouveau contrat avec l'identifiant " + $(this).val() + " ?",
				type: "warning",
				showCancelButton: true,
				confirmButtonClass: "btn-info",
				confirmButtonText: "Oui, créer le contrat",
				cancelButtonText: "Non",
				closeOnConfirm: true,
				closeOnCancel: true
			},
			function(isConfirm) {
				if (isConfirm) {
					var new_str_id = _ctr.find("select[name=contract_id] option:selected").text();
					if (new_str_id == "Pas de contrat (N/D)") {
						new_str_id = _ctr.find("select[name=contract_id] option:selected").val();
					}
					_ctr.model.create(new_str_id);
				} else {
					_ctr.interface.select2.val(0).trigger("change");
				}
			});
		} else if ($(this).val() === "0"){
			_ctr.model.reset();
			_ctr.e.set("contract_id", "NULL");
			_ctr.uploader.contract.reset();
			_ctr.uploader.notes.reset();
			_ctr.contract_table.reset();
			_ctr.interface.action_buttons.attr("aria-hidden", "true");
			_ctr.e.contractUpdated();
		} else {
			var contract_id = parseInt($(this).val(), 10);
			_ctr.interface.action_buttons.attr("aria-hidden", "false");
			_ctr.model.get(contract_id);
			_ctr.e.set("contract_id", contract_id);
			_ctr.e.contractUpdated();
		}
	};

	_ctr.created = function(item)
	{
		// add the option in dropdown
		_ctr.e.el.existing_contracts.push(item.id);
		_ctr.interface.select.find('option[value="' + item.str_id + '"]').remove();
		_ctr.interface.select.append($('<option value="' + item.id + '">' + item.str_id + '</option>').prop("selected", true));
		_ctr.interface.select.change();

		// affect the template
		_ctr.e.el.template.find(".select-plus-new").replaceWith(_ctr.interface.select.clone());
		_ctr.interface.action_buttons.attr("aria-hidden", "false");
		_ctr.interface.rename_btn.prop("disabled", false);
		_ctr.interface.delete_btn.prop("disabled", false);
		_ctr.interface.clipboard_btn.prop("disabled", false);

		// affect other elements
		_ctr.e.contractCreated();
	};

	_ctr.get_id = function() // for uploader
	{
		return _ctr.getContractID();
	};

	_ctr.getContractID = function()
	{
		return _ctr.model.item.id;
	};

	_ctr.load_files = function()
	{
		// load contrat file
		_ctr.uploader.contract.reset();
		_ctr.uploader.notes.reset();

		$.ajax("/facture/contract_files/" + _ctr.get_id() + "/" + "491", {
			data: {},
			dataType: 'html',
			complete: function(x) {
				var response = $('<html></html>').html(x.responseText);

				// Contract file
				_ctr.interface.contract_files.replaceWith(response.find(".contract-files-cell"));
				_ctr.interface.contract_files = _ctr.find(".contract-files-cell");
				_ctr.init_contract_uploader();

				// Contract notes
				_ctr.interface.contract_notes.replaceWith(response.find(".contract-notes-cell"));
				_ctr.interface.contract_notes = _ctr.find(".contract-notes-cell");
				_ctr.init_notes_uploader();

				// Contract comment
				if (response.find(".contract-comment-cell").length) {
					_ctr.interface.contract_comment.replaceWith(response.find(".contract-comment-cell"));
					_ctr.interface.contract_comment = _ctr.find(".contract-comment-cell");
					_ctr.init_comment_field();
				}
			}
		});
	};

	_ctr.load_element_files = function()
	{
		// load element files
		if (!_ctr.element_files_loaded){ // only once on load or when ID is assigned
			$.ajax("/facture/element_files/" + _ctr.e.getElementID(), {
				data: {},
				dataType: 'html',
				complete: function(x) {
					_ctr.interface.element_files.replaceWith($(x.responseText).filter('.element-files-cell'));
					_ctr.interface.element_files = _ctr.find(".element-files-cell");
					_ctr.interface.element_timesheets.replaceWith($(x.responseText).filter('.element-timesheet-cell'));
					_ctr.interface.element_timesheets = _ctr.find(".element-timesheet-cell");
					_ctr.init_element_uploader();
					_ctr.init_file_draggables();
					_ctr.interface.element_files.fadeIn("fast");
					_ctr.interface.element_timesheets.fadeIn("fast");
				}
			});
			_ctr.element_files_loaded = true;
		}
	};

	_ctr.reloadOthers = function(source_contract)
	{
		// load inside if right id
		if (_ctr.model.item.id == source_contract.get_id() && _ctr != source_contract){
			_ctr.interface.contract_files.load("/facture/contract_files/" + source_contract.get_id(), {}, function(){
				_ctr.init_contract_uploader();
				_ctr.init_contract_draggables();
				_ctr.interface.contract_files.fadeIn("fast");
			});
			_ctr.interface.contract_notes.load("/facture/contract_notes/" + source_contract.get_id(), {}, function(){
				_ctr.init_notes_uploader();
				_ctr.init_contract_draggables();
				_ctr.interface.contract_notes.fadeIn("fast");
			});
		}
	};

	_ctr.init_contract_uploader = function()
	{
		// file uploaders
		_ctr.uploader.contract = _ctr.find(".contract-files-upload").Uploader({
			parent: _ctr,
			model : 'contract',
			type: 'file',
			id : _ctr.get_id(),
			str_id : _ctr.model.item.str_id,
			multiple: true,
			callback : function(){
				_ctr.e.el.reloadContractFiles(_ctr);
			}
		});
		_ctr.init_contract_draggables()
	};

	_ctr.init_notes_uploader = function()
	{
		// file uploaders
		_ctr.uploader.notes = _ctr.find(".contract-notes-upload").Uploader({
			parent: _ctr,
			model : 'contract',
			type: 'note',
			id : _ctr.get_id(),
			str_id : _ctr.model.item.str_id,
			multiple: true,
			callback : function(){
				_ctr.e.el.reloadContractNotes(_ctr);
			}
		});
		_ctr.init_contract_draggables()
	};

	_ctr.init_element_uploader = function()
	{
		if (_ctr.e.getElementID()){
			// real element uploader with element id
			_ctr.uploader.element = _ctr.find(".element-file-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : _ctr.e.getElementID(),
				multiple: true,
				type: 'file',
			});
			_ctr.uploader.timesheet = _ctr.find(".element-timesheet-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : _ctr.e.getElementID(),
				multiple: true,
				type: 'timesheet',
			});
		} else {
			// dummy and disabled element uploader just for looks
			_ctr.uploader.element = _ctr.find(".element-file-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : 0,
				multiple: false,
				type: 'file',
			});
			_ctr.uploader.timesheet = _ctr.find(".element-timesheet-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : 0,
				multiple: false,
				type: 'timesheet',
			});
			_ctr.uploader.element.disable();
			_ctr.uploader.timesheet.disable();
		}
	};

	_ctr.init_file_draggables = function() {
		_ctr.find('.element-files-cell, .element-timesheet-cell').each(function() {
			let $cell = $(this),
			type = $(this).hasClass('element-timesheet-cell') ? 'timesheet' : 'file'
			if (!$cell.data('is-droppable-initialized')) {
				$cell.droppable({
					accept: 'a',
					drop: function(event, ui) {
						$.ajax({
							url: '/fichier/api/',
							type: 'POST',
							data: {
								object_type: 'file',
								file_action: 'element_' + type,
								element_id: _ctr.e.getElementID(),
								file_id: ui.draggable.data('value'),
								attachment_id: ui.draggable.data('attachment'),
							},
							dataType: 'json',
							success: function (response) {
								let $newFile = $('<div class="file-holder" data-file-id="' + ui.draggable.data('attachment') + '"><label class="mb-0"><a href="' + ui.draggable.attr('href') + '" target="_blank">' + ui.draggable.text() + '</a></label><button class="btn btn-sm btn-link btn-action-upload-delete"><span class="material-symbols-outlined">delete</span></button></div>'),
								attachment_id = ui.draggable.data('attachment')
								$newFile.find('.btn-action-upload-delete').on('click', function() {
									swal({
										title: "Êtes-vous certain?",
										text: "Voulez-vous vraiment supprimer ce fichier?",
										type: "warning",
										showCancelButton: true,
										confirmButtonClass: "btn-danger",
										confirmButtonText: "Oui, supprimer le fichier",
										cancelButtonText: "Non",
										closeOnConfirm: true,
										closeOnCancel: true
									},
									function(isConfirm) {
										if (isConfirm) {
											$newFile.fadeOut("fast");
											var request = new FormData();
											request.append("model", 'element');
											request.append("type", type);
											request.append("action", "delete_file");
											request.append("data", JSON.stringify({
												id : _ctr.e.getElementID(),
												file_id : attachment_id,
												index: 0,
											}));
											$.slr.db.add(request);
										}
									});
									return false;
								})
								$cell.find('.files').append($newFile)
							},
						})
					},
				});
				$cell.data('is-droppable-initialized', 1)
			}
		})
	}

	_ctr.init_contract_draggables = function() {
		_ctr.find('.contract-files-cell, .contract-notes-cell').each(function() {
			let $cell = $(this),
			type = $(this).hasClass('contract-notes-cell') ? 'note' : 'file'
			if (!$cell.data('is-droppable-initialized')) {
				$cell.droppable({
					accept: 'a',
					drop: function(event, ui) {
						$.ajax({
							url: '/fichier/api/',
							type: 'POST',
							data: {
								object_type: 'file',
								file_action: 'contract_' + type,
								contract_id: _ctr.getContractID(),
								file_id: ui.draggable.data('value'),
								attachment_id: ui.draggable.data('attachment'),
							},
							dataType: 'json',
							success: function (response) {
								let $newFile = $('<div class="file-holder" data-file-id="' + ui.draggable.data('attachment') + '"><label class="mb-0"><a href="' + ui.draggable.attr('href') + '" target="_blank">' + ui.draggable.text() + '</a></label><button class="btn btn-sm btn-link btn-action-upload-delete"><span class="material-symbols-outlined">delete</span></button></div>'),
								attachment_id = ui.draggable.data('attachment')
								$newFile.find('.btn-action-upload-delete').on('click', function() {
									swal({
										title: "Êtes-vous certain?",
										text: "Voulez-vous vraiment supprimer ce fichier?",
										type: "warning",
										showCancelButton: true,
										confirmButtonClass: "btn-danger",
										confirmButtonText: "Oui, supprimer le fichier",
										cancelButtonText: "Non",
										closeOnConfirm: true,
										closeOnCancel: true
									},
									function(isConfirm) {
										if (isConfirm) {
											$newFile.fadeOut("fast");
											var request = new FormData();
											request.append("model", 'contract');
											request.append("type", type);
											request.append("action", "delete_file");
											request.append("data", JSON.stringify({
												id : _ctr.getContractID(),
												file_id : attachment_id,
												index: 0,
											}));
											$.slr.db.add(request);
										}
									});
									return false;
								})
								$cell.find('.files').append($newFile)
							},
						})
					},
				});
				$cell.data('is-droppable-initialized', 1)
			}
		})
	}

	_ctr.init_comment_field = function() {
		_ctr.find('textarea[name="note"]').off('change').on('change', function() {
			_ctr.model.item.note = $(this).val();
			_ctr.model.save();
		});
	};

	_ctr.clipboard_contract = function() {
		var input = $('<input type="text">');
		input.val(_ctr.find('.select2-selection__rendered').text());
		$('body').append(input);
		input.select();
		document.execCommand("copy");
		input.remove();
	}

	_ctr.rename_contract = function()
	{
		swal({
			title: "Renommer le contrat",
			text: "Veuillez entrer le numéro de contrat désiré.\nCeci modifiera le contrat partout.",
			type: "input",
			customClass: "rename-contract-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-warning",
			confirmButtonText: 'Renommer',
			closeOnConfirm: true,
			inputPlaceholder: "Nouveau numéro"
		}, function (inputValue){
			if (inputValue){
				_ctr.model.rename(inputValue, function(x){
					if (x.success == 1){
						_ctr.interface.select.find('option[value="' + x.item.id + '"]').remove();
						_ctr.interface.select.append($('<option value="' + x.item.id + '">' + x.item.str_id + '</option>').prop("selected", true));
						_ctr.interface.select.change();
					} else {
						// didn't get permission
						swal({
							title: "Erreur",
							text: "Une erreur s'est produite lors du renommage.",
							type: "error",
							confirmButtonClass: "btn-danger"
						});
					}
				});
			}
		});
		$(".rename-contract-swal").find(".form-control").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_ctr.delete_contract = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer ce contrat?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer le contrat",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_ctr.model.delete(function(x){
					if (x.success == 1){
						_ctr.interface.select.find('option[value="' + x.item.id + '"]').remove();
						_ctr.interface.select.change();
					}
				});
			}
		});
		return false;
	};

	return function()
	{
		// initialize contract selector
		_ctr.interface.select2 = _ctr.interface.select.select2({
			tags: true
		});
		_ctr.interface.select.on("change", _ctr.changed);
		if (_ctr.data("focus-contract") == true){
			_ctr.interface.select.select2('open');
		}

		// do not submit form
		_ctr.form.on("submit", function(){
			return false;
		});

		// init file uploaders
		_ctr.init_contract_uploader();
		_ctr.init_notes_uploader();
		_ctr.init_element_uploader();
		_ctr.init_comment_field();
		_ctr.init_file_draggables();
		_ctr.init_contract_draggables();

		// open in window rather than tab
		_ctr.on('click', '.file-holder a', function() {
			window.open($(this).attr('href'), '_blank', `width=${screen.width * 3/5},height=${screen.height},scrollbars=yes,toolbar=no,location=no`);
			return false
		})

		// init buttons
		_ctr.interface.rename_btn.on("click", _ctr.rename_contract);
		_ctr.interface.delete_btn.on("click", _ctr.delete_contract);
		_ctr.interface.clipboard_btn.on("click", _ctr.clipboard_contract);
		_ctr.interface.next_tab_btn.on("click", function(){
			_ctr.e.reachTab($('body').hasClass('solis') ? 2 : 1);
			return false;
		});

		// init importable rows table
		_ctr.contract_table = _ctr.find("#import-contract-table").ContractTable(_ctr);

		// load model at start
		if (_ctr.interface.select.val() !== "0"){
			var contract_id = parseInt(_ctr.interface.select.val(), 10);
			_ctr.model.get(contract_id);
			_ctr.interface.action_buttons.attr("aria-hidden", "false");
		} else {
			_ctr.uploader.contract.disable();
			_ctr.uploader.notes.disable();
		}
		return _ctr;
	}();
};

$.fn.ContractTable = function(_ctr)
{
	var _ct = this;
	_ct.ctr = _ctr;

	_ct.load = function(elements_list)
	{
		// empty
		_ct.reset();

		// load each element list
		elements_list.forEach(function(element, index){
			var contract_row = $('#template-import-contract-row').clone().ContractRow(_ct);
			contract_row.load(element);
			_ct.find("tbody").append(contract_row);
		});

		// make visible
		if (elements_list.length){
			_ct.show();
		}
	};

	_ct.reset = function()
	{
		_ct.find("tbody tr").remove();
		_ct.hide();
	};

	return function()
	{
		_ct.reset();
		return _ct;
	}();
}

$.fn.ContractRow = function(_ctr)
{
	var _cr = this;
	_cr.ctr = _ctr;
	_cr.interface = {
		import_button : _cr.find("button[data-action='import-options-list']")
	};

	_cr.load = function(element)
	{
		_cr.interface.import_button.data("config_name", element.config);
		_cr.interface.import_button.data("options_list", element.options_list);
		_cr.find(".cell-invoice-id").text(element.invoice.str_id);
		_cr.find(".cell-invoice-date").text(element.display_date);
		_cr.find(".cell-invoice-reference").text(element.invoice.reference);
		var fee = asFloat(element.fee);
		_cr.find(".cell-invoice-fee").text(fee.toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		if (element.config == 'inm_2016') {
			_cr.find(".cell-invoice-cycle").text('');
		} else {
			_cr.find(".cell-invoice-cycle").text(element.cycle);
		}
		_cr.find(".cell-invoice-cycle_dates").text(element.display_cycle_dates);
		_cr.find(".cell-config-display").text(element.display_config);
		_cr.find(".preview-link").attr("href", "/facture/previsualiser/" + element.invoice.id);
	};

	_cr.import = function()
	{
		// import
		_cr.ctr.ctr.e.interface.tabs.fee.import($(this).data("config_name"), $(this).data("options_list"));

		// next tab
		_cr.ctr.ctr.e.reachTab(1);

		// success notification
		$.slr.notify({
			icon: 'fa fa-check',
			title: "Liste d'options importées",
			message: "La liste d'options a été importée depuis un autre élément du même contrat."
		}, { type: 'success' });
	};

	return function()
	{
		_cr.interface.import_button.on("click", _cr.import);
		return _cr;
	}();
};

function SLR_OptionsList(_fee)
{
	/* Properties */
	var self = this;
	self.fee = _fee;
	self.item = {
		nb_annonces: undefined,
		// nb_supp: undefined,
		duration: undefined,
		circuit: undefined,
		use: undefined,
		use2: undefined,
		role: undefined,
		cond_percent: undefined,
		cond_negociee: undefined,
		cond_diff_percent: undefined,
		cond_diff_negociee: undefined,
		'option[post-synchro]': undefined,
		'option[saisonniere]': undefined,
		'option[panneau]': undefined,
		'option[remise]': undefined,
		'option[upgrade]': undefined,
		'option[une-station]': undefined,
		'option[combine]': undefined,
		upgrade_duration: undefined,
		upgrade_use: undefined,
		upgrade_use2: undefined,
		inm_diffusion: undefined,
		inm_duration: undefined,
		apc_tableau: undefined,
	};

	self.getOptionsList = function()
	{
		return JSON.stringify(self.item);
	};
}

$.fn.FeeCalculator = function(_e)
{
	var _fee = this;
	_fee.e = _e;
	_fee.form = _fee.find("form");
	_fee.model = new SLR_OptionsList(_fee);
	_fee.interface = {
		duration_field : _fee.find("select[name=duration]"),
		inm_duration_field : _fee.find("select[name=inm_duration]"),
		cycle_start_field : _fee.find("input[name=cycle_date1]"),
		cycle_end_field : _fee.find("input[name=cycle_date2]"),
		cycle_start_dp : undefined,
		upgrade : _fee.find(".slr-upgrade"),
		next_tab_btn : _fee.find("button[data-action='next-tab']")
	};
	_fee.baseFee = 0.00;
	_fee.upgradeFee = 0.00;
	_fee.broadcastFee = 0.00;

	_fee.calc = {
		cycle_duration: function()
		{
			var date1 = _fee.interface.cycle_start_dp.date();
			if (date1 != null){
				if (_fee.e.getConventionType() == "apc"){
					var cycleDuration = parseInt(_fee.interface.duration_field.val(), 10),
					date2 = date1.add(cycleDuration, 'days');
					_fee.interface.cycle_end_field.val(date2.format("DD-MM-YYYY")).change();
				} else if (_fee.e.getConventionType() == "inm"){
					var cycleDuration = parseInt(_fee.interface.inm_duration_field.val(), 10),
					date2 = date1.add(cycleDuration, 'days');
					_fee.interface.cycle_end_field.val(date2.format("DD-MM-YYYY")).change();
				}
			}
		},
		loaded: function()
		{
			// check boxes - only in active convention
			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			activeConv.find(".input-checked input").prop("checked", true);
			_fee.calc.update_item();
		},
		update_item: function()
		{
			// loaded options to model
			_fee.model.item["nb_annonces"] = _fee.get_value("nb_annonces");
			// _fee.model.item["nb_supp"] = _fee.get_value("nb_supp");
			_fee.model.item["duration"] = _fee.get_value("duration");
			_fee.model.item["circuit"] = _fee.get_value("circuit");
			_fee.model.item["use"] = _fee.get_value("use");
			_fee.model.item["use2"] = _fee.get_value("use2");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["cond_percent"] = _fee.get_value("cond_percent");
			_fee.model.item["cond_negociee"] = _fee.get_value("cond_negociee");
			_fee.model.item["cond_diff_percent"] = _fee.get_value("cond_diff_percent");
			_fee.model.item["cond_diff_negociee"] = _fee.get_value("cond_diff_negociee");
			_fee.model.item["option[post-synchro]"] = _fee.get_value("option[post-synchro]");
			_fee.model.item["option[saisonniere]"] = _fee.get_value("option[saisonniere]");
			_fee.model.item["option[panneau]"] = _fee.get_value("option[panneau]");
			_fee.model.item["option[remise]"] = _fee.get_value("option[remise]");
			_fee.model.item["option[upgrade]"] = _fee.get_value("option[upgrade]");
			_fee.model.item["option[une-station]"] = _fee.get_value("option[une-station]");
			_fee.model.item["option[combine]"] = _fee.get_value("option[combine]");
			_fee.model.item["upgrade_use"] = _fee.get_value("upgrade_use");
			_fee.model.item["upgrade_use2"] = _fee.get_value("upgrade_use2");
			_fee.model.item["upgrade_duration"] = _fee.get_value("upgrade_duration");
			_fee.model.item["inm_diffusion"] = _fee.get_value("inm_diffusion");
			_fee.model.item["inm_duration"] = _fee.get_value("inm_duration");
			_fee.model.item["apc_tableau"] = _fee.get_value("apc_tableau");
		},
		default: function(circuit_name)
		{
			// enabled divs according to convention config
			_fee.find(".conv").hide().addClass("conv-inactive");
			_fee.find(".conv.conv-" + _fee.e.getConventionName()).css('display', '').removeClass("conv-inactive");

			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			if (circuit_name == "start") {
				if (_fee.e.getConventionName() == 'apc_2024' || _fee.e.getConventionName() == 'apc_2025' || _fee.e.getConventionName() == 'apc_2026') {
					activeConv.find("input[name=tableau][value=t_a]").prop("checked", true);
					activeConv.find("input[name=circuit][value=internet]").prop("checked", true);
					activeConv.find("input[name=role][value=vhc]").prop("checked", true);
				} else {
					activeConv.find("input[name=circuit][value=radio]").prop("checked", true);
					activeConv.find("input[name=use][value=general]").prop("checked", true);
					activeConv.find("input[name=use2][value=reseau]").prop("checked", true);
					activeConv.find("input[name=role][value=vhc]").prop("checked", true);
				}
			} else if (circuit_name == "cinema"){
				activeConv.find("input[name=use][value=intermediaire]").prop("checked", true);
				activeConv.find("input[name=use2][value=eclair]").prop("checked", true);
			} else if (circuit_name == "internet"){
				activeConv.find("input[name=use][value=local]").prop("disabled", false).prop("checked", true);
			} else if (circuit_name == "publication"){
				//
			} else if (circuit_name == "ferme"){
				activeConv.find("input[name=use][value=local]").prop("checked", true);
			}

			// load initial options into model
			_fee.model.item["nb_annonces"] = _fee.get_value("nb_annonces");
			_fee.model.item["duration"] = _fee.get_value("duration");
			_fee.model.item["circuit"] = _fee.get_value("circuit");
			_fee.model.item["use"] = _fee.get_value("use");
			_fee.model.item["use2"] = _fee.get_value("use2");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["cond_percent"] = _fee.get_value("cond_percent");
			_fee.model.item["cond_negociee"] = _fee.get_value("cond_negociee");
			_fee.model.item["cond_diff_percent"] = _fee.get_value("cond_diff_percent");
			_fee.model.item["cond_diff_negociee"] = _fee.get_value("cond_diff_negociee");
			_fee.model.item["option[post-synchro]"] = _fee.get_value("option[post-synchro]");
			_fee.model.item["option[saisonniere]"] = _fee.get_value("option[saisonniere]");
			_fee.model.item["option[panneau]"] = _fee.get_value("option[panneau]");
			_fee.model.item["option[remise]"] = _fee.get_value("option[remise]");
			_fee.model.item["option[upgrade]"] = _fee.get_value("option[upgrade]");
			_fee.model.item["option[une-station]"] = _fee.get_value("option[une-station]");
			_fee.model.item["option[combine]"] = _fee.get_value("option[combine]");
			_fee.model.item["upgrade_use"] = _fee.get_value("upgrade_use");
			_fee.model.item["upgrade_use2"] = _fee.get_value("upgrade_use2");
			_fee.model.item["upgrade_duration"] = _fee.get_value("upgrade_duration");
			_fee.model.item["inm_diffusion"] = _fee.get_value("inm_diffusion");
			_fee.model.item["inm_duration"] = _fee.get_value("inm_duration");
			_fee.model.item["apc_tableau"] = _fee.get_value("apc_tableau");
		},
		enabled: function()
		{
			// enabled divs according to convention config
			_fee.find(".conv").hide().addClass("conv-inactive");
			_fee.find(".conv.conv-" + _fee.e.getConventionName()).css('display', '').removeClass("conv-inactive");
			_fee.attr('data-convention', _fee.e.getConventionName())

			// enabled field according to circuit
			var circuit = _fee.get_value('circuit');
			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			activeConv.find("input[type=radio]").prop("disabled", false);
			activeConv.find("input[type=checkbox]").prop("disabled", false);

			/* INM */
			if (_fee.e.getConventionType() == "inm"){
				activeConv.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);

				/* APC 2024 */
			} else if (_fee.e.getConventionName() == 'apc_2024' || _fee.e.getConventionName() == 'apc_2025' || _fee.e.getConventionName() == 'apc_2026') {
				var tableau = _fee.get_value('apc_tableau'),
				fees = _fee.find('.conv-' + _fee.e.getConventionName()).not('.conv-inactive'),
				initial = {
					role: _fee.get_value('role'),
					circuit: _fee.get_value('circuit'),
					use: _fee.get_value('use'),
				}

				if (tableau == 'none') {
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=tv]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=internet]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_a' || tableau == 't_b' || tableau == 't_c' || tableau == 't_aa') {
					fees.find("input[name=circuit][value=radio]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=cinema]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=publication]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=ferme]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_a' || tableau == 't_b'|| tableau == 't_c') {
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_aa') {
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", false);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				}
				if (circuit == 'radio') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=ap]").prop("checked", false);
					fees.find("input[name=role][value=vhc]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=vhcap]").prop("checked", true);
					fees.find("input[name=role][value=muet]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=fp]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == 'tv') {
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					if (tableau == 't_aa') {
						fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
						fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					} else if (tableau != 't_aa') {
						fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					}
					if (tableau == 't_b' || tableau == 't_c') {
						fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					}
				} else if (circuit == 'cinema' || circuit == 'publication' || circuit == 'ferme') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == 'internet') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					if (tableau != 't_aa') {
						fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					}
				}
				if (circuit == 'publication') {
					fees.find("input[name=use]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
				}

				/* keep initial role if still available */
				if (fees.find('input[name="role"][value="' + initial.role + '"]').prop('disabled') === false) {
					fees.find('input[name="role"][value="' + initial.role + '"]').prop('checked', true)
				}
				if (fees.find('input[name="use"][value="' + initial.use + '"]').prop('disabled') === false) {
					fees.find('input[name="use"][value="' + initial.use + '"]').prop('checked', true)
				}
				if (fees.find('input[name="circuit"][value="' + initial.circuit + '"]').prop('disabled') === false) {
					fees.find('input[name="circuit"][value="' + initial.circuit + '"]').prop('checked', true)
				}

				/* par défaut si rien sélectionné */
				if (tableau == 'none') {
					if (_fee.get_value('circuit') == undefined) {
						fees.find('input[name="circuit"][value="radio"]').prop('checked', true).trigger('change')
						fees.find('input[name="use"][value="general"]').prop('checked', true).trigger('change')
					}
					if (_fee.get_value('role') == undefined) {
						fees.find('input[name="role"][value="ap"]').prop('checked', true).trigger('change')
					}
				}

				/* APC 2021-2024 */
			} else {
				var fees = _fee.find('.conv-' + _fee.e.getConventionName()).not('.conv-inactive')
				if (circuit == "radio"){
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=muet]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=fp]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "tv"){
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
				} else if (circuit == "cinema"){
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=local]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "internet"){
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "publication"){
					fees.find("input[name=use]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[saisonniere]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[panneau]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[remise]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "ferme"){
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				}
			}

			// number label
			if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[panneau]']").prop('checked') == true){
				_fee.find("label[for=nb_annonces]").text("panneau(x)");
			} else if (circuit == "publication"){
				_fee.find("label[for=nb_annonces]").text("publication(s)");
			} else {
				_fee.find("label[for=nb_annonces]").text("annonce(s)");
			}

			// Récupération des références sur les deux selects et de la valeur actuellement sélectionnée
			var durationSelect = _fee.find('select[name=duration]'),
			upgradeDurationSelect = _fee.find('select[name=upgrade_duration]');
			var currentValue = _fee.interface.duration_field.val();

			// Sauvegarder les options originales pour chacun (si ce n'est pas déjà fait)
			if (!durationSelect.data('originalOptions')) {
				durationSelect.data('originalOptions', durationSelect.html());
			}
			if (!upgradeDurationSelect.data('originalOptions')) {
				upgradeDurationSelect.data('originalOptions', upgradeDurationSelect.html());
			}

			// Traitement spécifique pour la convention apc_2024, apc_2025, apc_2026
			let select90 = false
			if (_fee.getConventionName() === 'apc_2024' || _fee.getConventionName() === 'apc_2025' || _fee.getConventionName() === 'apc_2026') {
				if (tableau === "none") {
					durationSelect.html(durationSelect.data('originalOptions'));
					_fee.interface.duration_field.selectpicker('refresh');
					// Select 90 days by default (same as tableau A)
					if (currentValue !== "90") {
						select90 = true;
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				} else if (tableau === "t_aa" || tableau === "t_c") {
					if (durationSelect.find('option[value="365"]').length === 0) {
						durationSelect.append('<option value="365">1 an</option>');
					}
					durationSelect.find('option').each(function(){
						if ($(this).val() !== "365") {
							$(this).remove();
						}
					});
					_fee.interface.duration_field.selectpicker('refresh');
					if (currentValue !== "365") {
						_fee.interface.duration_field.selectpicker('val', "365");
					}
				} else if (tableau === "t_a" || tableau === "t_b") {
					var allowed = ["7", "14", "21", "90"];
					durationSelect.find('option').each(function(){
						if ($.inArray($(this).val(), allowed) === -1) {
							$(this).remove();
						}
					});
					var labels = {
						"7": "7 jours",
						"14": "14 jours",
						"21": "21 jours",
						"90": "90 jours"
					};
					allowed.forEach(function(val) {
						if (durationSelect.find('option[value="'+val+'"]').length === 0) {
							durationSelect.append('<option value="'+val+'">'+labels[val]+'</option>');
						}
					});
					_fee.interface.duration_field.selectpicker('refresh');
					if ($.inArray(currentValue, allowed) === -1) {
						select90 = true
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				}
			} else {
				var hasOneYearOption = (durationSelect.find('option[value="365"]').length > 0);
				var shouldHaveOneYearOption = ((_fee.getConventionName() === 'apc_2024' || _fee.getConventionName() === 'apc_2025' || _fee.getConventionName() === 'apc_2026') || circuit === 'internet');
				if (hasOneYearOption && !shouldHaveOneYearOption)  {
					var wasOneYear = (currentValue === "365");
					durationSelect.find('option[value="365"]').remove();
					_fee.interface.duration_field.selectpicker('refresh');
					if (wasOneYear) {
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				} else if (!hasOneYearOption && shouldHaveOneYearOption) {
					durationSelect.append('<option value="365">1 an</option>');
					_fee.interface.duration_field.selectpicker('refresh');
				}
			}

			upgradeDurationSelect.html(durationSelect.html());
			upgradeDurationSelect.selectpicker('refresh');
			if (select90) { requestAnimationFrame(function() {
				upgradeDurationSelect.selectpicker('val', "90");
			}) }


			// upgrade interface
			if (_fee.find(".conv.conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[upgrade]']").prop('checked') == true && _fee.e.getConventionType() == "apc"){
				_fee.interface.upgrade.fadeIn("fast");
			} else {
				_fee.interface.upgrade.fadeOut("fast");
			}
		},
		option: function(path)
		{
			var value = 0;
			if (path.length == 1){
				value = asFloat(_fee.e.getConventionData().options[path[0]]);
			} else if (path.length == 2){
				value = asFloat(_fee.e.getConventionData().options[path[0]][path[1]]);
			}
			if (isNaN(value)){
				value = 0;
			}
			return value;
		},
		base_fee: function()
		{
			// calculate base fee
			var	base_fee = _fee.calc.dig(_fee.e.getConventionData(), 'base'),
			mod_fee = _fee.calc.mod(base_fee, 'base');

			// fee can't be under zero
			if (mod_fee < 0){
				mod_fee = 0;
			}
			return mod_fee;
		},
		upgrade_fee: function()
		{
			// calculate upgrade fee
			var upgrade_fee = _fee.calc.dig(_fee.e.getConventionData(), 'upgrade'),
			mod_fee = _fee.calc.mod(upgrade_fee, 'upgrade'),
			displayed_fee = mod_fee - _fee.baseFee;

			// upgrade can't be under zero
			if (displayed_fee < 0){
				displayed_fee = 0;
			}
			return displayed_fee;
		},
		broadcast_fee: function()
		{
			// calculate broadcast fee
			var broadcast_fee = _fee.calc.dig(_fee.e.getConventionData(), 'broadcast'),
			mod_fee = _fee.calc.mod(broadcast_fee, 'broadcast');

			// broadcast can't be under zero
			if (mod_fee < 0){
				mod_fee = 0;
			}
			return mod_fee;
		},
		dig: function(tree, parameters)
		{
			for (var key in tree) {
				if (key === "options" || key === "types"){
					continue;
				}
				var command = key.split(":");
				switch (command[0]) {
					case 'use':
					case 'use2':
						if (parameters === "upgrade" && _fee.get_value("upgrade_"+command[0]) == command[1]){
							return _fee.calc.dig(tree[key], parameters);
						} else if (parameters === "base" && _fee.get_value(command[0]) == command[1]){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
					case 'circuit':
					case 'role':
					case 'inm_diffusion':
					case 'inm_duration':
					case 'apc_tableau':
					if (_fee.get_value(command[0]) == command[1]){
						return _fee.calc.dig(tree[key], parameters);
					}
					break;
					case 'if':
					var value = asFloat(_fee.get_value(command[1])),
					operator = command[2],
					operationNumber = asFloat(command[3]);
					switch (operator){
						case '==':
						case '=':
						if (value == operationNumber){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
						case '>=':
						if (value >= operationNumber){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
					}
					break;
					case 'fee':
					if (parameters == 'base' || parameters == 'upgrade'){
						return asFloat(tree[key]);
					}
					break;
					case 'broadcast':
					if (parameters == "broadcast"){
						return _fee.calc.dig(tree[key], parameters);
					}
					case 'broadcast_fee':
					if (parameters == 'broadcast' || parameters == 'upgrade'){
						return asFloat(tree[key]);
					}
					default:
					return -1;
				}
			}
			return -1;
		},
		mod: function(fee, parameters)
		{
			// cond_negociee négociée
			if (parameters == "broadcast"){
				var cond_negociee = asFloat(_fee.get_value('cond_diff_negociee'));
				if (cond_negociee){
					return cond_negociee;
				}
			} else {
				var cond_negociee = asFloat(_fee.get_value('cond_negociee'));
				if (cond_negociee){
					return cond_negociee;
				}
			}

			// number of ads
			var numberOfAds = parseInt(_fee.get_value('nb_annonces'), 10);
			if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[panneau]']").prop('checked') == true){
				fee *= _fee.calc.option(["numberofads", numberOfAds]);
			} else {
				if (numberOfAds){
					fee *= numberOfAds;
				} else {
					return 0;
				}
			}

			// condition pourcentage
			if (parameters == "broadcast"){
				var percentage = asFloat(_fee.get_value('cond_diff_percent'))/100;
				fee *= percentage;
			} else {
				var percentage = asFloat(_fee.get_value('cond_percent'))/100;
				fee *= percentage;
			}

			// tv / radio seulement
			if (_fee.e.getConventionType() === "apc")
			{
				// post-synchro: 125%
				if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[post-synchro]']").prop('checked') == true){
					fee *= _fee.calc.option(["post-synchro"]);
				}

				// remise en onde: 150%
				if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[remise]']").prop('checked') == true){
					fee *= _fee.calc.option(["remise"]);
				}

				// durée de cycle
				if (parameters == 'base' && _fee.get_value('duration') != undefined){
					fee *= _fee.calc.option(["duration", _fee.get_value('duration').toString()]);
				} else if (parameters == "upgrade" && _fee.get_value('upgrade_duration') != undefined){
					fee *= _fee.calc.option(["duration", _fee.get_value('upgrade_duration').toString()]);
				}
			}

			// final base fee
			return fee;
		},
		role_fee: function(item_type)
		{
			var data = _fee.e.getConventionData();
			if (_fee.get_value('role') && item_type){
				return data['role:' + _fee.get_value('role')].items[item_type];
			}
			return 0;
		}
	};

	_fee.import = function(config_name, options_list)
	{
		// set config name
		_fee.e.find("select[name=config]").val(config_name);
		_fee.e.find("select[name=config]").change();

		// set circuit BEFORE applying default/enabled to avoid it being reset
		var tempConv = _fee.find(".conv-" + _fee.e.getConventionName());
		tempConv.find(":input[name=circuit][value=" + options_list.circuit + "]").prop("checked", true);

		// Apply default and enabled which will set .conv-inactive classes
		_fee.calc.default(options_list.circuit);
		_fee.calc.enabled();

		// NOW define activeConv after classes are set
		var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');

		// set upgrade
		if (options_list['option[upgrade]'] && options_list['option[upgrade]'] == 'on'){
			activeConv.find(":input[name='option[upgrade]']").prop("checked", true);
		} else {
			activeConv.find(":input[name='option[upgrade]']").prop("checked", false);
		}

		//  set options
		for (var key in options_list){
			switch (key) {
				case 'nb_annonces':
				// case 'nb_supp':
				case 'cond_negociee':
				case 'cond_percent':
				case 'cond_diff_negociee':
				case 'cond_diff_percent':
				activeConv.find(":input[name=" + key + "]").val(options_list[key]);
				break;
				case 'duration':
				case 'upgrade_duration':
				case 'inm_duration':
				case 'upgrade_use':
				case 'upgrade_use2':
				activeConv.find(":input[name=" + key + "]").val(options_list[key]);
				activeConv.find(":input[name=" + key + "]").selectpicker('refresh');
				break;
				case 'use':
				case 'use2':
				case 'role':
				case 'inm_diffusion':
				case 'apc_diffusion':
				activeConv.find(":input[name=" + key + "][value=" + options_list[key] + "]").prop("checked", true);
				break;
				case 'option[saisonniere]':
				case 'option[post-synchro]':
				case 'option[remise]':
				case 'option[panneau]':
				case 'option[une-station]':
				case 'option[combine]':
				activeConv.find(":input[name='" + key + "']").prop("checked", true);
				break;
			}
		}

		// uncheck if not checked
		if (!options_list['option[saisonniere]']){
			activeConv.find(":input[name='option[saisonniere]']").prop("checked", false);
		}
		if (!options_list['option[panneau]']){
			activeConv.find(":input[name='option[panneau]']").prop("checked", false);
		}
		if (!options_list['option[remise]']){
			activeConv.find(":input[name='option[remise]']").prop("checked", false);
		}
		if (!options_list['option[post-synchro]']){
			activeConv.find("input[name='option[post-synchro]']").prop("checked", false);
		}
		if (!options_list['option[une-station]']){
			activeConv.find(":input[name='option[une-station]']").prop("checked", false);
		}
		if (!options_list['option[combine]']){
			activeConv.find("input[name='option[combine]']").prop("checked", false);
		}

		// save
		_fee.calc.update_item();
		_fee.changed({target:_fee});
	};

	_fee.changed = function(event)
	{
		// variables
		var field = $(event.target),
		key = undefined,
		value = undefined;

		// datetime picker
		if (field.data("DateTimePicker") != undefined){
			key = field.find("input").attr("name");
			var date = field.data("DateTimePicker").date();
			value = (date != null) ? field.data("DateTimePicker").date().format("YYYY-MM-DD 00:00:00") : '';

			// checkboxes
		} else if (field.attr("type") == "checkbox"){
			key = field.attr("name");
			value = field.prop("checked") ? "on" : undefined;

			// normal fields
		} else {
			key = field.attr("name");
			value = field.val();
		}

		// floats
		if (key == "cond_negociee" || key == "cond_diff_negociee"){
			value = asFloat(value);
			if (isNaN(value)){
				value = "0,00";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		}

		// ints
		if (key == "cond_percent" || key == "cond_diff_percent"){
			value = parseInt(value, 10);
			if (isNaN(value) || value <= 0){
				value = 100;
			}
			field.val(value);
		}

		// actions
		if (key == 'apc_tableau' || key == "circuit" || key == "option[panneau]" || key == "option[upgrade]" || key == "config"){
			_fee.calc.default(field.val());
			_fee.calc.enabled();
		} else if (key == "cycle_date1"){
			_fee.calc.cycle_duration();
		} else if (key == "duration" || key == "inm_duration"){
			_fee.calc.cycle_duration();
		}

		// automatically update fee
		_fee.updateFee();

		// element set
		if (key == "cycle" || key == "cycle_date1" || key == "cycle_date2"){
			_fee.e.set(key, value);
		} else {
			_fee.calc.update_item();
			_fee.e.updateOptionsList();
		}
	};

	_fee.get_value = function(key)
	{
		// input fields - exclude inactive conventions
		var input = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='" + key + "']"),
		select = undefined;
		if (!input.length){
			select = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("select[name='" + key + "']");
			if (!input.length && !select.length){
				return undefined;
			}
		}
		if (key === "cycle_date1" || key === "cycle_date2"){
			if (input.closest('.element-date-picker').length){
				var date = input.closest('.element-date-picker').data("DateTimePicker").date();
				return (date != null) ? date.format("YYYY-MM-DD 00:00:00") : '';
			} else {
				return '';
			}
		} else if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return input.filter(':checked').val();
			} else {
				return input.val();
			}
		} else if (select.length){
			return select.val();
		}
	};

	_fee.updateFee = function()
	{
		_fee.baseFee = _fee.calc.base_fee();
		_fee.upgradeFee = (_fee.e.getConventionType() == "apc") ? _fee.calc.upgrade_fee() : 0;
		_fee.broadcastFee = (_fee.e.getConventionType() == "inm") ? _fee.calc.broadcast_fee() : 0;
		_fee.e.updateInterface();
	};

	_fee.getFee = function()
	{
		return _fee.baseFee;
	};

	_fee.getUpgrade = function()
	{
		if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[upgrade]']").prop('checked') == true){
			return _fee.upgradeFee;
		}
		return 0;
	};

	_fee.getBroadcast = function()
	{
		if (_fee.e.getConventionType() == "inm"){
			return _fee.broadcastFee;
		}
		return 0;
	};

	_fee.getConventionName = function()
	{
		return _fee.e.find("select[name=config]").val();
	};

	_fee.getOptionsList = function()
	{
		return _fee.model.getOptionsList();
	};

	return function()
	{
		// dynamic interface elements
		_fee.interface.cycle_start_dp = _fee.interface.cycle_start_field.closest('.element-date-picker').data("DateTimePicker");

		// checked options
		if (_fee.form.data("loaded") == true){
			_fee.calc.loaded();
			_fee.calc.enabled();
			_fee.updateFee();
		} else {
			_fee.calc.default("start");
			_fee.calc.enabled();
			_fee.updateFee();
		}
		_fee.e.setInitialOptionsList();

		// calculator elements changed
		_fee.on("change", _fee.changed);
		_fee.find('.element-date-picker').each(function(){
			$(this).on('dp.change', _fee.changed);
		});
		_fee.e.find("select[name=config]").on("change", function(){
			_fee.e.set("config", $(this).val());
			_fee.changed({target:$(this)});
		});

		// selectpicker
		_fee.find("select").each(function(){
			if ($(this).hasClass("select")){
				$(this).selectpicker({
					size: 5
				});
			}
		});

		// next tab button
		_fee.interface.next_tab_btn.on("click", function(){
			_fee.e.reachTab(2);
			return false;
		});

		// return object
		return _fee;
	}();
};

$.fn.Banque = function(_g) {
	var _bank = this;
	_bank.selectToggle = false;
	_bank.selectingAll = false;
	_bank.el = {
		checkboxes: _bank.find('input[type=checkbox]'),
		select_all: _bank.find('.btn-action-select-all'),
		save_btn: _bank.find('.btn-action-banque-save'),
	};

	_bank.selectAll = function() {
		_bank.selectingAll = true;
		if (!_bank.selectToggle){
			_bank.selectToggle = true;
			_bank.el.checkboxes.prop('checked', true).change();
			_bank.displayUnselectAllButton();
		} else {
			_bank.selectToggle = false;
			_bank.el.checkboxes.prop('checked', false).change();
			_bank.displaySelectAllButton();
		}
		_bank.selectingAll = false;
	};

	_bank.displaySelectAllButton = function() {
		_bank.el.select_all.find('span:not(.material-symbols-outlined)').text("Sélectionner tout");
		// _bank.el.select_all.find('i').removeClass("fa-close").addClass("fa-check");
	};

	_bank.displayUnselectAllButton = function() {
		_bank.el.select_all.find('span:not(.material-symbols-outlined)').text("Désélectionner tout");
		// _bank.el.select_all.find('i').removeClass("fa-check").addClass("fa-close");
	};

	_bank.changed = function() {
		if (!_bank.selectingAll) {
			var allSelected = true;
			_bank.el.checkboxes.each(function() {
				if (!$(this).prop('checked')) {
					allSelected = false;
				}
			});
			if (allSelected) {
				_bank.selectToggle = true;
				_bank.displayUnselectAllButton();
			} else {
				_bank.selectToggle = false;
				_bank.displaySelectAllButton();
			}
		}
	};

	_bank.save = function() {
		var bank_guarantees = [];
		_bank.el.checkboxes.each(function() {
			if ($(this).prop('checked')) {
				bank_guarantees.push($(this).attr("name"));
			}
		});
		_g.setBanqueDetails(bank_guarantees.join(","));
		_bank.modal('hide');
	};

	return function() {
		// initialize checkboxes
		_bank.el.select_all.on('click', _bank.selectAll);
		_bank.el.checkboxes.each(function() {
			$(this).on("change", _bank.changed);
		});
		_bank.el.save_btn.on('click', _bank.save);

		// load checked details
		_bank.selectingAll = true;
		_g.getBanqueDetails().forEach(function(x) {
			_bank.find('input[name="' + x + '"]').prop('checked', true).change();
		});
		_bank.selectingAll = false;
		_bank.changed();
		return _bank;
	}();
};

$.fn.Guarantees = function(_e)
{
	var _g = this;
	_g.e = _e;
	_g.form = _g.find("form");
	_g.model = undefined;	// defined later
	_g.interface = {
		guarantees_field : undefined,
		banque_modal : undefined,
		banque_details_btn: _g.find("button.banque-modal"),
		next_tab_btn : _g.find("button[data-action='next-tab']"),
		calculator : {
			cachet_jour : _g.find('input[name=cachet_jour]'),
			cachet: _g.find('input[name=cachet]'),
			taux_horaire: _g.find('input[name=taux_horaire]'),
			hre_supp: _g.find('input[name=hre_supp]'),
			droits_percent: _g.find('input[name=droits]'),
			droits: _g.find('input[name=droits]'),
			total: _g.find('input[name=total]'),
		}
	};
	_g.baseFee = 0.00;

	_g.calc = {
		update_item: function()
		{
			// send details to contract model
			_g.model = _g.e.interface.tabs.contract.model;
			_g.model.item["fonction"] = _g.get_value("fonction");
			_g.model.item["jours_tournage"] = _g.get_value("jours_tournage");
			_g.model.item["emissions_episodes"] = _g.get_value("emissions_episodes");
			_g.model.item["banque"] = _g.get_value("banque");
			_g.model.item["banque_details"] = _g.get_value("banque_details");
			_g.model.item["garanties"] = _g.get_value("garanties");
			_g.model.item["cachet"] = _g.get_value("cachet");
			_g.model.item["cachet_total"] = _g.get_value("total");
			_g.model.item["droits_percent"] = _g.get_value("droits_percent");
			_g.model.item["droits_total"] = _g.get_value("droits");
			_g.model.save();
		},
		option: function(path)
		{
			var value = 0;
			if (path.length == 1){
				value = asFloat(_g.e.getConventionData().options[path[0]]);
			} else if (path.length == 2){
				value = asFloat(_g.e.getConventionData().options[path[0]][path[1]]);
			}
			if (isNaN(value)){
				value = 0;
			}
			return value;
		},
		base_fee: function()
		{
			// calculate base fee
			var base_fee = 0,
			cachet = _g.get_value('cachet'),
			droits_percent = _g.get_value('droits_percent'),
			factor = _g.calc.highest_number(),
			banque = _g.get_value('banque');

			// no fee returned
			if (!_g.form.data("loaded")){
				return 0;
			}

			// set hourly rate
			var taux_horaire = cachet / 8;
			_g.interface.calculator.taux_horaire.val(taux_horaire.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set supp amount
			var taux_horaire_supp = taux_horaire * 1.5;
			_g.interface.calculator.hre_supp.val(taux_horaire_supp.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// get guarantees fees
			var guarantees_totals = _g.calc.guarantees_fees();

			// set droits amount
			var droits_cachet = (cachet * factor) * droits_percent / 100;
			var droits = droits_cachet + (guarantees_totals.rights * droits_percent / 100);
			_g.interface.calculator.droits.val(droits.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set total
			var total = parseFloat((cachet * factor) + droits + (guarantees_totals.total) + banque);
			_g.interface.calculator.total.val(total.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set daily fee
			var cachet_jour = factor ? total / factor : 0;
			if (isNaN(cachet_jour)) cachet_jour = 0;
			_g.interface.calculator.cachet_jour.val(cachet_jour.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			return total;
		},
		highest_number: function()
		{
			// calculate highest number
			var jours_tournage = _g.get_value('jours_tournage'),
			emissions_episodes = _g.get_value('emissions_episodes'),
			highest_number = Math.max(jours_tournage, emissions_episodes);
			if (highest_number < 0) highest_number = 0;
			return highest_number;
		},
		guarantees_fees: function()
		{
			// no field?
			if (_g.interface.guarantees_field == undefined){
				return 0;
			}

			// calculate guarantees fee
			var guarantees_fees = { rights: 0, total: 0 },
			taux_horaire = _g.get_value('taux_horaire'),
			droits_percent = _g.get_value('droits_percent');

			// loop through guarantees
			var guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				guarantee_totals = _g.calc.guarantee_fee(guarantee);
				guarantees_fees.total += guarantee_totals.total;
				_g.interface.guarantees_field.rows[index].find('input[name="guarantee_total"]').val(guarantee_totals.total);
				if (guarantee_totals.rights){
					guarantees_fees.rights += guarantee_totals.total;
					_g.interface.guarantees_field.rows[index].find('input[name="guarantee_droits"]').val(guarantee_totals.total * droits_percent / 100);
				}
				_g.interface.guarantees_field.rows[index].find('input[name="guarantee_number"]').val(guarantee_totals.display ? guarantee_totals.display : '');
			});
			return guarantees_fees;
		},
		guarantee_fee: function(guarantee, force_amount)
		{
			// force amount?
			if (force_amount == undefined){
				force_amount = false;
			}

			// get item value
			var item_value = asFloat(guarantee.guarantee_number);
			if (isNaN(item_value) || item_value < 0) item_value = 0;
			var totals = { total: 0, rights: 0, display: item_value };

			// edit item value
			if (item_value && guarantee.guarantee_item && guarantee.guarantee_item != "NONE"){
				var guarantee_config = _g.e.getConventionData().guarantees[guarantee.guarantee_item],
				calc_config = guarantee_config.calc;

				// set field values
				switch (calc_config[0]) {
					case "%": {
						var raw_value = parseInt(item_value, 10);
						if (!raw_value) raw_value = 0;
						totals.display = raw_value + "%";
						break;
					}
					case "$": {
						var raw_value = asFloat(item_value, 10);
						if (!raw_value) raw_value = 0;
						raw_value = raw_value.toLocaleString('fr-CA', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});
						totals.display = raw_value + " $";
						break;
					}
					case "int": {
						var raw_value = parseInt(item_value, 10);
						if (!raw_value) raw_value = 0;
						totals.display = raw_value;
						break;
					}
					case "float": {
						var raw_value = asFloat(item_value);
						if (!raw_value) raw_value = 0;
						raw_value = raw_value.toLocaleString('fr-CA', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});
						totals.display = raw_value;
						break;
					}
				}

				// get action
				switch(calc_config[1]){
					case "fn": {
						var input_value = asFloat(item_value);
						totals.total = _g.calc.fn[calc_config[2]](input_value);
						break;
					}
					case "*": {
						var input_value = asFloat(item_value);
						if (isNaN(input_value) || input_value == 0){
							totals.total = 0;
						} else {
							if (isNaN(calc_config[2])){
								totals.total = input_value * _g.calc.fn.grid_value(calc_config[2]);
							} else {
								totals.total = input_value * calc_config[2];
							}
						}
						break;
					}
					case "=": {
						var input_value = asFloat(item_value);
						if (isNaN(input_value) || input_value == 0){
							totals.total = 0;
						} else if (!force_amount && calc_config[2] === 0){
							totals.total = 0;
						} else {
							totals.total = input_value;
						}
						break;
					}
					default: {
						// * with percentage factor
						if (calc_config[1].charAt(0) === "*"){
							var percent = asFloat(calc_config[1].substr(1)) / 100,
							input_value = asFloat(item_value);
							if (isNaN(input_value) || input_value == 0){
								totals.total = 0;
							} else {
								if (calc_config[2] === "c"){
									totals.total = input_value * _g.calc.values.cachet() * percent;
								} else if (calc_config[2] === "hc"){
									totals.total = input_value * _g.calc.values.taux_horaire() * percent;
								} else if (isNaN(calc_config[2])){
									totals.total = input_value * _g.calc.fn.grid_value(calc_config[2]) * percent;
								} else {
									totals.total = input_value * calc_config[2] * percent;
								}
							}
						}
					}
				}

				// rights if needed
				if (guarantee_config.droits){
					totals.rights = 1;
				}
			}
			return totals;
		},
		guarantee_fee_for: function(item_type) {
			// loop through guarantees
			var guarantees_total = 0,
			guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				if (guarantee.guarantee_item === item_type){
					var guarantee_total = _g.calc.guarantee_fee(guarantee);
					guarantees_total += guarantee_total.total;
				}
			});
			return guarantees_total;
		},
		guarantee_amount_for: function(item_type) {
			// loop through guarantees
			var guarantees_amount = 0,
			guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				if (guarantee.guarantee_item === item_type){
					var guarantee_total = _g.calc.guarantee_fee(guarantee, true);	// force amount
					guarantees_amount += guarantee_total.total;
				}
			});
			return guarantees_amount;
		},
		fn: {
			grid_value: function(input_value){
				var fonction = _g.get_value('fonction')
				if (fonction == 'NONE') {
					return 0;
				}
				var category = _g.e.getConventionData().roles[fonction].category;
				if (!category) {
					return 0;
				}
				return _g.calc.option(['cat_' + category, input_value]);
			},

			/* get divided contract value */
			jours_attente: function(input_value)
			{
				var j = _g.calc.fn.grid_value("j");
				var total = 0;
				if (input_value > 2) {
					total += (j * .25 * 2) + (j * .5 * (input_value - 2));
				} else {
					total += (j * .25 * input_value);
				}
				return total;
			},
		},
		values: {
			taux_horaire: function(){
				var value = asFloat(_g.get_value('taux_horaire'));
				if (isNaN(value) || !value) { value = 0; }
				return value;
			},
			cachet: function(){
				var value = asFloat(_g.get_value('cachet'));
				if (isNaN(value) || !value) { value = 0; }
				return value;
			},
			droits_percent: function(){
				var value = asFloat(_g.get_value('droits_percent'));
				if (isNaN(value) || !value) { value = 0; }
				return value / 100;
			}
		}
	};

	_g.changed = function(event)
	{
		// variables
		var field = $(event.target),
		key = undefined,
		value = undefined;

		// normal fields
		key = field.attr("name");
		value = field.val();

		// floats
		if (key == "cachet" || key == "banque"){
			value = asFloat(value);
			if (isNaN(value)){
				value = "0,00";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		} else if (key == "droits_percent") {
			value = asFloat(value);
			if (isNaN(value)){
				value = "0";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		}

		// ints
		if (key == "jours_tournage" || key == "emissions_episodes"){
			value = parseInt(value, 10);
			if (isNaN(value)){
				value = 0;
			}
			if (value < 0) value = 0;
			field.val(value);
		}

		// automatically update fee
		_g.updateFee();

		// element set
		_g.calc.update_item();
		_g.e.updateOptionsList();
	};

	_g.get_value = function(key)
	{
		// input fields
		var input = _g.find("input[name='" + key + "']"),
		select = _g.find("select[name='" + key + "']");

		// guarantees field
		if (key == "garanties"){
			return _g.interface.guarantees_field.val();
		}

		// fields not found
		if (!input.length && !select.length){
			return undefined;
		}

		// input field
		if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return _g.find("input[name='" + key + "']:checked").val();
			} else {
				var valueFloat = asFloat(input.val()),
				valueInteger = parseInt(input.val(), 10);
				if (!isNaN(valueInteger)){
					if (valueInteger != valueFloat){
						return valueFloat;
					}
					return valueInteger;
				}
				return input.val();
			}

			// select field
		} else if (select.length){
			return select.val();
		}
	};

	_g.updateFee = function()
	{
		_g.baseFee = _g.calc.base_fee();
		_g.e.updateInterface();
	};

	_g.getFee = function()
	{
		return _g.baseFee;
	};

	_g.getGuaranteeFee = function(item_type)
	{
		return _g.calc.guarantee_fee_for(item_type);
	};

	_g.getGuaranteeAmount = function(item_type)
	{
		return _g.calc.guarantee_amount_for(item_type);
	};

	_g.getConventionName = function()
	{
		return _g.e.find("select[name=config]").val();
	};

	_g.getOptionsList = function()
	{
		// return _g.model.getOptionsList();
	};

	_g.initialize = function()
	{
		// select with search
		// the tab can reload while closed: skip only the row template and already initialized selects
		_g.find(".select-search").not(".template select, .select2-hidden-accessible").each(function(){
			$(this).select2({
				language: "fr"
			});
		});

		// add first guarantee
		_g.find('.repeater-field').each(function(){
			_g.interface.guarantees_field = $(this).RepeaterField();
			if (!_g.interface.guarantees_field.rows.length){
				_g.interface.guarantees_field.add_row();
			}
			// focus sur la garantie de la nouvelle ligne
			_g.interface.guarantees_field.el.button.add.on("click", function(){
				var rows = _g.interface.guarantees_field.rows;
				rows[rows.length - 1].find(".select2-selection").first().focus();
			});
		});

		// event listeners
		_g.find('.slr-watched :input').on("change", _g.changed);
		_g.interface.guarantees_field.on("update", function(){
			_g.changed({target: _g.interface.guarantees_field});
		})
	};

	_g.openBanqueDetails = function() {
		if (_g.interface.banque_modal == undefined){
			_g.interface.banque_modal = _g.find('.banque-details-modal').Banque(_g);
		}
		_g.interface.banque_modal.modal('show');
		return false;
	};

	_g.getBanqueDetails = function() {
		return _g.find('input[name="banque_details"]').val().split(',');
	};

	_g.setBanqueDetails = function(value) {
		_g.find('input[name="banque_details"]').val(value).change();
	};

	return function()
	{
		// form
		if (_g.form.data("loaded") == true){
			_g.initialize();
			_g.updateFee();
		} else {
			_g.updateFee();
			_g.e.setInitialOptionsList();
		}
		_g.form.on("submit", function(){
			return false;
		});

		// next tab button
		_g.interface.next_tab_btn.on("click", function(){
			_g.e.reachTab(2);
			return false;
		});

		// banque details button
		_g.interface.banque_details_btn.on('click', _g.openBanqueDetails);

		// convention select, bound once per element since this tab reloads after creation
		_g.e.find("select[name=config]").off("change.guarantees").on("change.guarantees", function(){
			_g.e.set("config", $(this).val());
			if (_g.form.data("loaded") == true){
				_g.changed({target: _g.interface.guarantees_field});
			} else {
				_g.e.updateOptionsList();
			}
		});

		// return object
		return _g;
	}();
};

$.fn.Details = function(_e)
{
	var _details = this;
	_details.e = _e;
	_details.details_list = undefined;
	_details.types_config = undefined;
	_details.interface = {
		element_type_select: _details.find("select[name=element_type]"),
		date1_field: _details.find("input[name=date1]"),
		date2_field: _details.find("input[name=date2]"),
	};

	/* Public */
	_details.getHeaderTitle = function()
	{
		var headerText = _details.interface.element_type_select.find("option:selected").text();
		if (!headerText || headerText == " " || headerText == " " || headerText == ""){
			headerText = "–";
		}
		return headerText;
	};

	_details.getHeaderDates = function()
	{
		var datesString = "";
		if (_details.interface.date1_field.val() != ""){ datesString += _details.interface.date1_field.val(); }
		if (_details.interface.date1_field.val() != "" && _details.interface.date2_field.val() != ""){ datesString += " - "; }
		if (_details.interface.date2_field.val() != ""){ datesString += _details.interface.date2_field.val(); }
		if (!datesString) datesString = "–";
		return datesString;
	};

	/* Private */
	_details.changed = function(event)
	{
		// set property to element
		var key = undefined,
			value = undefined;
		if ($(event.target).data("DateTimePicker") != undefined){
			key = $(event.target).find("input").attr("name");
			var date = $(event.target).data("DateTimePicker").date();
			value = (date != null) ? $(event.target).data("DateTimePicker").date().format("YYYY-MM-DD 00:00:00") : '';
		} else {
			key = $(event.target).attr("name");
			value = $(event.target).val();
		}
		_details.e.set(key, value);

		// element type recalculate
		if (key == 'element_type'){
			_details.details_list.updatedBaseFee();
		}
	};

	/* Get value */
	_details.get_value = function(key)
	{
		// input fields
		var input = _details.find("input[name='" + key + "']");
		if (key === "date1" || key === "date2"){
			var date = input.closest('.element-date-picker').data("DateTimePicker").date();
			return (date != null) ? date.format("YYYY-MM-DD 00:00:00") : undefined;
		} else if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return _details.find("input[name='" + key + "']:checked").val();
			} else {
				return _details.find("input[name='" + key + "']").val();
			}
		} else {
			var select = _details.find("select[name='" + key + "']");
			return select.val();
		}
	};
	
	_details.updateTypesSelect = function(maybe_save)
	{
		if (_details.types_config == undefined || _details.types_config != _details.e.getConventionName())
		{
			// insert select choices
			var previousValue = _details.interface.element_type_select.val();
			_details.types_config = _details.e.getConventionName();
			_details.interface.element_type_select.find("option").remove();
			_details.interface.element_type_select.append(_details.find(".template-" + _details.types_config + "-elementtypes option").clone());
			
			// maybe save if value has to change
			if (maybe_save){
				if (previousValue && previousValue != 0 && previousValue != "NONE" && _details.interface.element_type_select.find("option[value=" + previousValue + "]").length){
					_details.interface.element_type_select.val(previousValue);
				} else {
					_details.interface.element_type_select.val("NONE").change();
				}
			}
		}
	};

	return function()
	{
		// static element fields
		_details.find(".static-input-group").on("change", _details.changed);
		_details.find('.element-date-picker').each(function(){
			$(this).on('dp.change', _details.changed);
		});
		
		// details list
		_details.details_list = _details.find(".slr-details-list").DetailsList(_details);
		
		// recalculate rights immediately after all items in element are loaded
		_details.details_list.model.each(function(item){
			if (item.model.item.item_type === "DROITS"){
				item.update();
			}
		});
		
		// details type select
		_details.updateTypesSelect(false);

		// return object
		return _details;
	}();
};

/*
*	Details list model
*/
function SLR_DetailsList(_dl)
{
	/* Properties */
	var self = this;
	self.dl = _dl;
	self.details = [];

	/* Methods */
	self.getDetailsItem = function(item_id)
	{
		var item = false;
		self.details.forEach(function(x){
			if (x.model.item.id == item_id){
				item = x;
			}
		});
		return item;
	};

	self.addDetailsItem = function(details_item)
	{
		details_item.model.item.list_order = self.details.length + 1;
		self.details.push(details_item);
	};

	self.removeDetailsItem = function(details_item)
	{
		var index = self.details.indexOf(details_item);
		if (index >= 0){
			self.details.splice(index, 1);
		}
	};

	self.duplicateDetailsItem = function(item)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "detailsitem");
		request.append("action", "duplicate");
		request.append("data", JSON.stringify(item.model.item));

		// add request to queue
		$.slr.db.add(request, function(x)
		{
			var invoice_type = self.dl.details_tab.e.el.form.get_invoice_type();
			self.dl.load_details_item(invoice_type, x.item.id);
		});
		return false;
	};

	self.setListOrder = function(list_order)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// new details array
		var newDetailsList = [];
		for (var i = 0; i < list_order.length; i++) {
			var detailsItem = self.getDetailsItem(list_order[i]);
			detailsItem.model.item.list_order = i+1;
			newDetailsList.push(detailsItem);
		}
		self.details = newDetailsList;

		// build request
		request.append("model", "detailsitem");
		request.append("action", "order");
		request.append("data", JSON.stringify(list_order));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	self.getCount = function()
	{
		return self.details.length;
	};

	self.each = function(callback)
	{
		self.details.forEach(function(x){
			callback(x);
		});
	};
}

/*
*	Details list interface behavior
*/
$.fn.DetailsList = function(_details_tab)
{
	var _dl = this;
	_dl.model = new SLR_DetailsList(_dl);
	_dl.template = undefined;
	_dl.details_tab = _details_tab;
	_dl.interface = {
		add_button : _dl.find(".btn-action-add-details"),
		container : _dl.find(".slr-details-item-container"),
		cell_received : _dl.find(".cell-subtotal-received"),
		cell_due : _dl.find(".cell-subtotal-due")
	};

	_dl.refresh = function()
	{
		// show elements
		_dl.model.each(function(x){
			_dl.interface.container.append(x);
		});

		// update details and totals
		_dl.details_tab.e.updateDetailsSummary();
		_dl.updateTotals();
	};

	_dl.add_details = function()
	{
		var newDetailsItem = _dl.template.find(".slr-item").clone();
		newDetailsItem.DetailsItem(_dl);
		newDetailsItem.save();
		_dl.model.addDetailsItem(newDetailsItem);
		_dl.refresh();
		return false;
	};

	_dl.remove_details_item = function(item)
	{
		_dl.model.removeDetailsItem(item);
		_dl.refresh();
		_dl.updateRights();
	};

	_dl.duplicate_details_item = function(item)
	{
		_dl.model.duplicateDetailsItem(item);
	}

	_dl.load_details_item = function(invoice_type, item_id)
	{
		$.get("/facture/details_item/" + invoice_type + "/" + item_id, {}, function(x){
			var newDetailsItem = $($(x)[0]);
			newDetailsItem.DetailsItem(_dl);
			_dl.model.addDetailsItem(newDetailsItem);
			_dl.refresh();
			_dl.updateRights();
		}, 'html');
	};

	_dl.details_items_sorted = function(e)
	{
		var order = [];
		_dl.interface.container.find(".slr-item").each(function(index, el){
			order.push(parseInt($(el).find("input[name=details_item_id]").val(), 10));
		});
		_dl.model.setListOrder(order);
		_dl.details_tab.e.updateDetailsSummary();
	};

	_dl.setElementID = function(elementID)
	{
		// show elements
		_dl.model.each(function(x){
			if (x.model.item.element_id == undefined){
				x.set("element_id", elementID);
			}
		});
	};

	_dl.updateTotals = function()
	{
		var subtotal_base = 0,
			subtotal_due = 0;
		_dl.model.details.forEach(function(x){
			subtotal_base += x.model.getBase();
			subtotal_due += x.model.getDue();
		});
		var subtotal_base = subtotal_base.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}),
			subtotal_due = subtotal_due.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		_dl.interface.cell_received.html(subtotal_base);
		_dl.interface.cell_due.html(subtotal_due);
	};

	_dl.updatedBaseFee = function()
	{
		_dl.model.details.forEach(function(x){
			x.update();
			x.model.save();
		});
	};
	
	_dl.updateRights = function()
	{
		_dl.model.details.forEach(function(x){
			if (x.getItemType() == "DROITS") {
				x.update();
				x.model.save();
			}
		});
	};
	
	_dl.getRights = function()
	{
		var rights_total = 0;
		_dl.model.each(function(item) {
			rights_total += item.calc.rights();
		});
		return rights_total;
	};

	return function()
	{
		_dl.template = _dl.find("#slr-item-template").clone().removeAttr("id");
		_dl.find("#slr-item-template").remove();
		_dl.interface.add_button.on("click", function(){
			_dl.add_details();
			// focus sur le champ Détails de la nouvelle ligne
			_dl.interface.container.find(".slr-item").last().find(".select2-selection").first().focus();
			return false;
		});

		// loaded items
		var loadedItems = _dl.interface.container.find(".slr-item");
		if (loadedItems.length){
			loadedItems.each(function(){
				var loadedElement = $(this).DetailsItem(_dl);
				_dl.model.addDetailsItem(loadedElement);
			});
			_dl.refresh();
		} else {
			_dl.add_details();
		}

		// sortable
		_dl.find(".slr-details-item-container").sortable({
			helper : 'clone',
			stop : _dl.details_items_sorted,
			handle : '.drag-item-button'
		});
		_dl.on("mousedown", function(e){
			if (e.target.nodeName.toLowerCase() != "input"){
				_dl.find("input").blur();
			}
		});
		return _dl;
	}();
};

function SLR_DetailsItem(_details_item)
{
	// parent element
	var self = this;
	self.details_item = _details_item;
	self.item = {
		id: undefined,
		element_id: undefined,
		list_order: undefined,
		deleted: false,
		item_type: undefined,
		value: undefined,
		description: undefined,
		tax_exempt: 0,
		base_fee: 0,
		due_fee: 0,
		base_bypass: undefined,
		due_bypass: undefined,
	};

	self.pending = false;	// requête d'enregistrement en cours
	self.dirty = false;		// changement en attente pendant une insertion

	self.save = function()
	{
		// Le type placeholder « NONE » ne s'enregistre jamais.
		if (!self.item.id && (self.item.item_type == undefined || self.item.item_type == 'NONE')) {
			return false;
		}

		// Une seule insertion à la fois : en attendant l'id, marquer à re-sauver.
		if (!self.item.id && self.pending) {
			self.dirty = true;
			return false;
		}

		// gather data
		var request = new FormData(),
		data = {};

		// null bypass
		if (self.item.base_bypass == undefined) {
			self.item.base_bypass = 'NULL';
		}
		if (self.item.due_bypass == undefined) {
			self.item.due_bypass = 'NULL';
		}

		// build request
		request.append("model", "detailsitem");
		request.append("action", "auto");
		request.append("data", JSON.stringify(self.item));

		if (self.item.base_bypass == 'NULL') {
			self.item.base_bypass = undefined;
		}
		if (self.item.due_bypass == 'NULL') {
			self.item.due_bypass = undefined;
		}

		// add request to queue
		self.pending = true;
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.delete = function()
	{
		self.item.deleted = 1;
		self.save();
	};

	self.callback = function(x)
	{
		self.item.id = x.item_id;
		self.pending = false;
		self.details_item.update_id();

		// Changement survenu pendant l'insertion : ré-enregistrer une fois l'id connu.
		if (self.dirty) {
			self.dirty = false;
			self.save();
		}
	};

	self.getBase = function() {
		if (self.item.base_bypass != undefined) {
			return self.item.base_bypass;
		}
		return self.item.base_fee;
	}

	self.getDue = function() {
		if (self.item.due_bypass != undefined) {
			return self.item.due_bypass;
		}
		return self.item.due_fee;
	}

	self.init = function()
	{
		if (self.details_item.find("input[name=details_item_id]").val()){
			self.item.id = parseInt(self.details_item.find("input[name=details_item_id]").val(), 10);
		}
	}();
}

$.fn.DetailsItem = function(detailsList)
{
	var _i = this;
	_i.dl = detailsList;
	_i.model = new SLR_DetailsItem(_i);
	_i.config_name = undefined;
	_i.interface = {
		trash_button : _i.find(".trash-item-button"),
		duplicate_button : _i.find(".duplicate-item-button"),
		details_type_select : _i.find("[name=item_type]"),
		item_value : _i.find("input[name=value]"),
		description : _i.find("textarea[name=description]"),
		cell_received : _i.find(".cell-item-received"),
		cell_due : _i.find(".cell-item-due")
	};

	_i.getItemType = function() {
		return _i.interface.details_type_select.val();
	};

	_i.calc = {
		item_fees: function()
		{
			var config = _i.dl.details_tab.e.getConventionItems(),
			base_fee = _i.calc.base_fee(config),
			owed_fee = _i.calc.owed_fee(base_fee);
			// must update bypass with redevance here
			var bypassed = _i.model.item.base_bypass == undefined ? false : 'bypassed';
			if (bypassed === 'bypassed') {
				var redevance = _i.dl.details_tab.e.el.form.get_redevance()
				_i.find("input[name=due_bypass]").val(_i.model.item.base_bypass * redevance / 100);
				_i.model.item.due_bypass = parseFloat(_i.find("input[name=due_bypass]").val());
			}
			return [base_fee, owed_fee, _i.model.item.base_bypass, _i.model.item.due_bypass, bypassed];
		},
		base_fee: function(config)
		{
			// get base config
			var item_type = _i.interface.details_type_select.val(),
			item_value = _i.interface.item_value.val();
			if (item_type == 0 || item_type == undefined || !config[item_type]){
				return 0;
			}

			// calculate base fee
			var item_config = config[item_type].calc,
			fee = 0;

			// set field values
			switch (item_config[0]) {
				case "float": {
					var raw_value = asFloat(item_value.replace(',', '.'));
					if (!raw_value) raw_value = 0;
					raw_value = raw_value.toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					});
					_i.interface.item_value.val(raw_value);
					break;
				}
				case "int": {
					var raw_value = parseInt(item_value, 10);
					if (!raw_value) raw_value = 0;
					_i.interface.item_value.val(raw_value);
					break;
				}
				case "%": {
					var raw_value = parseInt(item_value, 10);
					if (!raw_value) raw_value = 0;
					_i.interface.item_value.val(raw_value + "%");
					break;
				}
				case "$": {
					var raw_value = asFloat(item_value, 10);
					if (!raw_value) raw_value = 0;
					raw_value = raw_value.toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					});
					_i.interface.item_value.val(raw_value + " $");
				}
				break;
			}

			// get action
			switch(item_config[1]){
				case "fn": {
					fee = _i.calc.fn[item_config[2]](item_type, item_value, item_config);
					break;
				}
				case "*": {
					var input_value = asFloat(item_value);
					if (isNaN(input_value) || input_value == 0){
						fee = 0;
					} else if (item_config[2] == "inm_role_fee"){
						fee = input_value * _i.calc.fn.get_inm_role_fee(item_type);
					} else {
						fee = input_value * item_config[2];
					}
					break;
				}
				case "=": {
					var input_value = asFloat(item_value);
					if (item_config[2] == "inm_role_fee"){
						return _i.calc.fn.get_inm_role_fee(item_type);
					} else if (isNaN(input_value) || input_value == 0){
						fee = 0;
					} else {
						fee = input_value;
					}
					break;
				}
				case "get": {
					if (item_config[2] == "c"){
						fee = _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet();
					} else if (item_config[2] == "j" || item_config[2] == "d"){
						fee = _i.dl.details_tab.e.interface.tabs.guarantees.calc.fn.grid_value(item_config[2]);
					}
					break;
				}
				default: {
					// * with percentage factor
					if (item_config[1].charAt(0) === "*"){
						var percent = asFloat(item_config[1].substr(1)) / 100,
						input_value = asFloat(item_value);
						if (item_config[0] == "int"){
							input_value = Math.floor(input_value);
						}
						if (isNaN(input_value) || input_value == 0){
							fee = 0;
						} else {
							var _g = _i.dl.details_tab.e.interface.tabs.guarantees;
							if (item_config[2] === "c"){
								fee = input_value * _g.calc.values.cachet() * percent;
							} else if (item_config[2] === "hc"){
								fee = input_value * _g.calc.values.taux_horaire() * percent;
							} else if (isNaN(item_config[2])){
								fee = input_value * _g.calc.fn.grid_value(item_config[2]) * percent;
							} else {
								fee = input_value * item_config[2] * percent;
							}
						}
					}
				}
			}

			// return base fee
			return fee;
		},
		owed_fee: function(base_fee)
		{
			// get redevance percent
			var fee = base_fee,
			redevance = _i.dl.details_tab.e.el.form.get_redevance();

			if (redevance == undefined || !redevance || isNaN(redevance)) {
				redevance = 0;
			}

			fee *= redevance/100;

			// return owed fee
			return fee;
		},
		rights: function() {
			var itemType = _i.model.item.item_type,
			config = _i.dl.details_tab.e.getConventionItems()[itemType],
			_g = _i.dl.details_tab.e.interface.tabs.guarantees;
			if (config != undefined && config.droits){
				var itemFees = _i.calc.item_fees();
				var bypassed = itemFees[4] == 'bypassed';
				return _i.calc.item_fees()[bypassed ? 2 : 0] * _g.calc.values.droits_percent();
			}
			return 0;
		},
		fn: {
			// get fee
			calc_c: function(item_type, item_value)
			{
				// base fee
				var nb_annonces = parseInt(_i.dl.details_tab.e.interface.tabs.fee.get_value('nb_annonces'), 10),
				base_fee = _i.dl.details_tab.e.getBaseOrUpgradeFee();
				if (isNaN(nb_annonces) || !nb_annonces){
					nb_annonces = 1;
				}
				return base_fee / nb_annonces;
			},

			// get role hour
			calc_role: function(item_type, item_value, item_config) {
				if (!item_value) {
					item_value = 0
				}
				var input_value = asFloat(item_value),
				_fee = _i.dl.details_tab.e.interface.tabs.fee,
				role_key = _fee.get_value('role')
				if (isNaN(input_value)) {
					input_value = 0
				}
				if (role_key == undefined) {
					return 0
				}
				if (role_key == 'vhcap' || role_key == 'soliste' || role_key == 'duettiste') {
					role_key = 'ap'
				} else if (role_key == 'petit') {
					role_key = 'choriste'
				}
				if (item_config[0] == 'string') {
					input_value = 1
				}
				if (!item_config[3] || !item_config[3][role_key]) {
					return 0
				}
				var hourly = item_config[3][role_key]
				return hourly * input_value
			},

			// get auditon
			calc_audition: function(item_type, item_value, item_config) {
				var input_value = parseInt(item_value, 10)
				if (!input_value) {
					return 0
				}
				return item_config[3][0] + (item_config[3][1] * (input_value - 1))
			},

			// get fee divided by two
			calc_c_div2: function(item_type, item_value)
			{
				return _i.dl.details_tab.e.getBaseOrUpgradeFee() / 2;
			},

      // get fee multiplied by value
			calc_c_multiply: function(item_type, item_value)
			{
				var nb_multiply = parseInt(item_value, 10);
				if (isNaN(nb_multiply) || !nb_multiply){
					nb_multiply = 0;
				}
				return _i.calc.fn.calc_c() * nb_multiply;
			},

			// get majoration
			calc_c_majoration: function(item_type, item_value)
			{
				var input_value = asFloat(item_value);
				if (isNaN(input_value) || input_value == 0){
					return 0;
				}
				return _i.dl.details_tab.e.getBaseOrUpgradeFee() * input_value / 100;
			},

			// get etiquettes plus
			calc_etiquettes_plus: function(item_type, item_value)
			{
				var input_value = asFloat(item_value),
				item_values = _i.dl.details_tab.e.getConventionItems().ETIQUETTES_PLUS.values,
				total = 0;
				if (isNaN(input_value) || input_value == 0){
					return total;
				}
				if (input_value >= 21){
					var h3 = input_value - 20;
					total += h3 * item_values.x21plus;
					input_value -= h3;
				}
				if (input_value >= 11){
					var h2 = input_value - 10;
					total += h2 * item_values.x11a20;
					input_value -= h2;
				}
				total += input_value * item_values.x1a10;
				return total;
			},

			calc_etiquettes_plus_majoree: function(item_type, item_value) {
				var etiquette_plus_total = _i.calc.fn.calc_etiquettes_plus(item_type, item_value),
				total = etiquette_plus_total,
				cond_percent = parseFloat(_i.dl.details_tab.e.interface.tabs.fee.get_value("cond_percent")) / 100
				if (cond_percent) {
					total *= cond_percent
				}
				return total
			},

			// get supplementaire plus
			calc_supp_plus: function(item_type, item_value)
			{
				var input_value = asFloat(item_value),
				total = 0;
				if (isNaN(input_value) || input_value == 0){
					return total;
				}
				total = 112*input_value;
				return total;
			},

			// inm audition
			calc_inm_audition: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = asFloat(item_value),
				total = 0;
				if (isNaN(item_value) || item_value < 1){
					return total;
				}
				total = _fee.calc.option(["audition", "hre_1_audition"]);
				item_value -= 1;
				total += _fee.calc.option(["audition", "hre_2_plus"]) * item_value;
				return total;
			},

			// inm audition_rappel
			calc_inm_rappel_audition: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = asFloat(item_value),
				total = 0;
				if (isNaN(item_value) || item_value < 1){
					return total;
				}
				total = _fee.calc.option(["audition", "hre_1_rappel"]);
				item_value -= 1;
				total += _fee.calc.option(["audition", "hre_2_plus"]) * item_value;
				return total;
			},

			// inm min 3h deplacement
			calc_inm_deplacement: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee,
				input_value = Math.ceil(asFloat(item_value)),
				total = 0;
				if (isNaN(item_value) || item_value < 3){
					input_value = 3;	// min 3 heures
				}
				return input_value * _fee.calc.role_fee(item_type);
			},

			// inm broadcast
			calc_inm_broadcast: function(item_type, item_value)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee;
				return _fee.getBroadcast();
			},

			// get inm role fee number
			get_inm_role_fee: function(item_type)
			{
				var _fee = _i.dl.details_tab.e.interface.tabs.fee;
				var role_fee = _fee.calc.role_fee(item_type);
				return role_fee;
			},

			// get guarantee equivalent
			get_guarantee: function(item_type, item_value)
			{
				var guarantee_fee = _i.dl.details_tab.e.interface.tabs.guarantees.getGuaranteeFee(item_type);
				setTimeout(function() {
					_i.dl.updateRights();
				}, 100);
				return guarantee_fee;
			},

			// get versement
			get_versement: function(item_type, item_value)
			{
				item_value = parseInt(item_value, 10);
				if (!item_value || item_value < 1 || isNaN(item_value)) {
					return 0;
				} else if (item_value < 10) {
					item_value = '0' + item_value;
				}
				var guarantee_fee = _i.dl.details_tab.e.interface.tabs.guarantees.getGuaranteeAmount('VERSEMENT_' + item_value);
				return guarantee_fee;
			},

			/* get multiplied contract value */
			get_cx: function(item_type, item_value)
			{
				var input_value = Math.ceil(asFloat(item_value));
				if (isNaN(input_value)){
					input_value = 0;
				}
				return _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet() * input_value;
			},

			/* get divided contract value */
			get_cd: function(item_type, item_value)
			{
				return _i.dl.details_tab.e.interface.tabs.guarantees.calc.values.cachet() * .5;
			},

			/* get negative value */
			negative: function(item_type, item_value)
			{
				var input_value = Math.ceil(asFloat(item_value));
				if (isNaN(input_value)){
					input_value = 0;
				}
				if (input_value < 0){
					return input_value;
				}
				return input_value * -1;
			},

			/* get rights for items */
			get_rights_for_items: function(item_type, item_value)
			{
				return _i.dl.getRights();
			},
		}
	};

	_i.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer cet item?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer l'item",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_i.model.delete(); // from db
				_i.slideUp("fast", function(){ // from view
					_i.dl.remove_details_item(_i); // from list
					_i.remove(); // from dom
					_i.dl.details_items_sorted(); // save order
				});
			}
		});
		return false;
	};

	_i.duplicate = function()
	{
		_i.dl.duplicate_details_item(_i); // in list
		return false;
	};

	_i.update_id = function()
	{
		_i.find("input[name=details_item_id]").val(_i.model.item.id);
	};

	_i.save = function()
	{
		_i.model.save();
	};

	_i.set = function(key, value)
	{
		_i.model.item[key] = value;
		_i.save();
	}

	_i.changed = function(event)
	{
		var key = $(event.target).attr("name"),
		value = $(event.target).val();
		if (key == 'tax_exempt') {
			if (!$(event.target).prop('checked')) {
				value = 0;
			}
		}
		_i.updateItemFees();
		_i.dl.updateTotals();
		_i.dl.updateRights();
		_i.set(key, value);
		_i.dl.details_tab.e.updateDetailsSummary();
	};

	_i.update = function()
	{
		_i.dl.details_tab.updateTypesSelect(true);
		_i.updateItemsSelect(true);
		_i.updateItemFees();
		_i.dl.updateTotals();
		_i.dl.details_tab.e.updateDetailsSummary();
	};

	_i.getDetailsTitle = function()
	{
		var title = "";
		if (_i.dl.details_tab.e.el.form.get_invoice_type() == 3) {
			title = _i.interface.description.val();
		} else {
			title = _i.interface.details_type_select.find("option:selected").text();
		}
		return title;
	};

	_i.updateItemFees = function()
	{
		// on load calc fee
		var fees = _i.calc.item_fees();
		var bypassed = fees[4] == 'bypassed';
		var	amount_received = fees[bypassed ? 2 : 0].toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}),
		amount_due = fees[bypassed ? 3 : 1].toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		_i.interface.cell_received.html(amount_received);
		_i.interface.cell_due.html(amount_due);
		_i.model.item.base_fee = fees[0];
		_i.model.item.due_fee = fees[1];
		if (bypassed) {
			_i.interface.cell_received.parent().addClass('bypassed');
		} else {
			_i.interface.cell_received.parent().removeClass('bypassed');
		}
	};

	_i.updateItemsSelect = function(maybe_save)
	{
		// remove select choices
		var previousValue = _i.interface.details_type_select.val();
		_i.config_name = _i.dl.details_tab.e.getConventionName();
		_i.interface.details_type_select.find("option").remove();

		// parse possible new choices
		var parent_name = _i.dl.details_tab.get_value('element_type');
		if (_i.dl.details_tab.e.getConventionTypes()[parent_name] != undefined){
			var child_items = _i.dl.details_tab.e.getConventionTypes()[parent_name].children;
			_i.find(".template-" + _i.config_name + "-detailsitem option").each(function(){
				if (child_items == "ALL" || $(this).val() == "NONE" || child_items.indexOf($(this).val()) !== -1 || !child_items.length){
					_i.interface.details_type_select.append($(this).clone());
				}
			});
		}

		// maybe save if value has to change
		if (maybe_save){
			if (previousValue && previousValue != 0 && previousValue != "NONE" && _i.interface.details_type_select.find("option[value=" + previousValue + "]").length){
				_i.interface.details_type_select.val(previousValue);
			} else {
				_i.interface.details_type_select.val("NONE").change();
			}
		}

		// make sure the model item has the current value
		_i.model.item.item_type = _i.interface.details_type_select.val();
	};

	return function()
	{
		// initialize item and save to db
		if (_i.dl.details_tab.e.getElementID()){
			_i.model.item.element_id = _i.dl.details_tab.e.getElementID();
			_i.model.item.list_order = parseInt(_i.find("input[name=list_order]").val(), 10);
			_i.model.item.item_type = _i.find("select[name=item_type]").val();
			_i.model.item.value = _i.find("input[name=value]").val();
			_i.model.item.tax_exempt = _i.find("input[name=tax_exempt]").prop('checked') ? 1 : 0;
			if (_i.find("input[name=base_bypass]").val()) {
				_i.model.item.base_bypass = parseFloat(_i.find("input[name=base_bypass]").val());
				_i.model.item.due_bypass = parseFloat(_i.find("input[name=due_bypass]").val());
			}
		}

		// change
		_i.on("change", _i.changed);
		_i.interface.trash_button.on("click", _i.trash);
		_i.interface.duplicate_button.on("click", _i.duplicate);
		_i.updateItemsSelect(false);

		// select with search
		_i.find(".element-select-search").each(function(){
			$(this).select2({
				language: "fr"
			}).on("select2:select", function(e){
				_i.interface.item_value.focus().select();
				_i.dl.updateRights();
			});
		});

		// update fees
		_i.updateItemFees();
		_i.dl.updateTotals();

		// cell bypass
		_i.interface.cell_received.BypassCell(_i);

		// return
		return _i;
	}();
};

$.fn.BypassCell = function(_i) {
	var cell = this;
	cell.item = _i;
	cell.bypass_field = cell.siblings('input');

	cell.clicked = function() {
		var bypass_value = prompt('Veuillez entrer le montant de la correction.', cell.bypass_field.val()), bypassed = false;
		if (bypass_value) {
			bypass_value = bypass_value.replace(',', '.');
			bypass_value = parseFloat(bypass_value);
			if (!isNaN(bypass_value) && bypass_value != 0) {
				bypassed = true;
				var redevance = cell.item.dl.details_tab.e.el.form.get_redevance();
				cell.item.set('base_bypass', bypass_value);
				cell.item.set('due_bypass', bypass_value * redevance / 100);
				cell.bypass_field.val(bypass_value);
			}
		}
		if (!bypassed) {
			cell.item.set('base_bypass', undefined);
			cell.item.set('due_bypass', undefined);
			cell.bypass_field.val('');
		}
		cell.item.trigger("change");
	};

	return function() {
		cell.on('click', cell.clicked);
		return cell;
	}();
}

$.fn.DetailsSummary = function(_element)
{
	var _ds = this;
	_ds.details_template;
	_ds.element = _element;
	
	_ds.setDetails = function(details_items)
	{
		_ds.empty();
		details_items.forEach(function(x)
		{
			// get item details
			var item = x.model.item,
			itemTitle = x.getDetailsTitle();
			var detailsLine = _ds.details_template.clone(),
			item_type = !itemTitle || itemTitle == " " || itemTitle == " " ? "–" : itemTitle,
			received = !x.model.getBase() ? 0 : x.model.getBase(),
			due = !x.model.getDue() ? 0 : x.model.getDue();
			received = received.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			due = due.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			
			// get value and display type
			var value = !item.value ? "–" : item.value,
			config = x.dl.details_tab.e.getConventionItems();
			if (item != undefined && item.item_type != 0 && item.item_type != "NONE" && item.item_type != undefined && config[item.item_type] != undefined){
				config_type = config[item.item_type].calc[0];
				switch (config_type){
					case '$':
					value = '–';
					break;
					case '%':
					value = parseInt(value, 10);
					value += "%";
					break;
				}
			};
			
			if (_ds.element.el.form.get_invoice_type() == 3) {
				detailsLine.find(".cell-value").text(received + ' $');
				detailsLine.find(".cell-tax_exempt").text(x.model.item.tax_exempt ? 'Sans taxe' : '–');
			} else {
				detailsLine.find(".cell-value").text(value);
			}
			detailsLine.find(".cell-desc").text(item_type);
			detailsLine.find(".cell-received").text(received);
			detailsLine.find(".cell-due").text(due);
			_ds.append(detailsLine);
		});
	};
	
	return function()
	{
		// template
		_ds.details_template = _ds.find(".slr-el-row-template").clone();
		_ds.details_template.removeClass("slr-el-row-template");
		_ds.find(".slr-el-row-template").remove();
		return _ds;
	}();
}

$.fn.UploaderFile = function(_up, _index)
{
	var _uf = this;
	_uf.up = _up;
	_uf.index = _index;
	_uf.filename = undefined;

	_uf.setFilename = function(filename)
	{
		_uf.filename = filename;
		_uf.find(".cell-filename").html(filename);
	};

	_uf.start = function()
	{
		_uf.removeClass("waiting");
		_uf.addClass("transfering");
	};

	_uf.end = function(response)
	{
		_uf.removeClass("transfering");
		var data = JSON.parse(response),
		linkUrl = _uf.find(".cell-filename").attr("href");
		if (data.success || data.id){
			_uf.attr("data-file-id", data.id);
			_uf.find(".cell-filename").attr("href", data.protected_url);
			if (_uf.up.params.callback != undefined){
				_uf.up.params.callback();
			}
		} else {
			_uf.fadeOut("fast");
			$.slr.notify({
				icon: 'fa fa-exclamation-circle',
				title: "Erreur lors du transfert",
				message: data.error ? data.error : "Le transfert a échoué."
			}, {
				type: 'danger',
				delay: 15
			});
		}
	};

	_uf.abort = function()
	{
		_uf.up.upload('abort', _uf.index);
		_uf.delete();
	};

	_uf.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer ce fichier?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer le fichier",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_uf.delete();
			}
		});
		return false;
	};

	_uf.delete = function()
	{
		// delete from interface
		_uf.fadeOut("fast");

		// get object id
		var index = 0;
		if (_uf.up.params.model == "contact"){
			index = 0;
		} else {
			index = _uf.up.params.parent.e.get_element_index();
		}

		// build api item
		var item = {
			id : _uf.up.params.id,
			file_id : _uf.data('file-id'),
			index: index,
		};
		if (_uf.up.params.str_id != undefined){
			item.str_id = _uf.up.params.str_id;
		}

		// quick api call
		var request = new FormData();
		request.append("model", _uf.up.params.model);
		if (_uf.up.params.type != undefined){
			request.append("type", _uf.up.params.type);
		}
		request.append("action", "delete_file");
		request.append("data", JSON.stringify(item));

		// add request to queue
		$.slr.db.add(request, _uf.deleted);
		return false;
	};

	_uf.deleted = function()
	{
		if (_uf.up.params.callback != undefined){
			_uf.up.params.callback();
		}
	};

	return function()
	{
		_uf.find(".btn-action-upload-abort").on("click", _uf.abort);
		_uf.find(".btn-action-upload-delete").on("click", _uf.trash);
		return _uf;
	}();
};

$.fn.Uploader = function(_params)
{
	var _up = this;
	_up.params = _params;
	_up.uploader = undefined;
	_up.interface = {
		files: undefined,
		holders: [],
		holder_template: undefined
	};

	_up.clear = function()
	{
		_up.interface.holders.forEach(function(x){
			x.delete();
		});
		_up.interface.holders = [];
	};

	/* Files */
	_up.filestart = function(e, file)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.start();
	}

	_up.fileprogress = function(e, file, percent)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.find(".progress-bar").css({
			width : percent+"%"
		});
	};

	_up.filecomplete = function(e, file, response)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.end(response);
	};

	/* Queue */
	_up.queue_start = function(e, files)
	{
		if (!_up.params.multiple){
			if (files.length > 1){
				_up.uploader.upload("abort");
				return false;
			}
			_up.clear();
		}
		_up.uploader.upload('disable');
		files.forEach(function(file){
			var file_holder = _up.interface.holder_template.clone().UploaderFile(_up, file.index);
			file_holder.addClass("waiting");
			file_holder.setFilename(file.name);
			_up.interface.holders[file.index] = file_holder;
			_up.interface.files.append(file_holder);
		});
	};

	_up.queue_ended = function(e)
	{
		_up.uploader.upload('enable');
	};

	_up.current_files = function()
	{
		_up.interface.files.find(".file-holder").each(function(index, el){
			var file_holder = $(this).UploaderFile(_up, index);
			_up.interface.holders[index] = file_holder;
		});
	};

	_up.reset = function()
	{
		_up.disable();
		_up.interface.holders.forEach(function(x){
			x.remove();
		});
		_up.interface.holders = [];
	};

	_up.disable = function()
	{
		_up.uploader.upload('disable');
	};

	return function()
	{
		// files
		_up.interface.files = _up.find(".files");

		// file holder template
		_up.interface.holder_template = _up.find(".file-holder-template").clone().removeClass("file-holder-template");
		_up.find(".file-holder-template").remove();

		// setup uploader
		_up.uploader = _up.find(".upload").upload({
			action: "/api/multiupload",
			autoUpload: true,
			multiple: _up.params.multiple,
			maxConcurrent: 1,
			maxSize: 268435456,
			label: _up.params.multiple ? 'Sélectionner des documents' : 'Sélectionner un document',
			beforeSend: function(formData, file)
			{
				for (key in _up.params.data){
					formData.append(key, _up.params.data[key]);
				}
				formData.append('id', _up.params.id);
				formData.append('model', _up.params.model);
				if (_up.params.type != undefined){
					formData.append('type', _up.params.type);
				}
				return formData;
			}
		});
		_up.uploader.on('start', _up.queue_start);
		_up.uploader.on('complete', _up.queue_ended);
		_up.uploader.on('filestart', _up.filestart);
		_up.uploader.on('filecomplete', _up.filecomplete);
		_up.uploader.on('fileerror', _up.fileerror);
		_up.uploader.on('fileprogress', _up.fileprogress);

		// load files
		_up.current_files();

		// return
		return _up;
	}();
};

$.fn.Calculator_FieldReset = function()
{
	var self = this;
	self.originalValue = self.find('input').val();
	
	return function(){
		self.find('.input-group-addon').on('click', function(){
			self.find('input').val(self.originalValue).trigger('change');
			return false;
		});
		return self;
	}();
};

$.fn.Calculator = function()
{
	var _calc = this;
	_calc.fields = {
		fee: _calc.find('input[name=calc-fee]'),
		tax: _calc.find('input[name=calc-tax]'),
		taxAmount: _calc.find('input[name=calc-tax-amount]'),
		taxTotal: _calc.find('input[name=calc-tax-total]'),
		tps: _calc.find('input[name=calc-tps]'),
		tpsAmount: _calc.find('input[name=calc-tps-amount]'),
		tvq: _calc.find('input[name=calc-tvq]'),
		tvqAmount: _calc.find('input[name=calc-tvq-amount]'),
		v: _calc.find('input[name=calc-v]'),
		vAmount: _calc.find('input[name=calc-v-amount]'),
		subtotal: _calc.find('input[name=calc-subtotal]'),
		total: _calc.find('input[name=calc-total]'),
		net: _calc.find('input[name=calc-reverse-net]'),
		brut: _calc.find('input[name=calc-reverse-brut]')
	};

	_calc.get_value = function(field)
	{
		return asFloat(field.val());
	};

	_calc.normalize = function(field, is_tax)
	{
		var value = asFloat(field.val());
		value = _calc.format(value, is_tax);
		field.val(value);
	};

	_calc.format = function(amount, is_tax)
	{
		if (is_tax == undefined){
			is_tax = false;
		}
		if (isNaN(amount)){
			amount = 0;
		}
		amount = amount.toLocaleString('fr-CA', {
			minimumFractionDigits: is_tax ? 1 : 2,
			maximumFractionDigits: is_tax ? 3 : 2
		});
		return amount;
	};

	_calc.run = function(event)
	{
		// normalize input
		var field = $(event.target);
		_calc.normalize(field, field.hasClass("tax-field"));

		// run calculations
		var base = _calc.get_value(_calc.fields.fee),
			tax = _calc.get_value(_calc.fields.tax),
			taxAmount = base*tax/100,
			taxTotal = base+taxAmount,
			tps = _calc.get_value(_calc.fields.tps),
			tvq = _calc.get_value(_calc.fields.tvq),
			v = _calc.get_value(_calc.fields.v),
			tpsAmount = taxTotal*tps/100,
			tvqAmount = taxTotal*tvq/100,
			vAmount = base*v/100,
			subtotal = base-vAmount,
			total = subtotal+tpsAmount+tvqAmount;

		// reverse calculation (thanks wolfram alpha)
		var net = _calc.get_value(_calc.fields.net),
			brut = 10000*net/(tvq*(tax+100)+tps*(tax+100)-100*(v-100));

		// display values in fields
		_calc.fields.taxAmount.val(_calc.format(taxAmount));
		_calc.fields.taxTotal.val(_calc.format(taxTotal));
		_calc.fields.tpsAmount.val(_calc.format(tpsAmount));
		_calc.fields.tvqAmount.val(_calc.format(tvqAmount));
		_calc.fields.vAmount.val(_calc.format(vAmount));
		_calc.fields.subtotal.val(_calc.format(subtotal));
		_calc.fields.total.val(_calc.format(total));
		_calc.fields.brut.val(_calc.format(brut));
	};

	_calc.setFee = function(new_fee)
	{
		_calc.fields.fee.val(new_fee).change();
	};

	return function()
	{
		_calc.find("input").on("change", _calc.run);
		_calc.find('.input-group.reset').each(function(){
			$(this).Calculator_FieldReset();
		});
		return _calc;
	}();
};

$.fn.RepeaterFieldRow = function(_field)
{
	// Instance
	if ($(this).data('repeaterFieldRow')){
		return $(this).data('repeaterFieldRow');
	}
	
	var _row = this;
	_row.field = _field;
	_row.data('repeaterFieldRow', _row);
	
	_row.el = {
		button: {
			remove: _row.find('.repeater-field__remove')
		}
	};
	
	_row.delete = function()
	{
		_row.field.remove_row(_row);
	};
	
	_row.val = function(new_values)
	{
		if (new_values != undefined){
			for (var name in new_values) {
				if (new_values.hasOwnProperty(name)) {
					var input = _row.find('[name=' + name + ']');
					if (input.attr("type") == "checkbox"){
						input.prop("checked", new_values[name] == 1).trigger('change');
					} else {
						input.val(new_values[name]).trigger('change');
					}
				}
			}
		} else {
			var values = {}, has_values = false;
			_field.names.forEach(function(name, index){
				var input = _row.find('[name=' + name + ']');
				var value = input.val();
				if (input.attr("type") == "checkbox"){
					value = input.prop("checked") ? "on" : "off";
				}
				if (value){ has_values = true; }
				values[name] = value;
			});
			return has_values ? values : false;
		}
	};
	
	return function()
	{
		_row.removeClass('template');
		_row.el.button.remove.on('click', _row.delete);
		_row.find('select').each(function(){
			if ($(this).hasClass('select-search')){
				$(this).select2({
					language: "fr"
				});
			} else if ($(this).hasClass("select")){
				$(this).selectpicker();
			}
		});
		_row.find(':input').on("change", function(){
			_row.field.trigger('update');
		})
		return _row;
	}();
};

$.fn.RepeaterField = function()
{
	// Instance
	if ($(this).data('repeaterField')){
		return $(this).data('repeaterField');
	}
	
	var _field = this;
	_field.el = {
		button: {
			add: _field.find('.repeater-field__add'),
		},
		container: _field.find('.repeater-field__rows'),
		template: _field.find('.repeater-field__row.template')
	};
	_field.rows = [];
	_field.names = [];
	$(this).data('repeaterField', _field);
	
	_field.add_row = function(row_values)
	{
		var newRow = _field.el.template.clone().RepeaterFieldRow(_field);
		if (row_values != undefined){
			newRow.val(row_values);
		}
		_field.el.container.append(newRow);
		_field.rows.push(newRow);
		_field.trigger("update");
		return newRow;
	};
	
	_field.remove_row = function(row)
	{
		var index = _field.rows.indexOf(row);
		if (index >= 0){
			_field.rows.splice(index, 1);
		}
		row.remove();
		_field.trigger("update");
	};
	
	_field.val = function()
	{
		var values = [];
		_field.rows.forEach(function(row, index){
			var row_values = row.val();
			if (row_values){
				values.push(row_values);
			}
		});
		return JSON.stringify(values);
	};
	
	return function()
	{
		_field.el.template.find(':input').each(function(){
			var fieldname = $(this).attr("name");
			if (fieldname != undefined){
				_field.names.push(fieldname);
			}
		});
		if (_field.data('value')){
			var value = _field.data('value');
			value.forEach(function(row, index){
				_field.add_row(row);
			});
		}
		_field.el.button.add.on('click', _field.add_row);
		_field.data('repeater_field', _field);
		return _field;
	}();
};
/*
*	Ordre de tabulation des factures: Tab et Maj+Tab suivent les parcours ci-dessous
*	plutôt que l'ordre du document. Hors d'un parcours, Tab garde son comportement normal.
*/
var TabOrder = {

	// Chaque parcours: un conteneur et ses étapes, résolues au moment de la touche.
	// Un sélecteur qui touche plusieurs lignes donne une étape par champ, dans l'ordre du document.
	flows: [
		// Nouvelle facture: destinataire, champs de facturation, référence, puis Sauvegarder
		{
			container: 'body',
			when: function(){ return $('.slr-form input[name=action]').val() == 'add'; },
			steps: ['#field-contact_id', '#field-invoiced', '#field-att', '#field-reference', function(){ return $('.btn-action-submit'); }]
		},
		// Cachet (publicité)
		{
			container: '.slr-fee-tab',
			steps: [
				'input[name=nb_annonces]',
				'input[name=apc_tableau]',
				'input[name=circuit]',
				'input[name=use]',
				'input[name=use2]',
				'input[name=inm_diffusion]',
				'input[name=role]',
				'input[name=cond_percent]',
				'input[name=cond_diff_percent]',
				'input[name=cycle]',
				'select[name=duration]',
				'select[name=inm_duration]',
				'input[name=cycle_date1]',
				'input[name=cycle_date2]',
				'button[data-action=next-tab]'
			]
		},
		// Garanties et cachet (autre)
		{
			container: '.slr-guarantees-tab',
			steps: ['select[name=fonction]', 'input[name=jours_tournage]', 'input[name=emissions_episodes]', 'input[name=droits_percent]', 'input[name=cachet]', 'button[data-action=next-tab]']
		},
		// Lignes de garanties, puis Ajouter
		{
			container: '.slr-guarantees-tab',
			steps: ['.repeater-field__rows select[name=guarantee_item], .repeater-field__rows input[name=guarantee_number]', '.repeater-field__add', 'button[data-action=next-tab]']
		},
		// Détails: type, dates, lignes, puis +
		{
			container: '.slr-details-tab',
			steps: [
				'select[name=element_type]',
				'input[name=date1]',
				'input[name=date2]',
				'.slr-details-item-container select[name=item_type], .slr-details-item-container textarea[name=description], .slr-details-item-container input[name=value]',
				'.btn-action-add-details'
			]
		},
		// Contrat: le bouton Suivant
		{
			container: '.slr-contract-tab',
			steps: ['button[data-action=next-tab]']
		},
		// Édition de facture: la redevance mène à l'onglet ouvert de l'élément
		{
			container: 'body',
			when: function(){ return $('.slr-form input[name=action]').val() == 'edit'; },
			steps: ['#field-redevance', function(){ return TabOrder.openTabEntry(); }]
		}
	],

	// Champ qui reçoit vraiment le focus: la boîte select2, le bouton bootstrap-select ou le bouton radio coché
	target: function(el, container)
	{
		var $el = $(el);
		if ($el.is('select') && $el.next('.select2').length){
			return $el.next('.select2').find('.select2-selection')[0];
		}
		if ($el.is('select') && $el.closest('.bootstrap-select').length){
			return $el.closest('.bootstrap-select').find('button.dropdown-toggle')[0];
		}
		if ($el.is(':radio')){
			var group = $(container).find('input[type=radio][name="' + el.name + '"]').filter(':visible');
			return group.filter(':checked')[0] || group[0];
		}
		return el;
	},

	// Étapes d'un parcours: [{focus, members}], sans les champs cachés ou désactivés
	resolve: function(flow, container)
	{
		var steps = [];
		flow.steps.forEach(function(step){
			var found = (typeof step === 'function') ? step() : $(step, container);
			var radios = {};
			$(found).each(function(){
				if ($(this).is(':radio')){
					if (radios[this.name]){ return; }
					radios[this.name] = true;
				}
				var focus = TabOrder.target(this, container);
				if (!focus || !$(focus).is(':visible') || $(focus).is(':disabled')){ return; }
				var members = $(this).is(':radio') ? $(container).find('input[type=radio][name="' + this.name + '"]').get() : [focus];
				steps.push({ focus: focus, members: members });
			});
		});
		return steps;
	},

	// Premier champ de l'onglet ouvert de l'élément sélectionné
	openTabEntry: function()
	{
		var tab = $('.slr-el.selected .card-collapse.show .card-block').first();
		return tab.length ? TabOrder.firstStep(tab) : $();
	},

	firstStep: function(tab)
	{
		for (var i = 0; i < TabOrder.flows.length; i++){
			var flow = TabOrder.flows[i];
			if (!flow.when && tab.is(flow.container)){
				var steps = TabOrder.resolve(flow, tab);
				if (steps.length){ return $(steps[0].focus); }
			}
		}
		return $();
	},

	// Donne le focus à un champ; le texte d'une case est sélectionné pour être tapé par-dessus
	focus: function(el)
	{
		$(el).focus();
		if ($(el).is('input[type=text], input:not([type])')){
			el.select();
		}
	},

	// Donne le focus au premier champ d'un onglet, une fois ouvert
	focusTab: function(tab)
	{
		var first = TabOrder.firstStep($(tab).find('.card-block').first());
		if (first.length){
			TabOrder.focus(first[0]);
		}
	},

	// Étapes du parcours qui contient ce champ et sa position, ou null hors parcours
	locate: function(el)
	{
		for (var i = 0; i < TabOrder.flows.length; i++){
			var flow = TabOrder.flows[i];
			var container = $(el).closest(flow.container);
			if (!container.length || (flow.when && !flow.when())){ continue; }
			var steps = TabOrder.resolve(flow, container);
			var index = steps.findIndex(function(step){ return step.members.indexOf(el) >= 0; });
			if (index >= 0){ return { steps: steps, index: index }; }
		}
		return null;
	},

	// Vrai entre un Enter dans une liste select2 ouverte et sa fermeture
	select2Enter: false,

	// Après un choix dans une liste: passe au champ suivant, sauf si le focus a déjà été placé ailleurs
	advance: function(select)
	{
		var from = TabOrder.target(select);
		var active = document.activeElement;
		if (active && active !== document.body && active !== from){ return; }
		var found = TabOrder.locate(from);
		var next = found && found.steps[found.index + 1];
		if (next){
			TabOrder.focus(next.focus);
		}
	},

	keydown: function(e)
	{
		if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey){ return; }
		var found = TabOrder.locate(document.activeElement);
		var next = found && found.steps[found.index + (e.shiftKey ? -1 : 1)];
		if (next){
			e.preventDefault();
			TabOrder.focus(next.focus);
		}
	},

	// bootstrap-select 1.12 suit Bootstrap 3: sous Bootstrap 4, sa liste ouverte ne répond ni aux flèches ni à Enter.
	// Capté avant les deux librairies: les flèches parcourent les options, Enter ou Espace choisit, Échap referme.
	selectpickerKeydown: function(e)
	{
		var option = $(e.target).filter('.bootstrap-select [role=listbox] li > a');
		if (!option.length){ return; }
		var picker = option.closest('.bootstrap-select');
		var options = picker.find('[role=listbox] li').not('.disabled, .hidden, .dropdown-header, .divider').children('a');
		var index = options.index(option);
		if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
			options.eq(Math.max(0, Math.min(options.length - 1, index + (e.key === 'ArrowDown' ? 1 : -1)))).focus();
		} else if (e.key === 'Enter' || e.key === ' '){
			option[0].click();
			TabOrder.advance(picker.find('select')[0]);
		} else if (e.key === 'Escape'){
			picker.find('.dropdown-toggle').trigger('click').focus();
		} else {
			return;
		}
		e.preventDefault();
		e.stopPropagation();
	}
};

$(document).on('keydown', TabOrder.keydown);
document.addEventListener('keydown', TabOrder.selectpickerKeydown, true);

// Choix fait dans une liste select2, au clic ou au clavier: le focus suit au champ suivant.
// Rechoisir la valeur en place avec Enter ferme la liste sans choix: le focus suit aussi.
// Délai: les gestionnaires propres au champ et la fermeture de select2 passent d'abord.
document.addEventListener('keydown', function(e){
	if (e.key === 'Enter' && $('.select2-container--open').length){ TabOrder.select2Enter = true; }
}, true);
$(document).on('select2:select', function(e){
	setTimeout(function(){ TabOrder.advance(e.target); }, 0);
}).on('select2:close', function(e){
	var enter = TabOrder.select2Enter;
	TabOrder.select2Enter = false;
	setTimeout(function(){
		if (enter && document.activeElement === document.body){ TabOrder.advance(e.target); }
	}, 0);
});

$.fn.DepotTable = function(_depot) {
	var self = this;

	self.clicked_row = function() {
		var json_string = $(this).find('td:last-child textarea').val();
		var id = $(this).find('td:last-child input[name="id"]').val();
		var name = $(this).find('td:last-child input[name="name"]').val();
		var credit = asFloat($(this).find('td:last-child input[name="credit"]').val());
		var data = JSON.parse(json_string);
		_depot.details.display(id, name, credit, data);
	}

	return function() {
		self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[1, 'asc']],
			layout: {
				topStart: 'search',
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$('.dt-container > .row:first-child').css('visibility', 'visible');
				$(".dt-search").append($('#depot-filters').css('display', 'inline-block'));
				$(".dt-search input[type=search]").unbind().bind('keypress', function(e) {
					if (e.keyCode == 13) {
						self.DataTable().search(this.value).draw();
					}
				});
				$('.dt-search .table-search-clear').off().on('click', function() {
					if (!$(".dt-search input[type=search]").val()) {
						return;
					}
					$(".dt-search input[type=search]").val('');
					setTimeout(function() {
						self.DataTable().search('').draw();
					}, 35);
				});
				$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
				$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em').focus();
			},
			footerCallback: function(row, data, start, end, display) {
				let total = 0
				display.forEach(function(index) {
					total += data[index].total.total_amount;
				})
				$('.due-table-total').html(total.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}) + '&thinsp;$');
			},
		});
		self.on('click', 'tbody tr', self.clicked_row);
		return self;
	}();
}

$.fn.DepotList = function(_depot) {
	var self = this;
	return function() {
		self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			layout: {
				topStart: 'search',
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$('.dt-container > .row:first-child').css('visibility', 'visible');
				$(".dt-search").append($('#depot-list-filters').css('display', 'inline-block'));
				$(".dt-search input[type=search]").unbind().bind('keypress', function(e) {
					if (e.keyCode == 13) {
						self.DataTable().search(this.value).draw();
					}
				});
				$('.dt-search .table-search-clear').off().on('click', function() {
					if (!$(".dt-search input[type=search]").val()) {
						return;
					}
					$(".dt-search input[type=search]").val('');
					setTimeout(function() {
						self.DataTable().search('').draw();
					}, 35);
				});
				$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
				$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em').focus();
			}
		});
		return self;
	}();
}

$.fn.DepotDetails = function(_depot) {
	var self = this;
	self.current_id = undefined;
	self.selectToggle = false;
	self.amountChanged = false;
	self.table = undefined;
	self.el = {
		title: self.find('h5 .name-cell'),
		instruction: self.find('.hide-on-select'),
		wrapper: self.find('.table-wrapper'),
		select_all: self.find('.btn-action-select-all'),
		date_field: self.find('input[name="payment_date"]'),
		total_cell: self.find('span.invoices-total-cell'),
		code_field: self.find('input[name="payment_code"]'),
		amount_field: self.find('input[name="payment_amount"]'),
		cheque_field: self.find('input[name="payment_cheque"]'),
		payment_form: self.find('form'),
		credit: self.find('.credit-container'),
		credit_cell: self.find('.credit-cell'),
		account_report: self.find('a.rapport-a-payer'),
	};

	self.checked_row = function() {
		var checkbox = $(this).find('input[name="depot_invoice"]');
		if (checkbox.prop('checked') == true) {
			checkbox.prop('checked', false).change();
		} else {
			checkbox.prop('checked', true).change();
		}
	};

	self.display = function(id, name, credit, data) {
		if (self.current_id != id) {
			self.current_id = id;
			self.el.title.text(name);
			if (credit > 0) {
				self.el.credit_cell.html(credit.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}));
				self.el.credit.show();
			} else {
				self.el.credit_cell.html((0).toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}));
				self.el.credit.show();
			}
			self.el.instruction.remove();
			self.el.wrapper.removeClass('d-none');
			self.table.clear();
			self.table.rows.add(data).draw();
			self.changeRapportLink()
		}
	};

	self.tableChanged = function() {
		self.unselectAll();
		self.find('input[type="checkbox"]').on('change', self.selectionChanged);
	}

	self.changeRapportLink = function() {
		var link = '/depot/a-payer/' + self.current_id, request = ''
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				if (!request) {
					request = '?selection='
				} else {
					request += ',';
				}
				request += $(this).val();
			}
		});
		self.el.account_report.attr('href', link + request);
	}

	self.selectionChanged = function() {
		var allSelected = true;
		var paymentTotal = 0, creditAmount = asFloat(self.el.credit_cell.text());
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				var lineTotal = asFloat($(this).closest('tr').find('input[name="total"]').val());
				paymentTotal += lineTotal;
			} else {
				allSelected = false;
			}
		});
		var displayedTotal = paymentTotal - creditAmount;
		if (displayedTotal < 0) {
			displayedTotal = 0;
		}
		if (!self.amountChanged) {
			self.el.amount_field.val(displayedTotal.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		}
		self.el.total_cell.text(displayedTotal.toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		if (allSelected) {
			self.selectToggle = true;
			self.displayUnselectAllButton();
		} else {
			self.selectToggle = false;
			self.displaySelectAllButton();
		}
		self.changeRapportLink();
	}

	self.selectAll = function() {
		if (!self.selectToggle){
			self.selectToggle = true;
			self.find('input[type="checkbox"]').prop('checked', true).change();
			self.displayUnselectAllButton();
		} else {
			self.selectToggle = false;
			self.find('input[type="checkbox"]').prop('checked', false).change();
			self.displaySelectAllButton();
		}
	};

	self.unselectAll = function() {
		self.selectToggle = false;
		self.find('input[type="checkbox"]').prop('checked', false).change();
		self.el.date_field.val(self.el.date_field.data('today'));
		self.el.cheque_field.val('');
		self.el.code_field.val('').trigger('change');
		self.el.amount_field.val(asFloat(0).toLocaleString('fr-CA', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}));
		self.displaySelectAllButton();
		self.amountChanged = false;
	};

	self.displaySelectAllButton = function() {
		self.el.select_all.find('span:not(.material-symbols-outlined)').text("Sélectionner tout");
		// self.el.select_all.find('i').removeClass("fa-close").addClass("fa-check");
	};

	self.displayUnselectAllButton = function() {
		self.el.select_all.find('span:not(.material-symbols-outlined)').text("Désélectionner tout");
		// self.el.select_all.find('i').removeClass("fa-check").addClass("fa-close");
	};

	self.code_changed = function() {
		if (self.el.code_field.val()) {
			if (self.request != undefined) {
				self.request.abort()
			}
			$('.code-link').remove()
			self.el.code_field.val(self.el.code_field.val().trim())
			self.request = $.ajax('/depot/code-check', {
				type: 'POST',
				data: {
					code: self.el.code_field.val(),
					contact_id: self.current_id,
				},
				dataType: 'json',
				success: function(x) {
					$('input[name="depot_invoice"]').prop('checked', false).trigger('change')
					x.forEach(function(invoice_id) {
						$('input[name="depot_invoice"][value="' + invoice_id + '"]').prop('checked', true).trigger('change')
					})
					self.el.code_field.after('<a href="/depot/code/' + self.current_id + '?code=' + self.el.code_field.val() + '" class="btn btn-sm btn-primary code-link" target="_blank">Consulter</a>')
					self.request = undefined
				}
			})
		} else {
			$('.code-link').remove()
		}
	}

	self.submit_form = function(e) {
		// gather data
		var request = new FormData(), data = {}, paidMinimum = 0;
		data.contact_id = self.current_id;
		data.invoices = [];
		self.find('input[type="checkbox"]').each(function() {
			if ($(this).prop('checked')) {
				data.invoices.push($(this).val());
				paidMinimum += asFloat($(this).closest('tr').find('input[name="total"]').val())
			}
		});
		data.date = self.el.date_field.val();
		data.amount = asFloat(self.el.amount_field.val());
		data.cheque = self.el.cheque_field.val();
		data.code = self.el.code_field.val();

		// deposit specified
		if ($('input[name="deposit_id"]').val()) {
			data.deposit_id = $('input[name="deposit_id"]').val();
		}

		// validate over & under
		var availableAmount = data.amount + asFloat(self.el.credit_cell.text());
		if (availableAmount >= paidMinimum - .05) {	// 5¢ leniency in rounding totals
			if (availableAmount <= paidMinimum + .05) {	// 5¢ leniency in rounding totals
				// same amount
				request.append("model", "deposit");
				request.append("action", "make_payment");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			} else {
				// larger amount (will credit contact)
				swal({
					title: "Un crédit de " + (availableAmount - paidMinimum).toLocaleString('fr-CA', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}) + " $ sera appliqué",
					text: "Le montant disponible est supérieur au total des factures sélectionnées. Un crédit sera appliqué au dossier de " + $('#depot-details h5:first strong').html() + '.',
					type: "warning",
					showCancelButton: true,
					confirmButtonClass: "btn-success",
					confirmButtonText: "Continuer",
					cancelButtonText: "Annuler",
					closeOnConfirm: true,
					closeOnCancel: true
				}, function(isConfirm) {
					if (isConfirm) {
						// same amount
						request.append("model", "deposit");
						request.append("action", "make_payment");
						request.append("data", JSON.stringify(data));

						// add request to queue
						$.slr.db.add(request);
					}
				});
			}
		} else {
			swal({
				title: "Montant insuffisant",
				text: "Le montant est insuffisant pour les factures sélectionnées. Veuillez désélectionner une ou plusieurs factures.",
				type: "error",
				showCancelButton: true,
				confirmButtonClass: "btn-info",
				confirmButtonText: "Annuler",
				cancelButtonText: "Forcer le dépôt",
				closeOnConfirm: true,
				closeOnCancel: true,
				allowEnterKey: false,
			}, function(isConfirm) {
				if (!isConfirm) {	// to avoid "enter" default is cancel
					// same amount
					request.append("model", "deposit");
					request.append("action", "make_payment");
					request.append("data", JSON.stringify(data));

					// add request to queue
					$.slr.db.add(request);
				}
			});
		}
		return false;
	};

	self.updated = function(invoice_ids, credit) {
		self.unselectAll();

		/* remove lines */
		self.find('input[type="checkbox"]').each(function() {
			if (invoice_ids.indexOf($(this).val()) !== -1) {
				$(this).closest('tr').fadeOut(300, function() {
					self.table.row($(this)).remove().draw();
				});
			}
		});

		/* update credit */
		self.set_credit(credit)

		/* update table */
		_depot.table.DataTable().ajax.reload();
	};

	self.set_credit = function(credit) {
		/* update credit */
		var credit = asFloat(credit);
		if (credit >= 0.05) {
			self.el.credit_cell.html(credit.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			self.el.credit.show();
		} else {
			self.el.credit_cell.html((0).toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			self.el.credit.show();
		}

		/* credit in hidden field */
		$('.due-table').find('input[name="id"][value="' + self.current_id + '"]').parent().find('input[name="credit"]').val(credit)
	}

	self.delete_payment = function(e) {
		var request = new FormData(), data = {};
		data.payment_id = $(this).data('delete-payment');
		data.deposit_id = $(this).data('deposit');
		data.contact_id = $(this).data('contact');
		swal({
			title: "Suppression d'un paiement",
			text: "Ceci effacera le paiement et marquera toutes les factures associées comme étant non-payées.",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-success",
			confirmButtonText: "Oui, supprimer ce paiement",
			cancelButtonText: "Annuler",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm) {
			if (isConfirm) {
				// same amount
				request.append("model", "deposit");
				request.append("action", "withdraw_payment");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			}
		});
	};

	self.credit_clicked = function() {
		var bypass_value = prompt('Veuillez entrer le montant de la correction.');
		if (bypass_value || bypass_value === 0 || bypass_value === '0') {
			if (bypass_value < 0) {
				bypass_value = 0
			}
			bypass_value = bypass_value.replace(',', '.');
			bypass_value = bypass_value.replace(' ', '');
			bypass_value = bypass_value.replace(' ', '');
			bypass_value = parseFloat(bypass_value);
			if (!isNaN(bypass_value)) {
				if (bypass_value < 0.05) {
					bypass_value = 0;
				}

				// gather data
				var request = new FormData(),
				data = {};

				// build request
				request.append("model", "deposit");
				request.append("action", "credit");
				request.append("data", JSON.stringify({
					contact_id: self.current_id,
					credit: bypass_value,
				}));

				// add request to queue
				$.slr.db.add(request, function(x) {
					self.set_credit(bypass_value)
				});
			}
		}
	};

	return function() {
		// Initialize data table
		$("table.details-table").each(function(){
			self.table = $(this).DataTable({
				language: {
					url: '/assets/libraries/DataTables-fr_FR.json',
				},
				order: [[2, 'asc']],
				layout: {
					topStart: null,
					topEnd: null,
					bottomStart: null,
					bottomEnd: null,
				},
				paging: false,
			});
			self.table.on('draw', self.tableChanged);
		});
		$("table.deposit-table").each(function(){
			self.table = $(this).DataTable({
				language: {
					url: '/assets/libraries/DataTables-fr_FR.json',
				},
				layout: {
					topStart: null,
					topEnd: null,
					bottomStart: null,
					bottomEnd: null,
				},
				paging: false,
			});
			self.table.on('draw', self.tableChanged);
		});
		self.on('click', 'table.details-table tbody tr', self.checked_row);
		self.on('click', 'table.deposit-table button[data-delete-payment]', self.delete_payment);
		self.el.select_all.on('click', self.selectAll)
		self.find('.depot-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			});
		});
		self.el.payment_form.on('submit', self.submit_form);
		self.el.code_field.on('input', self.code_changed);
		self.el.amount_field.on('keypress change', function() {
			var currentAmount = asFloat(self.el.amount_field.val());
			if (currentAmount > 0) {
				self.amountChanged = true;
			} else {
				self.amountChanged = false;
			}
		});
		self.el.credit_cell.on('click', self.credit_clicked);
		return self;
	}()
}

$.fn.Depot = function() {
	var self = this;
	self.table = undefined;
	self.details = undefined;
	self.list = undefined;
	self.interface = {
		btn_close_deposit: $('.btn-action-close-deposit'),
	};

	self.close_deposit = function() {
		swal({
			title: "Fermeture du dépôt en cours",
			text: "Êtes-vous certain de vouloir fermer le dépôt en cours?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-success",
			confirmButtonText: "Oui, fermer le dépôt",
			cancelButtonText: "Annuler",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm) {
			if (isConfirm) {
				var request = new FormData(), data = {};
				request.append("model", "deposit");
				request.append("action", "close");
				request.append("data", JSON.stringify(data));

				// add request to queue
				$.slr.db.add(request);
			}
		});
	}

	return function() {
		self.table = self.find('.due-table').DepotTable(self);
		self.list = self.find('.list-table').DepotList(self);
		self.details = self.find('#depot-details').DepotDetails(self);
		self.interface.btn_close_deposit.on('click', self.close_deposit);
		var at_date_picker = $('.input-group.date').not('.depot-date-picker');
		if (at_date_picker.length) {
			at_date_picker.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			}).on('dp.change', function(e) {
				if (!e.date) return;
				if (e.date.isSame(moment(), 'day')) {
					location.href = '/depot/comptes/';
				} else {
					location.href = '/depot/comptes-recevoir-date/' + e.date.format('YYYYMMDD');
				}
			});
		}
		return self;
	}()
}

$.fn.RapportTable = function(_rapport) {
	var self = this;
	self.request = undefined
	self.details = {
		pub: $('.rapport-details-table--pub'),
		tv: $('.rapport-details-table--tv'),
		vhc: $('.rapport-details-table--vhc'),
	}
	self.status = {
		main_loaded: false,
		pub_loaded: false,
		tv_loaded: false,
		vhc_loaded: false,
	}

	self.reset = function() {
		if (self.request != undefined) {
			self.request.abort()
		}
		if (self.status.main_loaded) {
			self.DataTable().clear().destroy()
			self.find('thead tr').remove()
			self.find('tfoot tr').remove()
			self.status.main_loaded = false
			self.off('click', 'tr')
		}
		$('.rapport-table__details').addClass('d-none')
	}

	self.update = function() {
		var contacts = [], fields = [], years = [], period = [];
		contacts = _rapport.filters.find('select[name="contact"]').val();
		if (_rapport.filters.find('input[name="single_contact"]').length) {
			contacts = [_rapport.filters.find('input[name="single_contact"]').val()]
		}
		if (!contacts || !contacts.length) {
			return
		}
		_rapport.filters.find('input[name="fields[]"]:checked').each(function() {
			fields.push($(this).val());
		})
		if (_rapport.filters.period_type == 'years') {
			years = [_rapport.filters.find('select[name="year_start"]').val(), _rapport.filters.find('select[name="year_end"]').val()];
		}
		if (_rapport.filters.period_type == 'period') {
			period = [_rapport.filters.find('input[name="period_start"]').val(), _rapport.filters.find('input[name="period_end"]').val()];
		}

		if (self.request != undefined) {
			self.request.abort()
		}

		self.request = $.ajax('/rapport/data', {
			type: 'POST',
			data: {
				contact: contacts,
				fields: fields,
				years: years,
				period: period,
			},
			dataType: 'json',
			complete: function(x) {
				self.request = undefined
				var data = JSON.parse(x.responseText)
				if (self.status.main_loaded) {
					self.DataTable().clear().destroy()
					self.find('thead tr').remove()
					self.status.main_loaded = false
					self.off('click', 'tr')
				}
				if (self.status.pub_loaded) {
					self.status.pub_loaded = false
					self.details.pub.DataTable().clear().destroy()
					self.details.pub.find('thead tr').remove()
					self.details.pub.find('tfoot').remove()
				}
				if (self.status.tv_loaded) {
					self.status.tv_loaded = false
					self.details.tv.DataTable().clear().destroy()
					self.details.tv.find('thead tr').remove()
					self.details.tv.find('tfoot').remove()
				}
				if (self.status.vhc_loaded) {
					self.status.vhc_loaded = false
					self.details.vhc.DataTable().clear().destroy()
					self.details.vhc.find('thead tr').remove()
					self.details.vhc.find('tfoot').remove()
				}
				$('.rapport-table__details').addClass('d-none')
				self.find('tfoot').remove()
				if (data.data.length > 1) {
					self.append('<tfoot><tr><th colspan="2">Total&thinsp;:</th></tr></tfoot>');
					var tfoot = self.find('tfoot tr');
					for (var i = 2; i < data.columns.length; i++) {
						tfoot.append('<th></th>');
					}
				}

				var mainTable = self.DataTable({
					language: { url: '/assets/libraries/DataTables-fr_FR.json' },
					order: [[1, 'asc']],
					layout: {
						topStart: null,
						topEnd: null,
						bottomStart: null,
						bottomEnd: null,
					},
					paging: false,
					data: data.data,
					columns: data.columns,
					footerCallback: function (row, data, start, end, display) {
						var api = this.api();
						api.columns().every(function (index) {
							if (index >= 2) {
								var total = 0;
								api.rows({ filter: 'applied' }).every(function (rowIndex, tableLoop, rowLoop) {
									var cellData = api.cell(rowIndex, index).data();
									total += parseFloat(cellData.replace(' ', '').replace(',', '.')) || 0;
								});
								$(api.column(index).footer()).html(total.toLocaleString('fr-CA', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2
								}) + '&thinsp;$');
							}
						});
					},
					initComplete: function() {
						self.status.main_loaded = true
						var thead = $('<tr class="rapport-years"><th colspan="1">&nbsp;</th></tr>')
						if (data.data.length > 0 && period && period.length == 2) {
							thead.append('<th class="year" colspan="' + fields.length + '">' + period[0] + ' — ' + period[1] + '</th>');
						} else if (data.data.length > 0 && years && years.length == 2) {
							for (var i = years[0]; i <= years[1]; i++) {
								thead.append('<th class="year" colspan="' + fields.length + '">' + i + '</th>');
							}
						}
						self.find('thead tr').before(thead.clone());
					},
				})

				self.on('click', 'tr', function() {
					var data = mainTable.row(this).data();
					if (data && 'id' in data) {
						if (!$('body').hasClass('solis')) {
							display_details(data.id, 'pub');
							display_details(data.id, 'vhc');
						}
						display_details(data.id, 'tv');
						$('.rapport-table__details').removeClass('d-none')
					}
				});

				function display_details(contact_id, type) {
					if (data.details_data.length < 1) {
						return;
					}

					if (self.status[type + '_loaded']) {
						self.status[type + '_loaded'] = false
						self.details[type].DataTable().clear().destroy()
					}
					self.details[type].find('thead tr').remove()
					self.details[type].find('tfoot').remove()
					self.details[type].append('<tfoot><tr><th colspan="2">Total&thinsp;:</th></tr></tfoot>');
					var tfoot = self.details[type].find('tfoot tr');
					for (var i = 2; i < data.columns.length; i++) {
						tfoot.append('<th></th>');
					}

					let details_table = self.details[type].DataTable({
						language: { url: '/assets/libraries/DataTables-fr_FR.json' },
						order: [[0, 'asc']],
						paging: false,
						data: data.details_data,
						columns: data.details_columns,
						layout: {
							topStart: ['search', {
								buttons: [
									{
										extend: 'excel',
										text: 'Télécharger Excel',
										className: 'btn btn-primary btn-sm',
										exportOptions: {
											modifier: {
												page: 'current'
											},
											format: {
												body: function (data, row, column, node) {
													data = $(node).text().trim()
													if (column === 0) {
														return data.split(' ')[0].trim();
													}
													if (column >= 2) {
														let numericValue = parseFloat(data.replace(',', '.').replace(/[^\d.-]/g, ''));
														return !isNaN(numericValue) ? numericValue : data;
													}
													return data;
												}
											}
										},
										init: function (api, node, config) {
											$(node).html('<span class="material-symbols-outlined mr-1">download</span><span>Télécharger Excel</span>');
										},
										// customize: function (xlsx) {
										// 	// let sheet = xlsx.xl.worksheets['sheet1.xml'];
										// 	// $('c[r^="C"]', sheet).each(function () {
										// 	// 	$(this).attr('s', '5');
										// 	// });
										// }
									}
								],
							}],
							topEnd: null,
							bottomStart: null,
							bottomEnd: null,
						},
						footerCallback: function (row, data, start, end, display) {
							var api = this.api();
							api.columns().every(function (index) {
								if (index >= 2) {
									var total = 0;
									api.rows({ filter: 'applied' }).every(function (rowIndex, tableLoop, rowLoop) {
										var cellData = api.cell(rowIndex, index).data();
										total += parseFloat(cellData.replace(' ', '').replace(',', '.')) || 0;
									});
									$(api.column(index).footer()).html(total.toLocaleString('fr-CA', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) + '&thinsp;$');
								}
							});
						},
						initComplete: function() {
							$('.col-md-auto').addClass('col')
							$('.dt-container > .row:first-child').css('visibility', 'visible')
							$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
							$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em');

							self.status[type + '_loaded'] = true
							var table_title = '', search_key = ''
							switch (type) {
								case 'tv':
								table_title = 'AUTRES';
								search_key = '(?=.*_t2_)(?=.*c' + contact_id + '_)';
								break;
								case 'pub':
								table_title = 'PUBLICITÉ';
								search_key = '(?=.*_t1_)(?=.*c' + contact_id + '_)';
								break;
								case 'vhc':
								table_title = 'VOIX HORS-CHAMP';
								search_key = '(?=.*_t4_)(?=.*c' + contact_id + '_)';
								break;
							}
							if (period && period.length == 2) {
								var tr_years = self.find('thead tr:first').clone();
								tr_years.find('th:first').attr('colspan', 2).html(table_title);
								self.details[type].find('thead tr').before(tr_years);
							} else if (years && years.length == 2) {
								var tr_years = self.find('thead tr:first').clone();
								tr_years.find('th:first').attr('colspan', 2).html(table_title);
								self.details[type].find('thead tr').before(tr_years);
							}
							var table = this.api();
							table.column(0).search(search_key, true, false).draw()
							if ($('#custom-search input').val()) {
								table.column(1).search($('#custom-search input').val()).draw()
							}
						},
					})

					/* Live reference search */
					$('#custom-search input').on('keyup', function() {
						details_table.column(1).search($(this).val()).draw()
					})
				}
			}
		})
	}

	return function() {
		return self;
	}();
}

$.fn.RapportFilters = function(_rapport) {
	var self = this;
	self.period_type = 'period'

	self.period_type_changed = function() {
		self.period_type = $(this).val()
		if (self.period_type == 'period') {
			self.find('.period-date-picker').parent().removeClass('d-none')
			self.find('.year-picker').parent().addClass('d-none')
		} else {
			self.find('.period-date-picker').parent().addClass('d-none')
			self.find('.year-picker').parent().removeClass('d-none')
		}
	}

	self.period_changed = function(e) {
		let changedField = $(e.currentTarget).find('input').attr('name'),
		periodStartValue = self.find('input[name="period_start"]').val(),
		periodEndValue = self.find('input[name="period_end"]').val()
		if (changedField == 'period_start' && periodStartValue > periodEndValue) {
			self.find('input[name="period_end"]').val(periodStartValue)
		} else if (changedField == 'period_end' && periodEndValue < periodStartValue) {
			self.find('input[name="period_start"]').val(periodEndValue)
		}
	}

	self.year_changed = function(e) {
		let changedField = $(e.currentTarget).attr('name'),
		yearStartValue = self.find('select[name="year_start"]').val(),
		yearEndValue = self.find('select[name="year_end"]').val()
		if (changedField == 'year_start' && yearStartValue > yearEndValue) {
			self.find('select[name="year_end"]').find('option[value="' + yearStartValue + '"]').prop('selected', true);
    	self.find('select[name="year_end"]').trigger('change');
		} else if (changedField == 'year_end' && yearEndValue < yearStartValue) {
			self.find('select[name="year_start"]').find('option[value="' + yearEndValue + '"]').prop('selected', true);
    	self.find('select[name="year_start"]').trigger('change');
		}
	}

	return function() {
		self.find('.select2[multiple]').each(function() {
			$(this).select2(select2WithCompany({
				allowClear: true,
			}));
			$(this).on('select2:select', function(e) {
				if (e.params.data.id === 'select_all') {
					self.find('.select2[name="contact"]').find('option').not('[value="select_all"]').prop('selected', true);
					$('option[value="select_all"]').prop('selected', false);
					$('option[value="select_all"]').closest('select').trigger('change');
				}
			});
			$(this).on('select2:unselecting', function(e) {
				// Prevent dropdown from opening after unselecting
				$(this).one('select2:opening', function(e) {
					e.preventDefault();
				});
			});
		})

		// Custom clear button for contact select
		var $contactSelect = $('select[name="contact"]');
		if ($contactSelect.length) {
			var $container = $contactSelect.next('.select2-container');
			var $clearBtn = $('<button type="button" class="select2-custom-clear" style="display:none;"><span class="material-symbols-outlined">backspace</span></button>');
			$container.after($clearBtn);

			// Show/hide clear button based on selections
			var updateClearButton = function() {
				if ($contactSelect.val() && $contactSelect.val().length > 0) {
					$clearBtn.show();
				} else {
					$clearBtn.hide();
				}
			};

			// Clear selections on click
			$clearBtn.on('click', function() {
				$contactSelect.val(null).trigger('change');
				$(this).hide();
			});

			// Update button visibility on change
			$contactSelect.on('change', updateClearButton);
			updateClearButton();
		}

		self.find('.period-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'YYYY-MM-DD',
				locale: 'fr-ca'
			})
			field.datetimepicker().on('dp.change', self.period_changed)
		});
		self.find('select[name="year_start"]').on('change', self.year_changed)
		self.find('select[name="year_end"]').on('change', self.year_changed)
		self.find('input[name="period_type"]').on('change', self.period_type_changed)
		return self;
	}();
}

$.fn.Rapport = function() {
	var self = this;
	self.table = undefined;
	self.filters = undefined;
	self.button = $('.btn-rapport');
	self.reset_button = $('.btn-reset-rapport');

	self.reset = function() {
		$('#custom-search input').val('')
		$('select[name="contact"] option:selected').prop('selected', false).change()
		$('input[type="checkbox"]').prop('checked', false)
		$('input[type="checkbox"][value="subtotal"]').prop('checked', true)
		$('input[type="checkbox"][value="due"]').prop('checked', true)
		$('input[type="radio"][name="period_type"][value="years"]').prop('checked', true).change()
		$('select[name="year_start"] option[value="' + (new Date().getFullYear()) + '"]').prop('selected', true).change()
		$('select[name="year_end"] option[value="' + (new Date().getFullYear()) + '"]').prop('selected', true).change()
		self.table.reset()
		self.button.click()
	}

	return function() {
		self.table = self.find('.rapport-table').RapportTable(self);
		self.filters = $('.rapport-filters').RapportFilters(self);
		self.button.on('click', self.table.update)
		self.reset_button.on('click', self.reset)
		self.reset()
		return self;
	}()
}

$.fn.FTP_Uploader = function(_params) {
	var _up = this
	_up.params = _params
	_up.uploader = undefined

	_up.interface = {
		files: undefined,
		folder: undefined,
		holders: [],
		holder_template: undefined
	}

	_up.clear = function()
	{
		_up.interface.holders.forEach(function(x) {
			x.delete()
		})
		_up.interface.holders = []
	}

	/* Files */
	_up.filestart = function(e, file)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.start()
		}
	}

	_up.fileprogress = function(e, file, percent)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.percent(percent)
		}
	}

	_up.filecomplete = function(e, file, response)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.end(response)
			_up.files.load()
		}
	}

	_up.fileerror = function(e, file, response)
	{
		if (_up.files != undefined) {
			_up.files.load()
		}
	}

	/* Queue */
	_up.queue_start = function(e, files)
	{
		if (!_up.params.multiple) {
			if (files.length > 1) {
				_up.uploader.upload("abort")
				return false
			}
			_up.clear()
		}
		_up.uploader.upload('disable')
		files.forEach(function(file) {
			if (_up.interface.files.length) {
				var file_holder = _up.interface.holder_template.clone().FTP_File(_up.files, _up, file.index)
				file_holder.addClass("waiting")
				file_holder.setFilename(file.name)
				_up.interface.holders[file.index] = file_holder
				_up.interface.files.prepend(file_holder)
				_up.interface.files.find('.dt-empty').parent().remove()
			}
		})
	}

	_up.queue_ended = function(e)
	{
		_up.uploader.upload('enable')
		if (_up.folders != undefined) {
			_up.folders.load()
		}
	}

	_up.current_files = function()
	{
		if (_up.interface.files.length) {
			_up.interface.files.find('tr').each(function(index, el) {
				var file_holder = $(this).FTP_File(_up, index)
				_up.interface.holders[index] = file_holder
			})
		}
	}

	_up.reset = function()
	{
		_up.disable()
		_up.interface.holders.forEach(function(x) {
			x.remove()
		})
		_up.interface.holders = []
	}

	_up.disable = function()
	{
		_up.uploader.upload('disable')
	}

	return function()
	{
		// files or folder
		_up.interface.files = _up.find('.ftp-table--files tbody')
		if (!_up.interface.files.length) {
			_up.interface.folder = _up.params.parent
		}

		// file holder template
		_up.interface.holder_template = _up.find(".file-holder-template").clone().removeClass("file-holder-template")

		// setup uploader
		_up.uploader = _up.find(".upload").upload({
			action: "/api/multiupload",
			autoUpload: true,
			multiple: _up.params.multiple,
			maxConcurrent: 1,
			maxSize: 268435456,
			label: _up.params.multiple ? 'Ajouter des fichiers' : 'Sélectionner un fichier',
			beforeSend: function(formData, file) {
				for (key in _up.params.data) {
					formData.append(key, _up.params.data[key])
				}
				formData.append('id', _up.params.id)
				formData.append('model', _up.params.model)
				if (_up.files != undefined && _up.files.length) {
					formData.append('contact_id', _up.files.ftp.bar.current.contact)
					formData.append('folder_id', _up.files.ftp.bar.current.reference)
					formData.append('file_tag', _up.files.ftp.bar.current.type)
				} else {
					formData.append('contact_id', _up.folders.ftp.bar.current.contact)
					formData.append('folder_id', _up.id)
				}
				return formData
			}
		})
		_up.uploader.on('start', _up.queue_start)
		_up.uploader.on('complete', _up.queue_ended)
		_up.uploader.on('filestart', _up.filestart)
		_up.uploader.on('filecomplete', _up.filecomplete)
		_up.uploader.on('fileerror', _up.fileerror)
		_up.uploader.on('fileprogress', _up.fileprogress)

		// load files
		_up.current_files()

		// return
		return _up
	}()
}

$.fn.FTP_Files = function(ftp) {
	let self = this

	self.ftp = ftp
	self.table = undefined
	self.response = undefined

	self.load = function() {
		$.ajax({
			url: '/fichier/json-files/',
			type: 'POST',
			data: {
				contact_id: ftp.bar.current.contact,
				folder_id: ftp.bar.current.reference,
			},
			dataType: 'json',
			success: function (response) {
				self.response = response
				self.table.clear()
				self.table.rows.add(response)
				self.table.draw()
				self.find('tr').each(function() {
					$(this).FTP_File(self)
				})
			},
		})
	}

	self.initialize_list = function() {
		self.table = self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[3, 'desc']],
			columnDefs: [
				{ targets: 1, orderable: true },
				{ targets: 2, orderable: false, width: '140px' },
				{ targets: 3, orderable: true, width: '140px' },
				{ targets: 4, orderable: false, width: '180px' }
			],
			layout: {
				topStart: null,
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$(this).addClass('d-none')
				$(this).closest('.dt-container').addClass('table-container--files')
			},
		})
		self.table.on('draw.dt', function() {
			self.find('tr').each(function() {
				$(this).FTP_File(self)
			})
		})
		$.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
			if (settings.nTable !== self.table.table().node()) return true
			const row_data = self.table.row(dataIndex).data()
			let should_be_visible = true
			if (ftp.bar.current.type != 0 && ftp.bar.current.type != 'all' && ftp.bar.current.type != row_data.type.value) {
				should_be_visible = false
			}
			if (!ftp.view_archived && row_data.archived) {
				should_be_visible = false
			}
			return should_be_visible
		})
	}

	return function() {
		self.initialize_list()
		return self
	}()
}

$.fn.FTP_File = function(files, uploader, index) {
	let self = this

	if (self.data('ftp-file')) {
		return self.data('ftp-file')
	}

	self.row_data = files.table.row(self).data()
	self.id = 0
	self.type = 0
	self.uploader = uploader
	self.input = $('<input type="text">')
	self.cell = self.find('a[data-value]')
	self.index = index
	self.filename = undefined
	self.archived = false

	self.button = {
		save: undefined,
		rename: undefined,
		cancel: undefined,
		archive: undefined,
		unarchive: undefined,
		duplicate: undefined,
		download: undefined,
	}

	self.download = function() {
		const link = document.createElement('a')
		link.href = self.cell.attr('href')
		link.target = '_blank'
		link.download = ''
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	self.archive = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				file_id: self.id,
				file_action: self.archived ? 'unarchive' : 'archive',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					files.load()
				} else {
					self.cancel()
				}
			},
		})
		if (self.archived) {
			self.archived = false
			self.removeClass('archived')
			self.button.archive.show()
			self.button.unarchive.hide()
		} else {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
			if (!files.ftp.view_archived) {
				self.detach()
			}
		}
	}

	self.select_filename = function(inputElement) {
		const value = inputElement.value,
		lastDotIndex = value.lastIndexOf('.'),
		fileNameWithoutExtension = lastDotIndex > 0 ? value.slice(0, lastDotIndex) : value
		inputElement.setSelectionRange(0, fileNameWithoutExtension.length)
	}

	self.rename = function() {
		self.button.save.show()
		self.button.cancel.show()
		self.button.rename.hide()
		self.button.archive.hide()
		self.button.unarchive.hide()
		self.button.duplicate.hide()
		self.button.download.hide()
		$cell = self.find('td:first')
		$cell.find('a').hide()
		$cell.append(self.input.show().val($cell.find('a').text()))
		self.input.focus()
		self.select_filename(self.input.get(0))
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.save = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				folder_id: files.ftp.bar.current.reference,
				file_id: self.id,
				filename: self.input.val().replace(/[^a-zA-Z0-9\s._'àâäéèêëïîôöùûüçÀÂÄÉÈÊËÏÎÔÖÙÛÜÇ#-]/g, '').trim(),
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					self.id = response.file_id
					self.cell.text(response.filename).attr('data-value', self.id)
					self.cancel()
					files.load()
				} else {
					self.cancel()
				}
			},
		})
	}

	self.set_type = function(new_type) {
		self.type = parseInt(new_type, 10)
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				folder_id: files.ftp.bar.current.reference,
				file_id: self.id,
				file_tag: self.type,
			},
			dataType: 'json',
			success: function (response) {
				files.load()
			},
		})
	}

	self.duplicate = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				file_id: self.id,
				file_action: 'duplicate',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					files.load()
				}
			},
		})
	}

	self.cancel = function() {
		self.input.hide()
		self.cell.show()
		self.button.save.hide()
		self.button.cancel.hide()
		self.button.rename.show()
		self.button.duplicate.show()
		self.button.download.show()
		if (self.archived) {
			self.button.unarchive.show()
		} else {
			self.button.archive.show()
		}
	}

	self.initialize_buttons = function() {
		if (!self.find('button').length) {
			self.find('td:last-child:not(.dt-empty)').append($('.file-holder-template button').clone())
		}
		self.button = {
			save: self.find('.btn-file-save'),
			cancel: self.find('.btn-file-cancel'),
			rename: self.find('.btn-file-rename'),
			archive: self.find('.btn-file-archive'),
			unarchive: self.find('.btn-file-unarchive'),
			duplicate: self.find('.btn-file-duplicate'),
			download: self.find('.btn-file-download'),
		}
		self.button.save.on('click', self.save)
		self.button.cancel.on('click', self.cancel)
		self.button.rename.on('click', self.rename)
		self.button.archive.on('click', self.archive)
		self.button.unarchive.on('click', self.archive)
		self.button.duplicate.on('click', self.duplicate)
		self.button.download.on('click', self.download)

		self.cell.on('click', function() {
			window.open(self.cell.attr('href'), '_blank', `width=${screen.width * 3/5},height=${screen.height},scrollbars=yes,toolbar=no,location=no`)
			return false
		})
	}

	self.setFilename = function(filename) {
		self.filename = filename
		self.cell.text(filename)
	}

	self.start = function() {
		self.removeClass("waiting")
		self.addClass("transfering")
	}

	self.percent = function(percent) {
		self.find('.progress-bar').css({
			width : percent + '%',
		})
	}

	self.end = function(response) {
		self.removeClass("transfering")
		var data = JSON.parse(response),
		linkUrl = self.cell.attr('href')
		if (data.success || data.id) {
			self.find('.progress').fadeOut("fast")
			self.attr("data-file-id", data.id)
			self.cell.attr("href",  data.protected_url).show()
			if (self.uploader != undefined && self.uploader.params != undefined && self.uploader.params.callback != undefined) {
				self.uploader.params.callback()
			}
		} else {
			self.fadeOut("fast")
			$.slr.notify({
				icon: 'fa fa-exclamation-circle',
				title: "Erreur lors du transfert",
				message: data.error ? data.error : "Le transfert a échoué."
			}, {
				type: 'danger',
				delay: 15
			})
		}
	}

	self.initialize_type = function() {
		let $dropdown = $('<div>').append(files.ftp.bar.menu_template.type.clone()).find('.dropdown')
		$dropdown.find('.current-cell').text('Choisir un type')
		$dropdown.find('.dropdown-item:eq(0)').remove()
		$dropdown = $dropdown.FTP_Dropdown()
		self.find('.dropdown').replaceWith($dropdown)
		$dropdown.set_current_value(self.type)
		$dropdown.find('input').on('change', function() {
			self.set_type($(this).val())
		})
	}

	return function() {
		self.id = self.cell.data('value')
		self.type = self.find('.dropdown').text() ? parseInt(self.find('.dropdown').text(), 10) : 0
		self.initialize_buttons()
		self.initialize_type()
		if (self.closest('#ftp-module.panel').length) {
			self.cell.draggable({
				appendTo: 'body',
				helper: 'clone',
			})
		}
		if (self.row_data != undefined && self.row_data.archived == 1) {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
		}
		self.data('ftp-file', self)
		return self
	}()
}

$.fn.FTP_Folders = function(ftp) {
	let self = this

	self.ftp = ftp
	self.table = undefined
	self.has_new = false
	self.response = undefined

	self.load = function() {
		$.ajax({
			url: '/fichier/json-folder/',
			type: 'POST',
			data: {
				contact_id: ftp.bar.current.contact,
			},
			dataType: 'json',
			success: function (response) {
				self.response = response
				self.table.clear()
				self.table.rows.add(response)
				self.table.draw()
				self.find('tr').each(function() {
					$(this).FTP_Folder(self)
				})
			},
		})
	}

	self.initialize_list = function() {
		self.table = self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[2, 'desc']],
			columnDefs: [
				{ targets: 1, orderable: true },
				{ targets: 2, orderable: true, width: '140px' },
				{ targets: 3, orderable: false, width: '180px' }
			],
			layout: {
				topStart: null,
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$(this).addClass('d-none')
				$(this).closest('.dt-container').addClass('table-container--folders')
			}
		})
		self.table.on('order.dt', function() {
			self.has_new = false
		})
		self.table.on('draw.dt', function() {
			ftp.bar.menu.reference.set_items(self.response)
			self.find('tr').each(function() {
				$(this).FTP_Folder(self)
			})
		})
		$.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
			if (settings.nTable !== self.table.table().node()) return true
			if (ftp.view_archived) return true
			const row_data = self.table.row(dataIndex).data()
			return !row_data.archived
		})
	}

	self.create_new = function() {
		if (self.has_new) {
			return
		}
		let template = $('.folder-holder-template').clone().removeClass('folder-holder-template').FTP_Folder(self)
		self.find('tbody').prepend(template)
		template.initialize_new()
		self.find('.dt-empty').parent().remove()
		self.has_new = true
	}

	return function() {
		self.initialize_list()
		return self
	}()
}

$.fn.FTP_Folder = function(folders) {
	let self = this

	if (self.data('ftp-folder')) {
		return self.data('ftp-folder')
	}

	self.folders = folders
	self.row_data = folders.table.row(self).data()
	self.id = 0
	self.input = $('<input type="text">')
	self.cell = self.find('a[data-value]')
	self.uploader = undefined
	self.archived = false

	self.button = {
		save: undefined,
		cancel: undefined,
		rename: undefined,
		archive: undefined,
		unarchive: undefined,
	}

	self.save = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'folder',
				contact_id: folders.ftp.bar.current.contact,
				folder_id: self.id,
				folder_reference: self.input.val().replace(/[^a-zA-Z0-9\s._'!?,àâäéèêëïîôöùûüçÀÂÄÉÈÊËÏÎÔÖÙÛÜÇ#-]/g, '').trim(),
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					folders.ftp.bar.menu.reference.add_item(response)
					self.id = response.folder_id
					self.cell.text(response.folder_reference).attr('data-value', self.id)
					self.cancel()
					folders.load()
				} else {
					self.cancel()
				}
			},
		})
	}

	self.cancel = function() {
		if (self.id == 0) {
			folders.has_new = false
			self.remove()
			folders.table.draw()
		} else {
			self.input.hide()
			self.cell.show()
			self.button.save.hide()
			self.button.cancel.hide()
			self.button.rename.show()
			if (self.archived) {
				self.button.unarchive.show()
			} else {
				self.button.archive.show()
			}
		}
	}

	self.rename = function() {
		self.button.save.show()
		self.button.cancel.show()
		self.button.rename.hide()
		self.button.archive.hide()
		self.button.unarchive.hide()
		$cell = self.find('td:first')
		$cell.find('a[data-value], .fs-upload-element, .files-count').hide()
		$cell.append(self.input.show().val($cell.find('a').text()))
		self.input.focus().select()
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.archive = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'folder',
				contact_id: folders.ftp.bar.current.contact,
				folder_id: self.id,
				folder_action: self.archived ? 'unarchive' : 'archive',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					folders.load()
				} else {
					self.cancel()
				}
			},
		})
		if (self.archived) {
			self.archived = false
			self.removeClass('archived')
			self.button.archive.show()
			self.button.unarchive.hide()
		} else {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
			if (!folders.ftp.view_archived) {
				self.detach()
			}
		}
	}

	self.initialize_buttons = function() {
		let is_new_folder = true
		if (!self.find('button').length) {
			is_new_folder = false
			self.find('td:last-child:not(.dt-empty)').append($('.folder-holder-template button').clone())
		}
		self.button = {
			save: self.find('.btn-folder-save'),
			cancel: self.find('.btn-folder-cancel'),
			rename: self.find('.btn-folder-rename'),
			archive: self.find('.btn-folder-archive'),
			unarchive: self.find('.btn-folder-unarchive'),
		}
		self.button.save.on('click', self.save)
		self.button.cancel.on('click', self.cancel)
		self.button.rename.on('click', self.rename)
		self.button.archive.on('click', self.archive)
		self.button.unarchive.on('click', self.archive)
		if (is_new_folder) {
			self.button.save.show()
			self.button.cancel.show()
			self.button.rename.hide()
			self.button.archive.hide()
			self.button.unarchive.hide()
		}
	}

	self.initialize_new = function() {
		self.find('td:first-child').append(self.input)
		self.input.focus()
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.initialize_uploader = function() {
		// Check if user has write permission
		if ($('#ftp-module').data('can-write') != '1') {
			return;
		}
		let $upload = $('<div>').addClass('upload')
		self.cell.before($upload)
		self.uploader = self.FTP_Uploader({
			parent: self,
			model : 'ftp',
			id : 0,
			multiple: true,
		})
	}

	return function() {
		self.id = self.cell.data('value')
		self.cell.on('click', function(e) {
			folders.ftp.bar.menu.reference.set_current_value($(this).data('value'))
		})
		self.initialize_buttons()
		self.initialize_uploader()
		if (self.row_data != undefined && self.row_data.archived == 1) {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
		}
		self.data('ftp-folder', self)
		return self
	}()
}

$.fn.FTP_Dropdown = function(bar, with_search) {
	let self = this

	if (with_search == undefined) {
		with_search = false
	}

	self.dd = self.find('.dropdown-menu')
	self.cell = self.find('.current-cell')
	self.input = self.find('input[type="hidden"]')
	self.searchInput = undefined

	if (with_search) {
		let searchHtml = '<div class="dropdown-search-container"><input type="text" class="dropdown-search form-control" placeholder="Rechercher"><button type="button" class="dropdown-search-clear"><span class="material-symbols-outlined">backspace</span></button></div>'
		self.dd.prepend(searchHtml)
		self.searchInput = self.dd.find('.dropdown-search')

		self.on('shown.bs.dropdown', function() {
			self.searchInput.focus()
		})

		self.searchInput.on('click', function(e) {
			e.stopPropagation()
		})

		self.dd.find('.dropdown-search-clear').on('click', function(e) {
			e.stopPropagation()
			self.searchInput.val('')
			self.searchInput.focus()
			self.searchInput.trigger('keyup')
		})

		self.searchInput.on('keyup', function() {
			let filter = $(this).val().toLowerCase().trim()
			let searchTerms = filter.split(/\s+/)
			self.dd.find('.dropdown-item').each(function() {
				let text = $(this).text().toLowerCase()
				let match = searchTerms.every(function(term) { return text.indexOf(term) > -1 })
				if (match) {
					$(this).show()
				} else {
					$(this).hide()
				}
			})
		})

		self.searchInput.on('keydown', function(e) {
			let $visibleItems = self.dd.find('.dropdown-item:visible')
			let $current = self.dd.find('.dropdown-item.highlighted')
			if (e.keyCode === 40) {
				e.preventDefault()
				if ($current.length === 0) {
					$visibleItems.first().addClass('highlighted')
				} else {
					let currentIndex = $visibleItems.index($current)
					$current.removeClass('highlighted')
					if (currentIndex < $visibleItems.length - 1) {
						$visibleItems.eq(currentIndex + 1).addClass('highlighted')
					} else {
						$visibleItems.first().addClass('highlighted')
					}
				}
			} else if (e.keyCode === 38) {
				e.preventDefault()
				if ($current.length === 0) {
					$visibleItems.last().addClass('highlighted')
				} else {
					let currentIndex = $visibleItems.index($current)
					$current.removeClass('highlighted')
					if (currentIndex > 0) {
						$visibleItems.eq(currentIndex - 1).addClass('highlighted')
					} else {
						$visibleItems.last().addClass('highlighted')
					}
				}
			} else if (e.keyCode === 13) {
				e.preventDefault()
				if ($current.length > 0) {
					$current.trigger('click')
				}
			} else {
				self.dd.find('.dropdown-item.highlighted').removeClass('highlighted')
			}
		})
	}

	self.clear_search = function() {
		if (self.searchInput != undefined) {
			self.searchInput.val('')
			self.searchInput.focus()
			self.searchInput.trigger('keyup')
		}
	}

	self.reorder = function() {
		let $searchContainer = self.dd.find('.dropdown-search-container').detach()
		let $firstItem = self.dd.find('.dropdown-item[data-value="all"]').detach()
		let $items = self.dd.find('.dropdown-item:not([data-value="all"])').detach()
		let $sortedItems = $items.sort((a, b) => $(a).text().localeCompare($(b).text()))
		self.dd.empty().append($searchContainer).append($firstItem).append($sortedItems)
	}

	self.add_item = function(reference) {
		self.find('.dropdown-item[data-value="' + reference.folder_id + '"]').remove()
		let $newItem = $('<a class="dropdown-item" href="#"></a>')
		.attr('data-value', reference.folder_id)
		.attr('aria-selected', 'false')
		.text(reference.folder_reference)
		$newItem.on('click', function() {
			self.set_current_item($(this))
		})
		self.dd.append($newItem)
		self.reorder()
	}

	self.set_items = function(response) {
		if (response != undefined) {
			self.find('.dropdown-item:not([data-value="all"])').remove()
			response.forEach(function(reference) {
				if (!reference.archived || (bar != undefined && bar.ftp.view_archived)) {
					let $newItem = $('<a class="dropdown-item" href="#"></a>')
					.attr('data-value', reference.id.value)
					.attr('aria-selected', 'false')
					.text(reference.reference.value)
					if (reference.archived) {
						$newItem.addClass('archived')
					}
					$newItem.on('click', function() {
						self.set_current_item($(this))
					})
					self.dd.append($newItem)
				}
			})
			self.reorder()
		}
	}

	self.set_current_value = function(value) {
		self.set_current_item(self.find('.dropdown-item[data-value="' + value + '"]'))
	}

	self.set_current_item = function($el) {
		// le fil d'Ariane garde le nom seul, sans le nom de la compagnie
		let $label = $el.clone()
		$label.find('.name-company').remove()
		self.cell.html($label.html())
		self.input.val($el.data('value')).change()
		self.dd.dropdown()
		self.dd.find('a').attr('aria-selected', 'false')
		$el.attr('aria-selected', 'true')
		if (bar != undefined) {
			self.cell.find('.material-symbols-outlined').remove()
		}
	}

	return (function() {
		self.dd.find('a').on('click', function() {
			self.set_current_item($(this))
		})
		return self
	})()
}

$.fn.FTP_Breadcrumb = function(ftp) {
	let self = this

	self.ftp = ftp

	self.input = {
		contact: self.find('input[name="ftp_contact"]'),
		reference: self.find('input[name="ftp_reference"]'),
		type: self.find('input[name="ftp_type"]')
	}

	self.menu_template = {
		type: self.find('#ftp-type-dropdown').clone(),
	}

	self.menu = {
		contact: self.find('#ftp-contact-dropdown').FTP_Dropdown(self, true),
		reference: self.find('#ftp-reference-dropdown').FTP_Dropdown(self, true),
		type: self.find('#ftp-type-dropdown').FTP_Dropdown(self, true),
	}

	self.current_as_string = ''
	self.current = {
		contact: self.input.contact.val(),
		reference: self.input.reference.val(),
		type: self.input.type.val(),
	}

	self.type_changed = function() {
		self.current.type = self.input.type.val()
		ftp.files.table.draw()
	}

	self.filters_changed = function() {
		self.old = self.current
		self.current = {
			contact: self.input.contact.val(),
			reference: self.input.reference.val(),
			type: self.input.type.val(),
		}
		if (JSON.stringify(self.current) != self.current_as_string) {
			self.current_as_string = JSON.stringify(self.current)
			if (self.current.contact == 'none') {
				self.menu.reference.addClass('d-none')
				self.menu.reference.clear_search()
				self.menu.reference.set_current_value('all')
				self.menu.type.addClass('d-none')
				self.menu.type.clear_search()
				self.menu.type.set_current_value('all')
				$('.btn-ftp-new-folder').addClass('disabled').prop('disabled', true)
				$('.btn-ftp-parent-folder').addClass('disabled').prop('disabled', true)
				$('.btn-ftp-view-hidden').addClass('disabled').prop('disabled', true)
				$('.ftp-table--files').addClass('d-none')
				$('.ftp-table--folders').addClass('d-none')
				$('#ftp-module .card-block:first').addClass('d-none')
				$('#ftp-module .card-block.new-files').removeClass('d-none')
				$('.btn-invoice-for-artist').addClass('disabled')
				$('.contact-invoices').addClass('d-none')
				ftp.folders.table.clear()
				ftp.folders.table.draw()
				$.slr.interface.table.clear().draw()
			} else if (self.current.contact != 'none') {
				$('.contact-invoices').removeClass('d-none')
				$('.btn-invoice-for-artist').removeClass('disabled').attr('href', '/facture/ajouter/type/' + self.current.contact)
				$('#ftp-module .card-block.new-files').addClass('d-none')
				$('#ftp-module .card-block:first').removeClass('d-none')
				$('.btn-ftp-view-hidden').removeClass('disabled').prop('disabled', false)
				self.menu.reference.removeClass('d-none')
				if (self.current.reference == 'all') {
					$('.btn-ftp-new-folder').removeClass('disabled').prop('disabled', false)
					$('.btn-ftp-upload-file').addClass('disabled').prop('disabled', true)
					if (ftp.is_mini) {
						$('.btn-ftp-parent-folder').addClass('disabled').prop('disabled', true)
					} else {
						$('.btn-ftp-parent-folder').removeClass('disabled').prop('disabled', false)
					}
					self.menu.type.addClass('d-none')
					self.menu.type.clear_search()
					$('.ftp-table--files').addClass('d-none')
					$('.ftp-table--folders').removeClass('d-none')
					ftp.folders.load()
					ftp.files.table.clear()
					ftp.files.table.draw()
				} else if (self.current.reference != 'all') {
					$('.btn-invoice-for-artist').removeClass('disabled').attr('href', '/facture/ajouter/type/' + self.current.contact)
					$('.btn-ftp-new-folder').addClass('disabled').prop('disabled', true)
					$('.btn-ftp-upload-file').removeClass('disabled').prop('disabled', false)
					$('.btn-ftp-parent-folder').removeClass('disabled').prop('disabled', false)
					self.menu.type.removeClass('d-none')
					$('.ftp-table--files').removeClass('d-none')
					$('.ftp-table--folders').addClass('d-none')
					ftp.files.load()
				}
			}
			if (self.old.contact != self.current.contact) {
				$.slr.interface.table.ajax.url('/facture/json/' + self.current.contact).load();
				ftp.folders.table.clear()
				ftp.folders.table.draw()
				self.menu.reference.set_current_value('all')
				self.menu.reference.clear_search()
				self.menu.type.set_current_value('all')
				self.menu.type.clear_search()
			}
		}
	}

	self.go_to_parent = function() {
		if (self.current.reference != 'all') {
			self.menu.reference.set_current_value('all')
			self.menu.type.set_current_value('all')
			self.menu.type.clear_search()
		} else if (self.current.contact != 'none') {
			self.menu.contact.set_current_value('none')
			self.menu.reference.clear_search()
			self.menu.type.clear_search()
		}
	}

	self.close_panel = function() {
		ftp.removeClass('panel--open')
	}

	self.toggle_view_archived = function() {
		if ($(this).hasClass('btn-outline-secondary')) {
			$(this).removeClass('btn-outline-secondary').addClass('btn-secondary')
			$(this).find('.material-symbols-outlined').text('visibility')
			ftp.view_archived = true
		} else {
			$(this).removeClass('btn-secondary').addClass('btn-outline-secondary')
			$(this).find('.material-symbols-outlined').text('visibility_off')
			ftp.view_archived = false
		}
		$(this).blur()
		ftp.folders.table.draw()
		ftp.files.table.draw()
	}

	self.new_folder = function() {
		if (self.current.reference != 'all') {
			self.menu.reference.set_current_value('all')
			self.menu.reference.clear_search()
			self.menu.type.clear_search()
		}
		ftp.folders.create_new()
	}

	self.trigger_upload = function() {
		$('.ftp-files-upload .fs-upload-input').click()
	}

	self.initialize_buttons = function() {
		$('.btn-ftp-upload-file').on('click', self.trigger_upload)
		$('.btn-ftp-parent-folder').on('click', self.go_to_parent)
		$('.btn-ftp-close-panel').on('click', self.close_panel)
		$('.btn-ftp-view-hidden').on('click', self.toggle_view_archived)
		$('.btn-ftp-new-folder').on('click', self.new_folder)

		if (ftp.is_mini) {
			$('.btn-ftp-parent-folder').removeClass('ml-2').addClass('ml-3')
		}
	}

	return function() {
		self.initialize_buttons()
		self.input.contact.on('change', self.filters_changed)
		self.input.reference.on('change', self.filters_changed)
		self.input.type.on('change', self.type_changed)
		setTimeout(self.filters_changed, 200)
		return self
	}()
}

$.fn.FTP_Module = function() {
	let self = this

	self.uploader = undefined
	self.drag_timeout = undefined
	self.folders = undefined
	self.files = undefined
	self.is_mini = self.hasClass('panel')
	self.view_archived = false

	self.initialize_uploader = function() {
		if (self.is_mini) {
			return
		}

		// Check if user has write permission
		if (self.data('can-write') != '1') {
			return;
		}

		self.uploader = self.FTP_Uploader({
			parent: self,
			model : 'ftp',
			id : 0,
			multiple: true,
		})

		$('html').on('dragover', function(e) {
			if (!e.originalEvent.dataTransfer.types.includes('Files')) {
				return
			}
			$('.table-container--files').addClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').addClass('active')
			clearTimeout(self.drag_timeout)
			self.drag_timeout = setTimeout(function() {
				clearTimeout(self.drag_timeout)
				$('.table-container--files').removeClass('disabled')
				$('.ftp-files-upload').removeClass('active')
			}, 3000)
		})

		$('html').on('click', function() {
			$('.table-container--files').removeClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').removeClass('active')
		})

		$('.fs-upload-target').on('drop', function(e) {
			$('.table-container--files').removeClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').removeClass('active')
		})
	}

	self.initialize_interface = function() {
		self.bar = $('#ftp-breadcrumb').FTP_Breadcrumb(self)
		self.folders = $('.ftp-table--folders').FTP_Folders(self)
		self.files = $('.ftp-table--files').FTP_Files(self)

		$('button[data-contact]').on('click', function() {
			self.folders.ftp.bar.menu.contact.set_current_value($(this).data('contact'))
		})

		setTimeout(function() {
			if (window.location.hash) {
				self.folders.ftp.bar.menu.contact.set_current_value(window.location.hash.substring(1))
				history.replaceState(null, '', location.pathname + location.search);
			}
		}, 100)
	}

	return function() {
		self.initialize_interface()
		self.initialize_uploader()
		return self
	}()
}

$.fn.DelegateAccount = function() {
    var self = this;
    self.form = self.find('#delegate-form');
    if (self.form.length) {
        self.form.Form();
    }

    self.clearForm = function() {
        self.form.get(0).reset();
        self.form.find('input[name=id]').val('');
        self.form.find('input[name=action]').val('add');
        self.form.find('button.btn-delegate-submit span').text('save');
        self.form.find('button.btn-delegate-submit')[0].lastChild.nodeValue = 'Créer le compte';
        self.form.find('.delegate-form-title').text('Nouvel accès délégué');
        self.form.find('.btn-delegate-cancel').addClass('d-none');
        self.form.find('label[for="field-user-password"], label[for="field-user-password-repeat"]').addClass('mandatory');
        return false;
    };

    self.fillForm = function(row) {
        self.form.find('input[name=action]').val('edit');
        self.form.find('input[name=id]').val(row.data('id'));
        self.form.find('input[name=firstname]').val(row.data('firstname'));
        self.form.find('input[name=lastname]').val(row.data('lastname'));
        self.form.find('input[name=email]').val(row.data('email'));
        self.form.find('input[name="user-password"]').val('');
        self.form.find('input[name="user-password-repeat"]').val('');
        self.form.find('label[for="field-user-password"], label[for="field-user-password-repeat"]').removeClass('mandatory');
        self.form.find('.delegate-form-title').text("Modifier l'accès délégué");
        self.form.find('button.btn-delegate-submit span').text('save');
        self.form.find('button.btn-delegate-submit')[0].lastChild.nodeValue = 'Mettre à jour';
        self.form.find('.btn-delegate-cancel').removeClass('d-none');
        return false;
    };

    self.editClicked = function(e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        self.fillForm(row);
    };

    self.deleteClicked = function(e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        var id = row.data('id');
        swal({
            title: "Suppression d'un compte",
            text: "Êtes-vous certain de vouloir supprimer ce compte?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
            closeOnConfirm: true
        }, function(isConfirm) {
            if (isConfirm) {
                var request = new FormData();
                request.append('model', 'accountant');
                request.append('action', 'delete');
                request.append('id', id);
                request.append('data', JSON.stringify({}));
                $.slr.db.add(request);
            }
        });
        return false;
    };

    return function() {
        $(document).on('click', '#delegate-module .btn-edit-delegate', self.editClicked);
        $(document).on('click', '#delegate-module .btn-delete-delegate', self.deleteClicked);
        self.form.on('click', '.btn-delegate-cancel', self.clearForm);
        return self;
    }();
};



function debounce(func, wait) {
	let timeout;
	return function() {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, arguments), wait);
	};
}

$(document).ready(function() {
	$.slr = {
		db: undefined,
		site: undefined,
		user: undefined,
		conventions: undefined,
		interface: {
			table: undefined,
			form: undefined,
			stack: undefined,
			calc: undefined,
			depot: undefined,
		}
	};

	/* Dark mode */
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	const darkModeCookie = getCookie('dark-mode');
	if (darkModeCookie === 'enabled') {
		$('body').addClass('--dark-mode');
		$('head meta[name="color-scheme"]').attr('content', 'dark')
	}

	$('.toggle-dark-mode').click(function() {
		$('body').toggleClass('--dark-mode')
		const isDarkModeEnabled = $('body').hasClass('--dark-mode');
		if (isDarkModeEnabled) {
			$('head meta[name="color-scheme"]').attr('content', 'dark')
		} else {
			$('head meta[name="color-scheme"]').attr('content', 'light')
		}
		document.cookie = `dark-mode=${isDarkModeEnabled ? 'enabled' : 'disabled'}; path=/; max-age=${60 * 60 * 24 * 30}`; // Cookie lasts for 30 days
	})

	var navigation =
	{
		/*
		*	Properties
		*/
		currentURL : undefined,
		isPopping : false,

		/*
		*	Page exit
		*/
		pageExit : function()
		{
			// Unload images
			$("#page-content img").attr("src", "").remove();

			// Unload form
			if ($.slr.interface.form != undefined){
				$.slr.interface.form = undefined;
				$("#form-controls").removeClass("visible");
			}

			// Unload datatables
			if ($.slr.interface.table != undefined) {
				$.slr.interface.table.destroy();
				$.slr.interface.table = undefined;
				$("table.datatable").remove();
			}

			// Remove some elements outside of content scope
			$(".select2-container").remove();

			// Scroll to top
			$(document).scrollTop(0);
			$("html, body").scrollTop(0);
		},

		/*
		*	Page display
		*/
		pageDisplay : function(loaded_url, loaded_content, AjaxRedirectLocation)
		{
			// Display loaded page
			var response = $('<html>').html(loaded_content);
			$("#page-content").replaceWith($("#page-content", response));
			setTimeout(function(){
				if (loaded_url == navigation.currentURL){
					navigation.pageLoad();
				}
			}, 50);

			// Remove transition
			setTimeout(function(){
				$("div#page-transition").addClass("hidden").on(TRANSITION_END, function(){
					$("div#page-transition").off(TRANSITION_END).removeClass("visible hidden");
				});
			}, 	150);

			// Push state
			if (!navigation.isPopping){
				document.title = $("title", response).text();
				var data = {
					is_page_transition: true,
					previous_page_url: window.location.href
				};
				window.history.pushState(data, $("title", response).text(), AjaxRedirectLocation == undefined ? navigation.currentURL : AjaxRedirectLocation);
			}
			navigation.isPopping = false;
		},

		/*
		*	Page transition
		*/
		pageTransition : function(href)
		{
			// Keep current URL
			navigation.currentURL = href;

			// Setting variables
			var loaded_url = href,
			loaded_content = undefined,
			page_disappeared = false,
			content_loaded = false;

			// Show page transition
			$("div#page-transition").addClass("visible").on(TRANSITION_END, function(){
				$(this).off(TRANSITION_END);
				navigation.pageExit();
				page_disappeared = true;
				if (content_loaded){
					alert("THIS SHOULD NEVER HAPPEN.");
					// navigation.pageDisplay(loaded_url, loaded_content);
				}
				$.get(loaded_url, {}, function(x, status, xhr){
					loaded_content = x;
					content_loaded = true;
					AjaxRedirectLocation = undefined;
					if (xhr.getResponseHeader('AjaxRedirectLocation') != null){
						var AjaxRedirectLocation = xhr.getResponseHeader('AjaxRedirectLocation');
					}
					if (page_disappeared){
						navigation.pageDisplay(loaded_url, loaded_content, AjaxRedirectLocation);
					}
				}, 'html');
			});

			// Dropdown not shown
			$(".dropdown").removeClass("show");
			$(".dropdown a").attr("aria-expanded", "false");
		},

		/*
		*	Page load
		*/
		pageLoad : function()
		{
			// Unbind dropdown actions
			$(document).off("click", ".dropdown-toggle");
			$(document).off("click", ".table-checkbox");
			$(document).off('click', '.btn-action-mark-as-paid, .btn-action-mark-as-unpaid');

			// Load variables from HTML
			if ("conventions" in window){
				$.slr.conventions = window.conventions;
			}

			// Initialize form
			if ($(".slr-form").length){
				$.slr.interface.form = $(".slr-form").Form();
				$("#form-controls").addClass("visible");
			} else {
				$("#form-controls").removeClass("visible");
			}

			// Initialize data table
			$("table.datatable").each(function() {
				if (!$(this).find("tfoot").length && $(this).find("thead").length){
					$(this).append($('<tfoot></tfoot>').html($(this).find("thead").html()));
				}
				var json_request = $(this).data("ajax");
				var search_delay = undefined;
				var isInvoiceTable = json_request && json_request.includes("/facture/json");

				// Remove data-ajax attribute so DataTables uses our config instead
				if (isInvoiceTable) {
					$(this).removeAttr('data-ajax').removeData('ajax');
				}

				// Track current AJAX request to allow cancellation
				var currentAjaxRequest = null;

				var tableConfig = {
					language: {
						url: '/assets/libraries/DataTables-fr_FR.json',
					},
					pageLength: 100,
					layout: {
						topStart: ['search'],
						topEnd: {
							pageLength: {
								menu: isInvoiceTable ? [[100, 25, 50, 250], ['100', '25', '50', '250']] : [[100, 25, 50, 250, -1], ['100', '25', '50', '250', 'Tous']]
							}
						},
						bottomStart: null,
						bottomEnd: {
							paging: {
								type: 'simple_numbers',
								numbers: 3,
							},
						},
					},
					processing: false,	// no "processing" loader div
					serverSide: isInvoiceTable,
					ajax: isInvoiceTable ? function(data, callback, settings) {
						// Cancel previous request if still pending
						if (currentAjaxRequest && currentAjaxRequest.readyState !== 4) {
							currentAjaxRequest.abort();
						}

						var selectElement = $('select[name="invoice-filters"]');
						if (selectElement.length) {
							data.type = selectElement.val();
						}

						// Store the new request
						currentAjaxRequest = $.ajax({
							url: json_request,
							type: 'GET',
							data: data,
							dataType: 'json',
							success: function(json) {
								callback(json);
							},
							error: function(xhr, status) {
								// Only log real errors, not aborted requests
								if (status !== 'abort') {
									console.error('AJAX error:', status);
								}
							}
						});
					} : json_request,
					initComplete: function(){
						$('.dt-container > .row:first-child').css('visibility', 'visible')
						$('.col-md-auto').addClass('col')
						if (json_request != undefined) {
							if (json_request.includes("/contact/json")){
								$(".dt-search").append($('#contact-filters').css('display', 'inline-block'));
								$('#contact-filters select').on('change', function() {
									$.slr.interface.table.draw();
								});
								$.slr.interface.table.column(0).visible(false);
							}
							if (json_request.includes("/facture/json")) {
								$(".dt-search").append($('#invoice-filters').css('display', 'inline-block'));
								$('#invoice-filters select').on('change', function() {
									$.slr.interface.table.draw();
								});
								$(document).on('click', '.search-tag', function(event) {
									var searchTerm = '';
									if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
										if ($('.dt-search input.form-control').val()) {
											searchTerm = $('.dt-search input.form-control').val() + ' ';
										}
									}
									if ($(this).data('search')) {
										searchTerm += $(this).data('search');
									} else {
										searchTerm += $(this).text();
									}
									$.slr.interface.table.search(searchTerm).draw();
								});
							}
						}
						$(".dt-search input[type=search]").unbind()
						$(".dt-search input[type=search]").bind('keypress', function(e) {
							if (e.keyCode == 13) {
								$.slr.interface.table.search(this.value).draw();
							}
						});
						$('.dt-search .table-search-clear').off().on('click', function() {
							if (!$(".dt-search input[type=search]").val()) {
								return
							}
							$(".dt-search input[type=search]").val('')
							setTimeout(function() {
								$.slr.interface.table.search('').draw();
							}, 35)
						})
						$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
						$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em').focus();
						$(".dt-length select").removeClass('custom-select-sm form-control-sm');

						// Add "Select All" button for single access (artists and accountants)
						if ($('.btn-select-all-invoices').length) {
							$('.btn-select-all-invoices').prependTo('.dt-search').css({
								'display': 'inline-block',
								'margin-right': '10px'
							});

							// Update button text based on selection state
							var updateSelectAllButton = function() {
								var checkboxes = $('.invoices-table .invoice-selection:not(:disabled)');
								var checkedCount = checkboxes.filter(':checked').length;
								var totalCount = checkboxes.length;

								if (checkedCount === totalCount && totalCount > 0) {
									$('.btn-select-all-invoices').html('<span class="material-symbols-outlined">check_box</span>Désélectionner tout');
								} else {
									$('.btn-select-all-invoices').html('<span class="material-symbols-outlined">check_box_outline_blank</span>Sélectionner tout');
								}
							};

							$('.btn-select-all-invoices').on('click', function() {
								var checkboxes = $('.invoices-table .invoice-selection:not(:disabled)');
								var checkedCount = checkboxes.filter(':checked').length;
								var totalCount = checkboxes.length;

								if (checkedCount === totalCount && totalCount > 0) {
									// All selected, so deselect all
									checkboxes.prop('checked', false).trigger('change');
								} else {
									// Not all selected, so select all
									checkboxes.prop('checked', true).trigger('change');
								}

								updateSelectAllButton();
							});

							// Update button text when checkboxes change
							$(document).on('change', '.invoices-table .invoice-selection', updateSelectAllButton);

							// Initial button text update
							setTimeout(updateSelectAllButton, 500);
						}

						$(document).on("click", ".dropdown-toggle", function(e){
							$(e.target).closest('td').find(".dropdown-menu.invoice-actions").SLR_InvoiceActions();
							$(e.target).closest('td').find(".dropdown-menu.contact-actions").SLR_ContactActions();
						});
					}
				};

				// Initialize DataTable with config
				$.slr.interface.table = $(this).DataTable(tableConfig);

				// Custom loading indicator with opacity for invoice tables
				if (isInvoiceTable) {
					$(this).on('processing.dt', function(e, settings, processing) {
						if (processing) {
							$(this).css('opacity', '0.5');
						} else {
							$(this).css('opacity', '1');
						}
					});
				}

				// Client-side filtering for contacts only (invoices use server-side)
				if (!isInvoiceTable) {
					$.fn.dataTable.ext.search.push(
						function(settings, data, dataIndex) {
							if ($("table.datatable").data('ajax') != undefined) {
								if ($("table.datatable").data('ajax').includes("/contact/json")){
									if ($('select[name="contact-filters"]').length) {
										if ($('select[name="contact-filters"]').val() == "admin") {
											return data[0].indexOf("Admin") !== -1 && data[0].indexOf("Inactif") === -1
										} else if ($('select[name="contact-filters"]').val() == "inactive") {
											return data[0].indexOf("Inactif") !== -1
										} else {
											return data[0].indexOf("Admin") === -1 && data[0].indexOf("Inactif") === -1
										}
									}
									$("input[type=search]").attr("autocomplete", "new-password");
								}
							}
							return true;
						}
					);
				}
			});

			// Initialize email composer if needed
			if ($("#email-multiple-modal").length){
				$.slr.interface.email_composer = $('#email-multiple-modal').EmailComposerMultiple();
				$('.btn-action-merge').on('click', function() {
					$('#merge-invoices-form input[name="invoice_ids"]').val($.slr.interface.email_composer.ids.join(','));
					$('#merge-invoices-form').submit();
				});
			}
			if ($("#email-multiple-modal").length || $("#single-invoices-form").length) {
				$(document).on('click', '.table-checkbox', function(e) {
					if (e.target == e.currentTarget && $(this).find('input[type="checkbox"]').prop('disabled') == false && e.shiftKey) {
						var isChecked = !$(this).find('input[type="checkbox"]').prop('checked');
						var allCheckboxes = $(e.target).closest('tr').prevAll('tr').find('input[type="checkbox"]');
						var lastChecked = undefined, lastCheckedPassed = false;
						allCheckboxes.each(function(index, checkbox) {
							var $checkbox = $(checkbox);
							if ($checkbox.prop('disabled') == false && $checkbox.prop('checked') == isChecked) {
								lastChecked = $checkbox;
							}
						});
						if (lastChecked != undefined) {
							allCheckboxes.each(function(index, checkbox) {
								var $checkbox = $(checkbox);
								if ($checkbox.val() == lastChecked.val()) {
									lastCheckedPassed = true;
								} else if (lastCheckedPassed && $checkbox.prop('disabled') == false) {
									$checkbox.prop('checked', isChecked).trigger('change');
								}
							});
						}
					}
				});
			}

			// Initialize single access merge forms
			if ($('#single-invoices-form').length) {
				$.slr.interface.invoice_selector = $('#single-invoices-form').InvoiceSelector();
			}

			// Initialize mark as paid/unpaid
			$(document).on('click', '.btn-action-mark-as-paid, .btn-action-mark-as-unpaid', function(e) {
				let action = $(this).hasClass('btn-action-mark-as-paid') ? 'mark-as-paid' : 'mark-as-unpaid',
				invoice_ids = ''
				console.log(action)
				if ($(this).data('invoice-id')) {
					invoice_ids = $(this).data('invoice-id')
				} else {
					invoice_ids = $.slr.interface.email_composer.ids.join(',')
				}
				$.ajax({
					url: '/facture/marquer/',
					type: 'POST',
					data: {
						action: action,
						invoice_ids: invoice_ids,
					},
					dataType: 'json',
					success: function (response) {
						quit_page = true;
						navigation.pageTransition(response.redirect);
					},
				})
			});

			// Actions dropdowns (lazy init)
			if ($("table.datatable").length === 0) {
				$(document).on("click", ".dropdown-toggle", function(e){
					$(e.target).parent().find(".dropdown-menu.invoice-actions").SLR_InvoiceActions();
					$(e.target).parent().find(".dropdown-menu.contact-actions").SLR_ContactActions();
				});
			}

			// Initialize Depot
			if ($('#depot-module').length) {
				$.slr.interface.depot = $('#depot-module').Depot();
			}

			// Initialize Rapport
			if ($('#rapports-module').length) {
				$.slr.interface.rapport = $('#rapports-module').Rapport();
			}

			// Initialize Fichier
			if ($('#ftp-module').length) {
				$.slr.interface.ftp = $('#ftp-module').FTP_Module();
			}

			// Initialize Delegate Account
			if ($('#delegate-module').length) {
				$('#delegate-module').DelegateAccount();
			}

			$('[data-toggle="tooltip"]').tooltip()
		},

		/*
		*	Initialize
		*/
		init : function()
		{
			/* History API pop state */
			$(window).on("popstate", function(e){
				var history_data = e.originalEvent.state;
				if (history_data != null){
					if (history_data.is_page_transition != null && history_data.is_page_transition == true){
						navigation.isPopping = true;
						navigation.pageTransition(e.target.location.href);
					}
				}
			});

			/* History API initial state */
			var initial_state = {
				is_page_transition: true,
				previous_page_url: window.location.href
			};
			window.history.replaceState(initial_state, document.title, window.location.href);

			/* History API transition links */
			$(document).on("click", "a", function(e){
				if (e.originalEvent.cmdKey || e.originalEvent.metaKey){ return true; }
				if ($(this).hasClass("no-transition")){ return true; }
				if ($(this).hasClass("action")){ return true; }
				if ($(this).attr("href")){
					if ($(this).attr("href").substr(0,6) === "mailto"){ return true; }
					if ($(this).attr("href").substr(0,4) === "http"){ return true; }
				}
				if ($(this).attr("target") === "_blank"){ return true; }
				if ($(this).attr("href") === "#"){ return false; }
				if ($(this).attr("href") === "javascript:;"){ return; }
				if ($(this).attr("role") === "option"){ return; }
				navigation.pageTransition($(this).attr("href"));
				return false;
			});

			/* Stack interface */
			$.slr.interface.stack = $("#stack").Stack();

			/* Calculator in top bar */
			$.slr.interface.calc = $('.cat__top-bar').find(".slr-calc").Calculator();
			$.slr.interface.calc.on('click', function(){
				$(this).closest('.dropdown').addClass('show');
				return false;
			});

			/* First page load */
			navigation.pageLoad();
		}
	};

	/*
	*	Launch site navigation
	*/
	$.slr.db = new DB();
	$.slr.site = navigation;
	$.slr.site.init();

	/*
	*	Notification
	*/
	$.slr.notify = function(options, settings)
	{
		settings = merge({
			delay: 2000,
			newest_on_top: true,
			placement: {
				from: 'bottom',
				align: 'right'
			},
			animate: {
				enter: 'animated fadeInUp',
				exit: 'animated fadeOutUp'
			}
		}, settings);
		$.notify(options, settings);
	};

	$.slr.warning = function()
	{
		swal({
			title: "Une erreur s'est produite",
			text: "Une opération précédente de la queue d'opération a mené à une erreur. Il est recommandé de recharger l'application.",
			type: "warning",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-danger",
			confirmButtonText: 'Recharger',
			closeOnConfirm: false
		},
		function(){
			location.reload();
		});
	};

	/*
	*	Transaction reaction
	*/
	$.slr.react = function(_transaction, x)
	{
		// do next action
		var default_action = true,
		permanent_error = true,
		quit_page = false,
		actions = x.action ? x.action.split("|") : [];
		actions.forEach(function(action){
			var action_parts = action.split(".");
			switch (action_parts[0]) {
				case "form":
				switch (action_parts[1]) {
					case "unlock":
					default_action = false;
					$.slr.db.ended();
					$.slr.interface.form.unlock();
					permanent_error = false;
					break;
					default:
					break;
				}
				break;
				case "slr":
				switch (action_parts[1]) {
					case "redirect":
					quit_page = true;
					navigation.pageTransition(action_parts[2]);
					break;
					case "reload":
					location.reload();
					break;
					default:
					break;
				}
				case "swal":
				switch (action_parts[1]){
					case "close":
					swal.close();
					break;
					default:
					break;
				}
				case "contract":
				switch (action_parts[1]) {
					case "cancel":
					default_action = false;
					$.slr.db.ended();
					$.slr.interface.form.unlock();
					permanent_error = false;
					if (_transaction.callback != undefined) {
						_transaction.callback();
					}
					break;
					default:
					break;
				}
				case "depot": {
					switch (action_parts[1]) {
						case "paid":
						$.slr.interface.depot.details.updated(action_parts[2].split(','), action_parts[3]);
						break;
						case "withdrawn":
						location.reload()
						break;
						case "cancel":
						default_action = false;
						$.slr.db.ended();
						permanent_error = false;
						if (_transaction.callback != undefined) {
							_transaction.callback();
						}
						default:
						break;
					}
				}
				default:
				break;
			}
		});

		// success or failure message
		if (x.success){
			_transaction.interface.stack_item.success();
			if (x.notify != undefined){
				$.slr.notify({
					icon: 'fa fa-check',
					title: x.notify.title,
					message: x.notify.message
				}, { type: 'success' });
			}
			$.slr.db.next();
		} else {
			_transaction.interface.stack_item.error(permanent_error);
			$.slr.notify({
				icon: 'fa fa-exclamation-circle',
				title: x.notify.title,
				message: x.notify.message
			}, {
				type: 'danger',
				delay: permanent_error ? -1 : 5000
			});
			if (default_action){
				$.slr.db.ended();
				$.slr.db.status.has_error = true;
				$.slr.interface.form.lock();
			}
		}

		// attachment fields returns
		if (!quit_page){
			if (x.attachments != undefined){
				for (var field in x.attachments){
					$.slr.interface.form.set_attachment_value(field, x.attachments[field])
				}
			}
		}
	}

	/* Details card */
	$('.details-card').each(function() {
		var detailsButton = $(this).find('.details-button');
		var detailsBlock = $(this).find('.details-list').closest('.card-block');
		detailsBlock.hide();
		detailsButton.on('click', function() {
			detailsBlock.slideToggle(0);
		});
	});

	/* Reference details list */
	$('.ref-invoice-list').each(function() {
		var detailsButton = $(this).find('h6');
		var detailsList = $(this).find('ul');
		detailsList.hide();
		detailsButton.on('click', function() {
			detailsList.slideToggle(0);
		});
	});

	// open in window rather than tab
	$('.file-holder a').on('click', function() {
		window.open($(this).attr('href'), '_blank', `width=${screen.width * 3/5},height=${screen.height},scrollbars=yes,toolbar=no,location=no`);
		return false
	})

	/* Helper: merge objects */
	function merge(object_1, object_2)
	{
		var merged = {};
		for (var attr in object_1) { merged[attr] = object_1[attr]; }
		for (var attr in object_2) { merged[attr] = object_2[attr]; }
		return merged;
	}
});
